import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, getManager, Not, IsNull, Any, FindOneOptions, Between, In, QueryRunner } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { CarrierType, CountRangesEnum, ErrorResponse, FgStatusEnum, GlobalStatus, GlobalVariableValues, HarvestTypes, Indentstatusenum, OperationTypeEnum, ProductionTypeEnum, SupplierTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { GrnRequest } from './dto/raw-material-grn.request';
import { Grn } from './raw-material-grn.entity';
import { GrnDTO } from './dto/raw-material-grn.dto';
import { GrnAdapter } from './dto/raw-material-grn.adapter';
import { GrnResponseModel } from 'libs/shared-models/raw-material-procurement/src/lib/raw-material-grn/raw-material-response-model';
import { AllGrnResponseModel } from 'libs/shared-models/raw-material-procurement/src/lib/raw-material-grn/all-raw-material-grn-response-model';
import { BomIdRequest, saleOrder, SaleOrderItemsRequest, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { SaleOrderDropDownDto, SaleOrderDropDownResponseModel, SoProductionDTO } from '@gtpl/shared-models/sale-management';
import { HLpercentagesService, HrmsEmpDetService, SuppliersService, UnitcodeService, VehicleService,RmBudgetServices } from '@gtpl/shared-services/masters';
import { CommonResponse, CompanyTypeEnum, FarmerModel, FarmerRequest, HlPercentageRangeRequest, InvoiceStatusEnum, MasterInfoFromIndentRequest, MasterInfoFromIndentResponse, PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { CompanyCategoryEnum, CreateInvoiceForVoucher, GrnData, GrnDetails, GrnDetailsForView, GrnIdReq, GrnItemInfoForPriceApproval, GrnItemsDataModelForView, GrnStatusUpdate, GrnVehicleInfo, indentIdReq, InvoiceNumReq, InvoiceStatusReq, InwardFilterReq, LotCodesDTO, LotCodesResponseModel, PayablesDashboardReq, ReWeighMentDefectsModel, ReWeighmentInfo, ReweighmentInfoModel, ReWeighMentModelDto, ReWeighMentResponseModel, ReWeighMentViewResponseModel, RmBudgetInfoReq, RmCountReq, RmGrnResponseModel, RMInvoicePrintReq, RmInvoiceReq, RmInvoiceUpdateReq, RmRatesInfoReq, rmReweighmentreq, RMVehicleInfoResponse, TdsApplicableReq, VoucherReq, VoucherVendorReq } from '@gtpl/shared-models/raw-material-procurement';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { LotCodesRequest } from './dto/lot-codes.request';
import { AverageRateRmReport, GrnInfoReq, GrnInformationDto, LotCodeData, LotCodeOpsData, LotNoReq, ProdData, ProdInvData, ProductionLogDto, RmInvoiceReportReq, YieldPerReq } from '@gtpl/shared-models/production-management';
import { LotCodeOpsService, ProdInvService, ProductionInventoryService, ProdlogService } from '@gtpl/shared-services/production';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { GrnRepository } from './grn-repository';
import { GrnItemRepository } from './grn-item-repository';
import { ReceivedBoxes } from './dto/received-boxes.request';
import { VehicleAssignmentService } from '@gtpl/shared-services/transportation';
import { RmGrnDetailsDto } from './dto/rm-grn-details.dto';
import appSettings from 'apps/services/config';
import { GrnItems } from './raw-material-grn-items.entity';
import { isNotEmpty } from 'class-validator';
import { RmGrnPlantRequest } from './dto/rm-grn-plants-request';
import { RMGrnItemIdReq } from './dto/grn-item-id.request';
import { LotNumberRequest } from './dto/lot-number.request';
import { GrnAbstractRequest } from './dto/grn-abstract.request';
import { RmActualCountDto } from './dto/rm-actual-count.dto';
import moment from 'moment';
import {ReweighmentReq} from '@gtpl/shared-models/raw-material-procurement'

import { ApiProperty } from '@nestjs/swagger';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import {PriceAccpetanceModel} from '@gtpl/shared-models/raw-material-procurement'
import { RMReWeighingEntity } from '../indent/rm-re-weighing/rm-re-weighing.entity';
import { GrnItemDefects } from './grn-item-defects.entity';
import { isNull } from 'util';
import { GrnInvoiceNumberRequest, GrnItemIdRequest } from '@gtpl/shared-models/procurement-management';
import { RmInvoice } from './raw-materail-grn-invoice.entity';
import { Indent } from '../indent/indent.entity';
import {EnquiriesService} from '@gtpl/shared-services/enquiry-management'
import { AntibioticsReq } from './antibiotics-microbiology-report/rm-antibiotics-req';
import {RmCountPriceListService} from '@gtpl/shared-services/raw-material-procurement'
import { range } from 'rxjs';
import { IndentIdRequest } from '../indent/dto/indent-id.request';
import dayjs from 'dayjs';
import { IndentItems } from '../indent/indent-items.entity';
import { PaybleComponentReq } from '@gtpl/shared-models/analytics-data';

const mastersSuppluierTable = appSettings.masters_db + '.suppliers';
const mastersFarmsTable = appSettings.masters_db + '.farms';
const mastersProductsTable = appSettings.masters_db + '.products';
const mastersEmployeeTable = appSettings.masters_db + '.employee_details';
const rmGrnTable = appSettings.rm_procure_db + '.grn';
const rmGrnItemsTable = appSettings.rm_procure_db + '.grn_items';
const rmIndentTable = appSettings.rm_procure_db + '.indent';
const rmVIInspection = appSettings.rm_procure_db + '.rm_vehicle_inspection';
const rmIndentItemsTable = appSettings.rm_procure_db + '.indent_items';
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const rmVehicleAssignment = appSettings.transport_db + '.vehicle_assignment';
const harvesting = appSettings.rm_procure_db + '.harvest_report';
const antibiotics = appSettings.rm_procure_db + '.rm_antibiotics_info';


@Injectable()
export class RawMaterialGrnService {
  constructor(
    @InjectRepository(Grn)
    private grnRepository: Repository<Grn>,
    @InjectRepository(GrnItems)
    private grnItemRepository: Repository<GrnItems>,
    private grnAdapter: GrnAdapter,
    private saleOrderService: SaleOrderService,
    private hlPerService: HLpercentagesService,
    private supplierService: SuppliersService,
    private indentService: IndentService,
    private unitcodeService: UnitcodeService,
    private prodInvService: ProductionInventoryService,
    private lotCodeOpsService: LotCodeOpsService,
    private prodLogService: ProdlogService,
    private vehicleAssignmentService: VehicleAssignmentService,
    private vehicleService: VehicleService,
    private harvestreportService: IndentService,
    private unitCodesService: UnitcodeService,
    private logService:LogsService,
    @InjectRepository(RMReWeighingEntity)
    private reweighmentRepo : Repository<RMReWeighingEntity>,
    
    private employeeService: HrmsEmpDetService,
    private vehicleervice: VehicleService,
    private enquiryService : EnquiriesService,
    private rmCountPriceListService : RmCountPriceListService,
    private rmBudgetService : RmBudgetServices,


  ) { }


  async getGrnDetailsWithoutRelations(remarks) {
    // tslint:disable-next-line: typedef
    const grnResponse = await this.grnItemRepository.findOne({
      where: { remarks: remarks },
    });
    if (grnResponse) {
      return grnResponse;
    } else {
      return null;
    }
  }



  async createGrn(grnDto: RmGrnDetailsDto, isUpdate: boolean): Promise<RmGrnResponseModel> {
    // console.log("grnDto req");
    // console.log(grnDto);

    const manager = new GenericTransactionManager();
    const queryManger = getManager()

    try {
      let toDate = 0;
      let refNo;
      let grnRefNo;
      let grnItemRefNo;
      let totalGrnItems;


      if (!isUpdate) {
        const unitcodeReq = new PlantIdRequest(grnDto.plantId)
        const getCompanyInfo = await this.unitCodesService.getPlantDetailsById(unitcodeReq)
        let unitCode;

        if (grnDto) {
          if (grnDto.plantId === 1) {
            unitCode = 'U1'
          }
          if (grnDto.plantId === 2) {
            unitCode = 'U2'
          }
          if (grnDto.plantId === 3) {
            unitCode = 'KKD'
          }

        }
        let today = new Date();
        let CurrentYear = today.getFullYear();
        let CurrentMonth = today.getMonth();
        let fromDate = 0;
        let totalGrn = await this.grnRepository.count();
        let grnYear = new Date(grnDto.grnDate).getFullYear()
        let grnMonth = new Date(grnDto.grnDate).getMonth() + 1
        // let grnDay = new Date(grnDto.grnDate).getDate()
        // const startDate = new Date(grnYear, 0, 1); // January 1st of the year
        // const endDate = new Date(grnYear, 11, 31);
        // let count = await this.grnRepository.count({where:{grnDate:Between(startDate,endDate)}})
        // if(count == 0){
        //   refNumber = 1
        // }
        // let getGrnQuery
        // if(grnMonth >= 4){
        //   getGrnQuery= `SELECT MAX(ref_no) as refNumber FROM ${appSettings.rm_procure_db} .grn g left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = g.plant_id where u.company = '${getCompanyInfo.data.company}' and year(grn_date) = ${grnYear} and month(grn_date) >= 4 `
         
        // }else{
        //   getGrnQuery = `SELECT MAX(ref_no) as refNumber FROM ${appSettings.rm_procure_db} .grn g left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = g.plant_id where u.company = '${getCompanyInfo.data.company}' and year(grn_date) = ${grnYear} and month(grn_date) < 4`
        // }
        // const refinfo = await queryManger.query(getGrnQuery)
        // if(refinfo.length > 0){
        //   refNo = refinfo[0].refNumber + 1
        // }else{
        //   refNo = 1
        // }

        // totalGrnItems = await this.grnItemRepository.count();
        if (!isUpdate) {
          if (CurrentMonth < 4) {
            fromDate = (CurrentYear);
            toDate = (CurrentYear);
          } else {
            fromDate = (CurrentYear);
            toDate = (CurrentYear + 1);
          }

        }

        

        const getMaxRefQuery = `SELECT MAX(ref) as maxRef FROM ${appSettings.rm_procure_db}.grn`;
const refResult = await queryManger.query(getMaxRefQuery);

let nextRef = 1;
if (refResult && refResult[0]?.maxRef) {
  nextRef = Number(refResult[0].maxRef) + 1;
}

// 🔹 assign ref
grnDto.ref = nextRef;

// 🔹 generate voucher number like V0001
grnDto.voucherNumber = "V" + nextRef.toString().padStart(4, '0');
        const batchCode = getCompanyInfo.data.company == CompanyTypeEnum.BMR_EXPORTS_AP ? 'E' : getCompanyInfo.data.company == CompanyTypeEnum.BMR_EXPORTS_ODISHA ? 'OR' : 'R'
        const currentFinancialYear = "G" + (toDate.toString().substr(-2)) + "/" + (grnDto.grnItemsInfo)[0].farmerCode + "/" + batchCode + "-" + nextRef.toString().padStart(4, '0');
        grnDto.grnNumber = currentFinancialYear;
        
        // grnDto.batchNumber = batchCode + '-' + refNo
        // grnDto.refNumber = refNo
        // const lotNo = "LOT" + "-" + (grnDto.plantId === 1 ? 'U1' : grnDto.plantId === 2 ? 'U2' : grnDto.plantId === 3 ? 'KKD' : '') + "/" + (toDate.toString().substr(-2)) + '/' + (today.getMonth() + 1) + "/" + refNo;
        // grnDto.lotNumber = lotNo;
      }
      // monthlyRefNo logic
      const month = moment().month()
      const year = moment().year()
      const getMaxId = `select max(ref_no) as ref from ${appSettings.rm_procure_db}.grn_items gi where YEAR(created_at) = ${year} and MONTH(gi.created_at) =  ${month + 1} `
      const result = await queryManger.query(getMaxId)
      console.log(result)

      const dummySOData = await this.saleOrderService.getDummySo();
      if(!(dummySOData.status)){
        throw new CommonResponse(false, 11104, 'Dummy SO not found to assign');
      }

      for (const [index, item] of grnDto.grnItemsInfo.entries()) {
        //assigning sale order to the grn based on its count

        // const getSoSoItem = `select rb.sale_order_id as saleOrderId,rb.sale_order_item_id as saleOrderItemId from ${appSettings.sales_db}.rm_bom_log rb 
        // left join ${appSettings.sales_db}.so_invoice_details sinv ON  sinv.sale_order_id = rb.sale_order_id
        // where rb.min_count<= ${item.count} AND rb.max_count >= ${item.count} AND  sinv.act_edl_date between DATE('${moment().format('YYYY-MM-DD')}') and DATE('${moment(nextMonth).format('YYYY-MM-DD')}') order by sinv.act_edl_date asc `
        // const data = await queryManger.query(getSoSoItem)
        // if(data.length){
        //   item.saleOrderId = data[0].saleOrderId
        //   item.saleOrderItemId = data[0].saleOrderItemId 
        // }
        if (!isUpdate) {
          const checkForDuplicate = await this.getGrnDetailsWithoutRelations(item.remarks)
          if (checkForDuplicate) {
            throw new CommonResponse(false, 11104, 'Plant LotNumber Already exists');

          }
        }

        if (result && result.length) {
          const maxref = Number(result[0].ref) + (index + 1)
          item.monthlyRefNo = maxref
          console.log(item.monthlyRefNo)
        } else {
          item.monthlyRefNo = ((index) + 1)
          console.log('else',item.monthlyRefNo)

        }
      }
      const convertedGrnEntity: Grn = this.grnAdapter.convertDtoToEntity(grnDto, isUpdate, toDate, refNo, totalGrnItems,dummySOData.data);
      convertedGrnEntity?.grnItemsInfo?.forEach(item => {
        item.assignToRm = true;
        item.reweighmentStatus = true;
      });
      manager.startTransaction()
      if (isUpdate) {

        // const soItemReq:SaleOrderItemsRequest={
        //   saleOrderItemId: grnDto.saleOrderItemId
        // }
        // const soItemDetails =await this.saleOrderService.getSaleOrderItemDetailsBySoItemId(soItemReq)
        // const hlPercentagedata: any = await this.hlPerService.getHlPercentageByRange(
        //   new HlPercentageRangeRequest(
        //     soItemDetails.data.maxGrade,
        //   )
        // );
        // const trtmntPer = await soItemDetails.data.finalPercentage;

        // const opQty = await (grnDto.quantity)*(hlPercentagedata/100)*(trtmntPer/100)
        // console.log('------'+opQty)
        for (const item of grnDto.grnItemsInfo) {
          const soProductionDto = await new SoProductionDTO();
          if(!(item.saleOrderId > 0)){
            item.saleOrderId = dummySOData.data.saleOrderId
            item.saleOrderItemId = dummySOData.data.saleOrderItemId
          }
          soProductionDto.saleOrderId = item.saleOrderId;
          soProductionDto.saleOrderItemId = item.saleOrderItemId;
          soProductionDto.lotNumber = item.lotNumber;
          soProductionDto.inputQuantity = item.quantity;
          soProductionDto.type = ProductionTypeEnum.GRN;
          soProductionDto.outputQuantity = 0;
          soProductionDto.createdUser = item.createdUser;
          soProductionDto.updatedUser = item.updatedUser;
          // soProductionDto.versionFlag = item.versionFlag;
          const soProduction = await this.saleOrderService.createSoProduction(soProductionDto)


        }

        // const prodInvDto = await new ProdData();
        // //  prodInvDto.grnNumber = grnDto.grnNumber;
        //  prodInvDto.lotNumber = grnDto.lotNumber;
        //  prodInvDto.saleOrderId = grnDto.saleOrderId;
        //  prodInvDto.saleOrderItemId= grnDto.saleOrderItemId;
        //  prodInvDto.physicalQuantity = grnDto.quantity;
        //  prodInvDto.inputGrade = grnDto.count;
        //  prodInvDto.boxes = grnDto.boxes;
        //  prodInvDto.plantId = grnDto.plantId;
        //  prodInvDto.subPlantId = grnDto.subPlantId;
        //  prodInvDto.weighmentReq = GlobalStatus.NO;
        //  prodInvDto.operation = OperationTypeEnum.BE_HEADING;
        //  prodInvDto.nextOperation = OperationTypeEnum.GRADING;
        //  prodInvDto.status = FgStatusEnum.OPEN;
        //  prodInvDto.createdUser = grnDto.createdUser;

        //    const prodInv = await this.prodInvService.createProdInv(prodInvDto)


        // const lotCodeOpsDto = await new LotCodeOpsData();
        //   lotCodeOpsDto.grnDate = grnDto.grnDate;
        //   lotCodeOpsDto.indentId = grnDto.indentId;
        //   lotCodeOpsDto.grnNumber = grnDto.grnNumber;
        //   lotCodeOpsDto.lotNumber = grnDto.lotNumber;
        //   lotCodeOpsDto.saleOrderId = grnDto.saleOrderId;
        //   lotCodeOpsDto.saleOrderItemId = grnDto.saleOrderItemId;
        //   lotCodeOpsDto.supplierType = grnDto.supplierType;
        //   lotCodeOpsDto.farmer = grnDto.farmer;
        //   lotCodeOpsDto.farmerCode = grnDto.farmerCode;
        //   lotCodeOpsDto.count = grnDto.count;
        //   lotCodeOpsDto.price = grnDto.price;
        //   lotCodeOpsDto.boxes = grnDto.boxes;
        //   lotCodeOpsDto.plantId = grnDto.plantId;
        //   lotCodeOpsDto.subPlantId = grnDto.subPlantId;
        //   lotCodeOpsDto.createdAt = grnDto.createdAt;
        //   lotCodeOpsDto.createdUser = grnDto.createdUser;

        //    const lotCodeOps = await this.lotCodeOpsService.createLotCodeOps(lotCodeOpsDto)

      }

      const savedGrnEntity: Grn = await this.grnRepository.save(
        convertedGrnEntity
      );
      // const savedGrnDto: GrnDTO = this.grnAdapter.convertEntityToDto(convertedGrnEntity);
      // console.log(savedStateDto);

      if (savedGrnEntity) {
        // generating resposnse

        const response = new RmGrnResponseModel(true, 1, isUpdate ? 'Grn Updated Successfully' : 'Grn Created Successfully');

        const grnStatus: GrnStatusUpdate = {
          indentId: grnDto.indentId,
          grnCompleted: true,
        }
        // update sale tracker status
        const grnStatusUpdate = await this.indentService.updateGrnCompletedStatus(grnStatus);

        if (grnDto.harvestType == HarvestTypes.Re_Weighment) {
          for (const items of savedGrnEntity.grnItemsInfo) {
            console.log(savedGrnEntity, items)
            if (items.saleOrderId) {
              const grnInfo: any = {};
              grnInfo.receivedBoxes = items.receivedBoxes
              grnInfo.grnDate = savedGrnEntity.grnDate;
              grnInfo.indentId = savedGrnEntity.indentId;
              grnInfo.grnNumber = grnDto.grnNumber;
              grnInfo.saleOrderId = items.saleOrderId;
              grnInfo.saleOrderItemId = items.saleOrderItemId;
              grnInfo.supplierType = grnDto.supplierType;
              grnInfo.farmer = items.farmer;
              grnInfo.farmerCode = items.farmerCode;
              grnInfo.count = items.count;
              grnInfo.quantity = items.quantity;
              grnInfo.price = items.price;
              grnInfo.boxes = items.receivedBoxes;
              grnInfo.plantId = savedGrnEntity.plantId;
              grnInfo.remarks = items.remarks
              grnInfo.refNo = items.monthlyRefNo
              grnInfo.subPlantId = savedGrnEntity.subPlantId;
              grnInfo.createdUser = items.createdUser;
              grnInfo.grnItemId = items.grnItemId
              // await this.assignToRM(grnInfo, false)
            }
          }
        }

        if (grnStatusUpdate.status) {
          manager.completeTransaction()
          return response
        } else {
          manager.releaseTransaction()
          return new RmGrnResponseModel(false, 0, 'something went wrong', undefined)
        }
      } else {
        manager.releaseTransaction()
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'Grn saved but issue while transforming into DTO');
      }
    } catch (error) {
      manager.releaseTransaction()
      console.log(error)
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef

      return error;
    }
  }



  async getAllGrnData(req?: UnitRequest): Promise<CommonResponse> {
    // console.log(req,"reqqqqqqqqqqqqq service")
    const manager = getManager();
    const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId;
    const result = await manager.query(query);

    let grnQuery = `SELECT i.indent_by as employeeId,i.rm_inward_type as rmInwardType,g.voucher_number as voucherNumber,e.employee_name as indentPerson,i.grn_completed as grnCompleted,g.grn_id as grnId,g.grn_date as grnDate,g.grn_number as grnNumber,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.assign_lead_2 as assignLead12,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,i.indent_code as indentNumber,g.plant_id as plantId,g.sub_plant_id as subPlantId,uc.unit_code_id AS unitId ,uc.unit_name as unit, gi.assign_to_rm as assignToRm,indent_by as indentBy,s.code as supplier,s.code as farmerCode,e.employee_name as indentPerson,gi.main_batch_num AS mainBatchNo,gi.year,g.reweighment_date as reweighmentDate FROM ` + rmGrnTable + ` g
    LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no AND i.is_active = 1
    LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii on ii.indent_id = g.indent_no
    LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=g.plant_id 
    LEFT JOIN `+ appSettings.rm_procure_db + `.grn_items gi ON gi.grn_id=g.grn_id 
    LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = ii.farmer
    LEFT JOIN `+ appSettings.masters_db + `.suppliers bs ON bs.supplier_id = ii.broker
    LEFT JOIN `+ appSettings.masters_db + `.employee_details e on e.employee_id = i.indent_by where g.grn_id >0 `
    if (result[0]?.plant_type == UnitTypeEnum.SUB_PLANT) {
      grnQuery += " AND g.sub_plant_id=" + req.unitId;
    }
    if (result[0]?.plant_type == UnitTypeEnum.PLANT) {
      grnQuery += " AND g.plant_id=" + req.unitId + ' and g.sub_plant_id = 0';
    }
    if(req.plantLotNumber){
      grnQuery += ` and gi.plant_lot_number = '${req.plantLotNumber}'`
    }
    grnQuery = grnQuery + ` GROUP BY g.grn_id ORDER By g.grn_date DESC , g.grn_id DESC`;
    const grnData = await manager.query(grnQuery);
    if (grnData) {
      const groupedData = grnData.reduce((acc, current) => {
        const grnId = current.grnId;
        if (!acc[grnId]) {
          acc[grnId] = new GrnDetailsForView(
            current.grnDate,
            current.indentId, 
            current.supplierType,
            current.createdUser,
            current.plantId,
            current.grnNumber,
            current.subPlantId,
            current.grnId,
            current.updatedUser,
            current.subPlantName,
            current.indentNumber,
            current.unit,
            current.supplier,
            current.harvestType,
            current.indentPerson,
            current.assignToRm,
            [] ,
            current.reweighmentDate,
            current.voucherNumber,
            current.rmInwardType
    
          );
        }
    
        acc[grnId].grnItemsInfo.push(
          new GrnItemsDataModelForView(
            current.farmer,
            current.farmerCode,
            current.quantity,
            current.count,
            current.price,
            current.createdUser,
            current.farmCode,
            current.farmId,
            current.farmerName,
            current.grnId,
            current.grnItemId,
            current.indentId,
            current.plantLotNumber,
            current.saleOrderId,
            current.saleOrderItemId,
            current.softPercentage,
            current.boxes ,current.mainBatchNo,
            current.year

          )
        );
    
        return acc;
      }, {} as { [key: number]: GrnDetailsForView });
    
      const result = (Object.values(groupedData) as GrnDetailsForView[])
  .sort((a, b) => b.grnId - a.grnId);
    
      return new CommonResponse(true, 1, "GRN Details Retrieved Successfully", result);
    } else {
      throw new ErrorResponse(9999, 'Failed to Get GRN Details');
    }
  }


  async getTraceabilityCodeForLot(req: LotNumberRequest) {
    const manager = getManager();
    const query = `SELECT  gi.farmer as supplierId, gi.lot_number as lotNumber, CASE WHEN gi.broker > 0 THEN CONCAT_WS(", ", msb.street, msb.apartment, msb.city, msb.state, msb.district, msb.postal_code) ELSE CONCAT_WS(", ",ms.street, ms.apartment, ms.city, ms.state, ms.district, ms.postal_code) END AS supplierAddress, farm.name as supplierCode, CASE WHEN gi.broker > 0 THEN msb.name
    ELSE ms.name END AS supplierName  FROM `+ rmGrnItemsTable + ` gi
    LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
    LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
    LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
    where  gi.lot_number='`+ req.lotNumber + `'`;
    const grnData = await manager.query(query);
    if (grnData?.length) {
      const data = grnData.find((val) => val.lotNumber == req.lotNumber)
      return new CommonResponse(true, 5, 'GRN data retreived', data)
    } else {
      return new CommonResponse(false, 5, 'Not Found')
    }
  }

  // async getAllGrn(): Promise<AllGrnResponseModel> {
  //   // const page: number = 1;
  //   try {
  //     const GrnDtos: GrnData[] = [];
  //     //retrieves all companies
  //     const GrnEntities: Grn[] = await this.grnRepository.find({ order: { 'grnDate': 'DESC' } });
  //     //console.log(statesEntities);
  //     if (GrnEntities.length === 0) {
  //       throw new ErrorResponse(10000, 'No Records Found');
  //     }
  //     for (const grn of GrnEntities) {
  //       const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(grn.farmer, grn.farmerCode, 1, 1, 1));
  //       const farmer = await this.supplierService.getSupplierBySupplierId({ farmerId: grn.farmer })
  //       const farmerCode = await this.supplierService.getFarmerDetailsByFarmerId({ farmerId: grn.farmerCode })

  //       const indentNumber = await this.indentService.getIndentDetailsById({ indentId: grn.indentId })
  //       console.log('indentNumber' + indentNumber)
  //       const indentCode = indentNumber.status ? indentNumber.data.indentCode : "";
  //       GrnDtos.push(new GrnData(grn.grnDate, grn.indentId, grn.supplierType, grn.farmer, grn.farmerCode, grn.quantity, grn.count, grn.price, grn.createdUser, grn.isActive, grn.grnNumber, grn.grnId, grn.lotNumber, grn.saleOrderId, grn.saleOrderItemId, farmer.status?farmer.data.supplierName:"", indentCode, farmer.status?farmer.data.supplierCode:"", grn.boxes, grn.plantId, grn.subPlantId, grn.updatedUser, grn.assignToRm, grn.softPercentage, grn.receivedBoxes, '', grn.isVInspectionCompleted, grn.isRmInspectionCompleted))
  //     }

  //     return new AllGrnResponseModel(true, 1, 'Grn retrieved successfully', GrnDtos);
  //     // if (GrnEntities) {
  //     //   // converts the data fetched from the database which of type companies array to type StateDto array.
  //     //   GrnEntities.forEach(GrnEntity => {
  //     //     const convertedGrnDto: GrnDTO = this.grnAdapter.convertEntityToDto(
  //     //       GrnEntity
  //     //     );
  //     //     GrnDtos.push(convertedGrnDto);
  //     //   });
  //     //   const response = new AllGrnResponseModel(true,1,'Grn retrieved successfully',GrnDtos);
  //     //   return response;
  //     // } else {
  //     //   throw new ErrorResponse(99998, 'Data not found');
  //     // }

  //   } catch (err) {
  //     return err;
  //   }
  // }
  async getAllActiveGrn(): Promise<AllGrnResponseModel> {
    // const page: number = 1;
    try {
      const GrnDtos: GrnDTO[] = [];
      //retrieves all companies
      const GrnEntities: Grn[] = await this.grnRepository.find({
        order: { 'grnNumber': 'ASC' }, where: { isActive: true },
      });
      console.log(GrnEntities)
      if (GrnEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        GrnEntities.forEach(countriesEntity => {
          const convertedGrnDtos: GrnDTO = this.grnAdapter.convertEntityToDto(
            countriesEntity
          );
          GrnDtos.push(convertedGrnDtos);
        });
        const response = new AllGrnResponseModel(true, 11108, "Grn retrieved successfully", GrnDtos);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  // async updateReceivedBoxes(receivedBoxes: ReceivedBoxes): Promise<GrnResponseModel> {
  //   try {
  //     const updateReceivedBoxes = await this.grnRepository.update(
  //       { grnId: receivedBoxes.grnId },
  //       { receivedBoxes: receivedBoxes.receivedBoxes });
  //     if (updateReceivedBoxes.affected) {
  //       const grnResponse: GrnResponseModel = new GrnResponseModel(true, 10115, 'Grn received boxes updated successfully');
  //       return grnResponse;
  //     } else {
  //       const grnResponse: GrnResponseModel = new GrnResponseModel(false, 10110, 'something went wrong, failed to update.');
  //       return grnResponse;
  //     }
  //   }
  //   catch (err) {
  //     return err;
  //   }
  // }
  async activateOrDeactivateGrn(grnReq: GrnRequest): Promise<GrnResponseModel> {
    try {
      const grnExists = await this.getGrnById(grnReq.grnId);
      if (grnExists) {
        if (grnReq.versionFlag !== grnExists.versionFlag) {
          throw new ErrorResponse(10113, 'Someone updated the current grn information.Refresh and try again');
        } else {

          const grnStatus = await this.grnRepository.update(
            { grnId: grnReq.grnId },
            { isActive: grnReq.isActive, updatedUser: grnReq.updatedUser });

          if (grnExists.isActive) {
            if (grnStatus.affected) {
              const grnResponse: GrnResponseModel = new GrnResponseModel(true, 10115, 'Grn is de-activated successfully');
              return grnResponse;
            } else {
              throw new ErrorResponse(10111, 'Grn is already deactivated');
            }
          } else {
            if (grnStatus.affected) {
              const GrnResponse: GrnResponseModel = new GrnResponseModel(true, 10114, 'Grn is activated successfully');
              return GrnResponse;
            } else {
              throw new ErrorResponse(10112, 'Grn is already  activated');
            }
          }
          // }
        }
      } else {
        throw new ErrorResponse(99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }
  // async getActiveGrnById(grnReq: GrnRequest): Promise<GrnResponseModel> {
  //   try {
  //     //retrieves all companies
  //     const grnEntities: Grn = await this.grnRepository.findOne({
  //       where: { grnId: grnReq.grnId }
  //     });

  //     if (!grnEntities) {
  //       throw new ErrorResponse(10000, 'No Records Found');
  //     }
  //     const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(grnEntities.farmer, grnEntities.farmerCode, 1, 1, 1));
  //     const farmer = await this.supplierService.getSupplierBySupplierId({ farmerId: grnEntities.farmer })
  //     const farmerCode = await this.supplierService.getFarmerDetailsByFarmerId({ farmerId: grnEntities.farmerCode })

  //     const indentNumber = await this.indentService.getIndentDetailsById({ indentId: grnEntities.indentId })
  //     const subPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: grnEntities.subPlantId });
  //     const grnObj = new GrnData(grnEntities.grnDate, grnEntities.indentId, grnEntities.supplierType, grnEntities.farmer, grnEntities.farmerCode, grnEntities.quantity, grnEntities.count, grnEntities.price, grnEntities.createdUser, grnEntities.isActive, grnEntities.grnNumber, grnEntities.grnId, grnEntities.lotNumber, grnEntities.saleOrderId, grnEntities.saleOrderItemId, masterResponse.data.farmerName, indentNumber.data.indentCode, masterResponse.data.farmerCode, grnEntities.boxes, grnEntities.plantId, grnEntities.subPlantId, grnEntities.updatedUser, grnEntities.assignToRm, grnEntities.softPercentage, grnEntities.receivedBoxes, subPlantDetails.status ? subPlantDetails.data.unitcodeName : "")

  //     return new GrnResponseModel(true, 1, 'Grn retrieved successfully', grnObj);
  //     // generating resposnse
  //   } catch (err) {
  //     return err;
  //   }
  // }

  async getGrnById(grnId: number): Promise<Grn> {
    //  console.log(employeeId);
    const Response = await this.grnRepository.findOne({
      where: { grnId: grnId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getSaleOrdersHavingLotCodes(plantId: number): Promise<SaleOrderDropDownResponseModel> {
    try {
      const manager = getManager();
      const query = `SELECT rm.sale_order_id as saleOrderId FROM ` + appSettings.rm_procure_db + `.grn_items rm Left Join grn g on g.grn_id=rm.grn_id where g.plant_id=` + plantId;
      const lotCodes: any[] = await manager.query(query);
      console.log(lotCodes);
      const response: SaleOrderDropDownDto[] = []
      for (const item of lotCodes) {
        const SoDetails = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: item.saleOrderId });
        if (SoDetails != undefined) {
          const data = new SaleOrderDropDownDto(SoDetails.saleOrderId, SoDetails.saleOrderNumber, SoDetails.poNumber);
          response.push(data);
        }
      }
      if (response.length > 0) {
        return new SaleOrderDropDownResponseModel(true, 1001, "Sale Orders Retrived Successfully", response);
      }
      else {
        return new SaleOrderDropDownResponseModel(false, 1010, "No data found. ", response);
      }
    } catch (err) {
      return err;
    }
  }
  async getLotCodesBySoIdAndSoItemId(req: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      const manager = getManager();
      const response: LotCodesDTO[] = []
      const query = `SELECT rm.lot_number as lotNumber,rm.sale_order_id as saleOrderId FROM ` + appSettings.rm_procure_db + `.grn_items rm 
      where rm.sale_order_id=`+ req.saleOrderId + ` and rm.sale_order_item_id=` + req.saleOrderItemId;

      const lotCodes = await manager.query(query);
      console.log(lotCodes);
      if (lotCodes.length > 0) {
        for (const item of lotCodes) {
          console.log(item);

          const poNumber = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: item.saleOrderId });
          const data = new LotCodesDTO(item.lotNumber, poNumber.poNumber != undefined ? poNumber.poNumber : "");
          response.push(data);
        }
        return new LotCodesResponseModel(true, 11101, 'lot codes retrieved Successfully', response);
      }
      else {
        return new LotCodesResponseModel(false, 99998, 'Data not found', response);
      }
    } catch (err) {
      return err;
    }
  }

  async getLotCodesBySoIdAndSoItemIdOld(lotCodesRequest: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      //retrieves all companies
      const lotCodes: LotCodesDTO[] = [];
      const grnEntities: GrnItems[] = await this.grnItemRepository.find({
        where: { saleOrderId: lotCodesRequest.saleOrderId, saleOrderItemId: lotCodesRequest.saleOrderItemId, grnInfo: Raw((alias) => `plant_id = '${lotCodesRequest.plantId}'`) }
      });

      if (grnEntities.length > 0) {
        grnEntities.forEach(grnEntity => {
          const grnData = new LotCodesDTO(grnEntity.lotNumber, "");
          lotCodes.push(grnData);
        });
        const response = new LotCodesResponseModel(true, 11101, 'Grn retrived Successfully', lotCodes);
        return response;
      }

      else {
        throw new ErrorResponse(99998, 'Data not found');
      }
      // generating resposnse
    } catch (err) {
      return err;
    }
  }

  async assignToRMTest(grnDto: GrnDTO, isUpdate: boolean): Promise<GrnResponseModel> {
    try {
      const prodInvDto = await new ProdData();
      //  prodInvDto.grnNumber = grnDto.grnNumber;
      prodInvDto.lotNumber = grnDto.lotNumber;
      prodInvDto.saleOrderId = grnDto.saleOrderId;
      prodInvDto.saleOrderItemId = grnDto.saleOrderItemId;
      prodInvDto.physicalQuantity = grnDto.quantity;
      prodInvDto.inputGrade = grnDto.count;
      prodInvDto.boxes = grnDto.boxes;
      prodInvDto.plantId = grnDto.plantId;
      prodInvDto.subPlantId = grnDto.subPlantId;
      prodInvDto.weighmentReq = GlobalStatus.NO;
      prodInvDto.operation = OperationTypeEnum.GRN;
      prodInvDto.nextOperation = OperationTypeEnum.BE_HEADING;
      prodInvDto.status = FgStatusEnum.OPEN;
      prodInvDto.createdUser = grnDto.createdUser;

      const prodInv = await this.prodInvService.createProdInv(prodInvDto);
      if (prodInv.status) {
        // generating resposnse
        const lotCodeOpsDto = await new LotCodeData();
        lotCodeOpsDto.grnDate = grnDto.grnDate;
        lotCodeOpsDto.indentId = grnDto.indentId;
        lotCodeOpsDto.grnNumber = grnDto.grnNumber;
        lotCodeOpsDto.lotNumber = grnDto.lotNumber;
        lotCodeOpsDto.saleOrderId = grnDto.saleOrderId;
        lotCodeOpsDto.saleOrderItemId = grnDto.saleOrderItemId;
        lotCodeOpsDto.supplierType = grnDto.supplierType;
        lotCodeOpsDto.farmer = grnDto.farmer;
        lotCodeOpsDto.farmerCode = grnDto.farmerCode;
        lotCodeOpsDto.count = grnDto.count;
        lotCodeOpsDto.quantity = grnDto.quantity;
        lotCodeOpsDto.price = grnDto.price;
        lotCodeOpsDto.boxes = grnDto.boxes;
        lotCodeOpsDto.plantId = grnDto.plantId;
        lotCodeOpsDto.subPlantId = grnDto.subPlantId;
        lotCodeOpsDto.createdAt = grnDto.createdAt;
        lotCodeOpsDto.createdUser = grnDto.createdUser;

        const lotCodeOps = await this.lotCodeOpsService.createLotCodeOps(lotCodeOpsDto)


        const prodLogDto = await new ProductionLogDto();
        let today = new Date();
        let CurrentYear = today.getFullYear();
        let CurrentMonth = today.getMonth();
        let fromDate = 0;
        let toDate = 0;
        let totalRecords = await (await this.grnRepository.find({ where: { assignToRm: true } })).length;
        if (CurrentMonth < 4) {
          fromDate = (CurrentYear);
          toDate = (CurrentYear + 1);
        } else {
          fromDate = (CurrentYear);
          toDate = (CurrentYear + 1);
        }

        totalRecords = totalRecords + 1;

        var refNo = totalRecords + "";
        while (refNo.length < 4) refNo = "0" + refNo;

        const grnJobNo = "GRN/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
        prodLogDto.lotNumber = grnDto.lotNumber;
        prodLogDto.saleOrderId = grnDto.saleOrderId;
        prodLogDto.saleOrderItemId = grnDto.saleOrderItemId;
        prodLogDto.plantId = grnDto.plantId;
        prodLogDto.subPlantId = grnDto.subPlantId;
        prodLogDto.inputGrade = grnDto.count;
        prodLogDto.inputQuantity = grnDto.quantity;
        prodLogDto.inputBoxes = grnDto.boxes;
        prodLogDto.operationType = OperationTypeEnum.GRN;
        prodLogDto.createdUser = grnDto.createdUser;
        prodLogDto.jobNumber = grnJobNo;

        const prodLog = await this.prodLogService.createProdLog(prodLogDto);

        if (prodInv) {
          // const updateInv = await this.grnRepository.update(
          //   { grnId: Raw((alias) => `grn_id = '${grnDto.grnId}'`) },
          //   { assignToRm: true }
          // );

          const response = new GrnResponseModel(true, 1, 'RM Received Successfully');

          return response
        } else {
          throw new ErrorResponse(11106, 'RM Received but issue while transforming into DTO');
        }
      } else {
        throw new ErrorResponse(11106, 'Failed To Receive RM Please Try again after some time');
      }

    } catch (error) {
      return error;
    }
  }


  async assignToRM(grnDto: any, isUpdate: boolean): Promise<CommonResponse> {
    console.log(grnDto, 'ass rm')
    const manager = new GenericTransactionManager();
    try {

      await manager.startTransaction();
      const unitcodeReq = new PlantIdRequest(grnDto.plantId)
      const getCompanyInfo = await this.unitCodesService.getPlantDetailsById(unitcodeReq)
      let totalGrnItems = await this.grnItemRepository.count({ where: { lotNumber: isNotEmpty(null) } })
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0
      let toDate = 0

      if ((CurrentMonth + 1) < 4) {
        fromDate = (CurrentYear);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);

      }

      totalGrnItems = totalGrnItems + 1;
      // let grnItemRefNo = totalGrnItems + "";
      let grnItemRefNo = grnDto.refNo + "";
      let subPlantShortCode = ''
      let result
      if (grnDto.subPlantId > 0) {
        result = await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(grnDto.subPlantId))
        if (result.data.plantType == UnitTypeEnum.SUB_PLANT) {
          subPlantShortCode = "-" + result.data.shortKey
        }
      }
      while (grnItemRefNo.length < 4) grnItemRefNo = "0" + grnItemRefNo;
      console.log('itemssss');
      console.log(grnItemRefNo)
      const lotNo = "LOT" + "-" + (getCompanyInfo.data.company == CompanyTypeEnum.BMR_EXPORTS_AP ? 'E' : getCompanyInfo.data.company == CompanyTypeEnum.BMR_EXPORTS_ODISHA ? 'OR' : 'R') + "/" + (toDate.toString().substr(-2)) + '/' + (today.getMonth() + 1) + "/" + grnItemRefNo + subPlantShortCode;

      const updateInv = await manager.getCustomRepository(GrnItemRepository).update(
        { grnId: Raw((alias) => `grn_item_id = '${grnDto.grnItemId}'`) },
        { assignToRm: true, receivedBoxes: grnDto.receivedBoxes, lotNumber: lotNo }
      );
      let prodInv;
      if (updateInv.affected) {
        //  production record saving after reweighment
        // const grnInfo = await new GrnInformationDto();
        // grnInfo.grnDate = grnDto.grnDate;
        // grnInfo.indentId = grnDto.indentId;
        // grnInfo.grnNumber = grnDto.grnNumber;
        // grnInfo.lotNumber = lotNo;
        // grnInfo.saleOrderId = grnDto.saleOrderId;
        // grnInfo.saleOrderItemId = grnDto.saleOrderItemId;
        // grnInfo.supplierType = grnDto.supplierType;
        // grnInfo.farmer = grnDto.farmer;
        // grnInfo.farmerCode = grnDto.farmerCode;
        // grnInfo.count = grnDto.count;
        // grnInfo.quantity = grnDto.quantity;
        // grnInfo.price = grnDto.price;
        // grnInfo.boxes = grnDto.receivedBoxes;
        // grnInfo.plantId = grnDto.plantId;
        // grnInfo.remarks = grnDto.remarks
        // if (grnDto.subPlantId > 0) {
        //   grnInfo.subPlantId = grnDto.subPlantId;
        // } else {
        //   grnInfo.subPlantId = 0;
        // }
        // grnInfo.createdAt = grnDto.createdAt;
        // grnInfo.createdUser = grnDto.createdUser;
        // console.log(grnInfo);
        // console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
        // prodInv = await this.prodInvService.createGrnInventory(grnInfo);
        // console.log(prodInv);
        // if (prodInv.status) {
  //       const getVehicleInfo =await this.vehicleAssignmentService.getVehicleAssignDetailsByIndentId({indentId:grnDto.indentId})
  //       console.log(getVehicleInfo.data);
        
  //       if(getVehicleInfo.status){
  //         for(const req of getVehicleInfo.data[0]?.vechileInfo){
  //           const updateDriver = await this.employeeService.updateAvalibility({id:req?.driverId,isAvailable:true})
  //           const updateVehicle = await this.vehicleervice.updateVehicleAvalibility({vehicleNum:req?.vehicleNum,isAvailable:true})
  // console.log(updateVehicle,'oooooooooooooooo');
  
  //         }
  //       }
              
          await manager.completeTransaction();
          const response = new CommonResponse(true, 1, 'RM Received Successfully');
          return response;
        }else{
          await manager.releaseTransaction();
          throw new ErrorResponse(11106, 'Failed To Receive RM');
        }
        // } else {
        //   throw new ErrorResponse(11106, 'Failed To Update Inventory');
        // }

      // } else {
      //   throw new ErrorResponse(11106, 'Failed To Receive RM');
      // }
    } catch (error) {
      console.log(error)
      await manager.releaseTransaction();
      throw error;
    }
  }

  async getAllLotCodes(plant: PlantIdRequest): Promise<LotCodesResponseModel> {
    return new LotCodesResponseModel(false, 1010, "No data found. ",);
    // try {
    //   const response: LotCodesDTO[] = [];
    //   const getAllLotCodes = await this.grnRepository.createQueryBuilder("Grn").where("plant_id =" + plant.unitcodeId).groupBy("lot_number").getMany();
    //   for (const grn of getAllLotCodes) {
    //     const data = new LotCodesDTO(grn.lotNumber);
    //     response.push(data);
    //   }
    //   if (getAllLotCodes.length > 0) {
    //     return new LotCodesResponseModel(true, 1001, "Lot Codes Retrived successfully. ", response);
    //   }
    //   else {
    //     return new LotCodesResponseModel(false, 1010, "No data found. ",);
    //   }

    // } catch (error) {
    //   return error;
    // }
  }
  async getAllSaleOrders(plant: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
    return new SaleOrderDropDownResponseModel(false, 1010, "No data found. ",);
    // try {
    //   const response: SaleOrderDropDownDto[] = [];
    //   const getAllSaleOrders = await this.grnRepository.createQueryBuilder("Grn").where("plant_id =" + plant.unitcodeId).andWhere('sale_order_id IS NOT NULL').groupBy("sale_order_id").getMany();
    //   for (const grn of getAllSaleOrders) {
    //     const getSaleOrderNo = await this.saleOrderService.getSaleOrderInformation({ saleOrderId: grn.saleOrderId });
    //     const data = new SaleOrderDropDownDto(grn.saleOrderId, getSaleOrderNo.data.saleOrderNumber);
    //     response.push(data);
    //   }
    //   if (getAllSaleOrders.length > 0) {
    //     return new SaleOrderDropDownResponseModel(true, 1001, "SaleOrders Retrived successfully. ", response);
    //   }
    //   else {
    //     return new SaleOrderDropDownResponseModel(false, 1010, "No data found. ",);
    //   }

    // } catch (error) {
    //   return error;
    // }
  }


  async getRmVehicleGrnById(grnReq: GrnRequest): Promise<RMVehicleInfoResponse> {
    return new RMVehicleInfoResponse(true, 1, 'Grn retrieved successfully', undefined)
    // try {
    //   //retrieves all companies
    //   const grnEntities: Grn = await this.grnRepository.findOne({
    //     where: { grnId: grnReq.grnId }
    //   });
    //   if (!grnEntities) {
    //     throw new ErrorResponse(10000, 'No Records Found');
    //   }
    //   console.log(grnEntities);
    //   const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(grnEntities.farmer, grnEntities.farmerCode, 1, 1, 1));
    //   // const farmer = await this.supplierService.getSupplierBySupplierId({ farmerId: grnEntities.farmer })
    //   // const farmerCode = await this.supplierService.getFarmerDetailsByFarmerId({ farmerId: grnEntities.farmerCode })

    //   const indentNumber = await this.indentService.getIndentDetailsById({ indentId: grnEntities.indentId })
    //   const subPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: grnEntities.subPlantId });
    //   const vehicleInfo = await this.vehicleAssignmentService.getVehicleAssignDetailsByIndentId({ indentId: grnEntities.indentId });
    //   const vehicleData = await this.vehicleService.getVehicleByVehId({ vehicleId: vehicleInfo.data.vehicleId });
    //   const harvestData = await this.harvestreportService.getHarvestReport({plantId:grnEntities.plantId,harvestId:grnEntities.indentId})
    //   console.log(harvestData)

    //   const grnVehiclInfo = new GrnVehicleInfo();
    //   grnVehiclInfo.rmGrnId = grnReq.grnId;
    //   grnVehiclInfo.rmGrnNumber = grnEntities.grnNumber;
    //   grnVehiclInfo.indentId = grnEntities.indentId;
    //   grnVehiclInfo.indentNumber = indentNumber.data.indentCode;
    //   grnVehiclInfo.supplierId = 0;
    //   grnVehiclInfo.supplierCode = masterResponse.data.farmerCode;
    //   grnVehiclInfo.supplierAddress = masterResponse.data.address;
    //   grnVehiclInfo.vehicleId = vehicleInfo.data.vehicleId;
    //   grnVehiclInfo.vehicleNumber = vehicleData.data.registrationNumber;
    //   grnVehiclInfo.productId = indentNumber.data.product;
    //   grnVehiclInfo.varietyOfMaterial = indentNumber.data.productCode;
    //   grnVehiclInfo.sealNumber = harvestData.data.sealNo


    //   return new RMVehicleInfoResponse(true, 1, 'Grn retrieved successfully', grnVehiclInfo);
    // } catch (err) {
    //   return err;
    // }
  }

  async getGrnInfoByItemId(req: RMGrnItemIdReq): Promise<RMVehicleInfoResponse> {
    try {
      const manager = getManager();
      const query = `SELECT g.grn_id as rmGrnId, gi.grn_item_id as rmGrnItemId,g.indent_no as indentId, gi.farmer as supplierId, veh.vehicle_assign_id as vehicleId, gi.product as productId,gi.quantity as quantity, indent_code as indentNumber, rmvi_number as rmVINumber, g.grn_number as rmGrnNumber, mp.name as varietyOfMaterial, har.vehicle_no as vehicleNumber, vehicle_in_time as vehicleInTime, har.seal_no as sealNumber, icing_condition as icingConditionOfMaterial, crates_condition as cratesCondition, cleanliness_Of_crates as cleanlinessOfCrates, vehicle_cleanliness as vehicleCleanliness, sign_of_infestation as anySignOfInfestation, dust_or_filth as contaminationDustOrFilth, insulation_damage as insulationDamage, rmVi.remarks as remarks, g.plant_id as plantId, rmVi.created_user as createdUser, rmVi.updated_user as updatedUser, rmVi.inspection_id as inspectionId, CASE WHEN gi.broker > 0 THEN CONCAT_WS(", ", msb.street, msb.apartment, msb.city, msb.state, msb.district, msb.postal_code)
      ELSE CONCAT_WS(", ",ms.street, ms.apartment, ms.city, ms.state, ms.district, ms.postal_code) END AS supplierAddress, farm.name as supplierCode  FROM `+ rmGrnItemsTable + ` gi
      LEFT JOIN `+ rmGrnTable + ` g ON g.grn_id=gi.grn_id 
      LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
      LEFT JOIN `+ rmVIInspection + ` rmVi ON rmVi.grn_item_id=gi.grn_item_id 
      LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
      LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
      LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=gi.product
      LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
      LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
      LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
      LEFT JOIN `+ rmVehicleAssignment + ` veh ON veh.indent_id=g.indent_no
      LEFT JOIN `+ harvesting + ` har ON har.indent_item_id=gi.indent_item_id
      LEFT JOIN `+ salesSoTable + ` s ON s.sale_order_id=gi.sale_order_id
      LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=gi.sale_order_id 
      where  gi.grn_item_id=`+ req.grnItemId;
      const grnData: GrnVehicleInfo[] = await manager.query(query);
      if (grnData) {
        const grnItem: GrnVehicleInfo = grnData.find((val) => val.rmGrnItemId === req.grnItemId);
        return new RMVehicleInfoResponse(true, 1, 'Grn retrieved successfully', grnItem)
      } else {
        throw new ErrorResponse(99999, 'Not Found');
      }
    } catch (error) {
      return error;
    }
  }


  async getRmGrnDataById(req: GrnRequest) {
    const manager = getManager();

    const query = `SELECT gi.plant_lot_number AS lotnplantlot,i.rm_inward_type as rmInwardType,g.voucher_number as voucherNumber,s.sale_order_no as saleOrderNo,inv.po_number as poNumber,gi.assign_to_rm as assignToRm,g.grn_id as grnId,gi.plant_lot_number as lotNumber,gi.boxes,gi.received_boxes as receivedBoxes,gi.soft_percentage as softPercentage,g.grn_date as grnDate,g.grn_number as grnNumber,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.assign_lead_2 as assignLead12,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,g.plant_id as plantId,g.sub_plant_id as subPlantId,gi.product,gi.farmer,gi.count,
    ms.code as farmerCode,gi.quality,gi.grn_item_id as grnItemId,gi.indent_item_id as indentItemId,gi.sale_order_id as saleOrderId,gi.sale_order_item_id as saleOrderItemId,gi.quantity,gi.price ,farm.name as farmName,farm.address as farmAddress,ms.name as farmerName,msb.name as brokerName,mp.name as productName,me.employee_name as lead1Name,mem.employee_name as lead2Name, gi.vi_inspection as isVInspectionCompleted, gi.rm_inspection as isRmInspectionCompleted, gi.antibiotic_test as isAntibioticsTestCompleted,gi.loose_shell as looseShell,fungus_percentage as fungusPercentage,gi.remarks as plantLotNumber,gi.ref_no as refNo,i.harvest_type as harvestType,g.reweighment_bill_to as reweightBillTo FROM ` + rmGrnTable + ` g 
    LEFT JOIN `+ rmGrnItemsTable + ` gi ON gi.grn_id=g.grn_id 
    LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
    LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
    LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
    LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=gi.product
    LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
    LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
    LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
    LEFT JOIN `+ salesSoTable + ` s ON s.sale_order_id=gi.sale_order_id
    LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=gi.sale_order_id 
    
    where  g.grn_id=`+ req.grnId;
    const grnData = await manager.query(query);
    return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
  }

// async getRmGrnfullDataForHarvest(req:AntibioticsReq) {
 
//   const manager = getManager();
//   req = req || {};
//   let query = `SELECT indi.indent_item_id as indentItemId,i.indent_code as indentNumber, indi.indent_id as indentId, i.indent_date AS indentDate,s.name AS farmerName,su.name AS dealerName,indi.expected_count AS count, indi.expected_qty AS quantity, indi.test_result as testResult,indi.antibiotics_test_status as antibioticsTestStatus,indi.product as productId,i.supplier_type as supplierType
// FROM ${appSettings.rm_procure_db}.indent_items indi 
// LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = indi.indent_id 
// LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = indi.farmer 
// LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = indi.broker  
// WHERE indi.antibiotics_test_status = 'PENDING' 
//    `
//    if (req.fromDate && req.toDate != undefined) {
//     query += ` AND i.indent_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
// } else {
//     query += ` AND i.indent_date >= '2025-03-15'`;
//   }
//   try {
//     const grnData = await manager.query(query, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []);
//     return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
//   } catch (error) {
//     console.error("Database query error:", error);
//     return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
//   }
// }

  
async getRmGrnfullDataForHarvest(req:AntibioticsReq) {
  const manager = getManager();
  req = req || {};

  let query = `SELECT gi.grn_item_id AS grnItemId ,gi.grn_id AS grnId,gi.test_result AS testResult ,gi.plant_lot_number AS lotnplantlot,s.sale_order_no AS saleOrderNo,inv.po_number AS poNumber,gi.assign_to_rm AS assignToRm,g.grn_id AS grnId,gi.soft_percentage AS softPercentage,g.grn_date AS grnDate,g.grn_number AS grnNumber,i.assign_lead_1 AS assignLead1,i.supplier_type AS supplierType,i.vehicle_assigned AS vehicleAssigned,i.assign_lead_2 AS assignLead12,i.commission,i.commission_type AS commissionType,i.created_user AS createdUser,i.grn_completed AS grnCompleted,i.harvesting_date AS harvestingDate,i.harvesting_time AS harvestingTime,i.indent_code AS indentNumber,i.indent_date AS indentDate,i.indent_id AS indentId,g.plant_id AS plantId,g.sub_plant_id AS subPlantId,gi.product,gi.farmer,gi.count AS count,gi.boxes as boxes,gi.antibiotics_test_status as antibioticsTestStatus,
  gi.farmer_code AS farmerCode,gi.grn_item_id AS grnItemId,gi.indent_item_id AS indentItemId,gi.sale_order_id AS saleOrderId,gi.sale_order_item_id AS saleOrderItemId,gi.quantity AS grnQuantity,ii.expected_qty as indentQuantity,gi.price ,farm.name AS farmName,farm.address AS farmAddress,ms.name AS farmerName,msb.name AS dealerName,mp.name AS productName,me.employee_name AS lead1Name,mem.employee_name AS lead2Name, gi.vi_inspection AS isVInspectionCompleted, gi.rm_inspection AS isRmInspectionCompleted, gi.antibiotic_test AS isAntibioticsTestCompleted,gi.loose_shell AS looseShell,fungus_percentage AS fungusPercentage,gi.remarks AS plantLotNumber,gi.ref_no AS refNo,i.harvest_type AS harvestType,g.reweighment_bill_to AS reweightBillTo,ii.expected_qty AS expectedQty FROM ` + rmGrnItemsTable + ` gi 
  LEFT JOIN ` + rmGrnTable +` g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
  LEFT JOIN `+ rmIndentItemsTable + ` ii ON ii.indent_item_id = gi.indent_item_id
  LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
  LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
  LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=gi.product
  LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
  LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
  LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
  LEFT JOIN `+ salesSoTable + ` s ON s.sale_order_id=gi.sale_order_id
  LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=gi.sale_order_id 
  WHERE gi.test_result IS NULL AND gi.antibiotics_test_status = 'PENDING'

   `
   if (req.fromDate && req.toDate != undefined) {
    query += ` AND g.grn_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
} else {
    query += ` AND g.grn_date >= '2025-03-15'`;
  }
  // query += ` GROUP BY gi.indent_id,gi.reweighment_count`;
  try {
    const grnData = await manager.query(query, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []);
    return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
  } catch (error) {
    console.error("Database query error:", error);
    return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
  }
}


  async getRmGrnDataByIds(req: GrnRequest) {
    const manager = getManager();

    const query = `SELECT gi.plant_lot_number AS lotnplantlot,s.sale_order_no as saleOrderNo,inv.po_number as poNumber,gi.assign_to_rm as assignToRm,g.grn_id as grnId,gi.plant_lot_number as lotNumber,gi.boxes,gi.received_boxes as receivedBoxes,gi.soft_percentage as softPercentage,g.grn_date as grnDate,g.grn_number as grnNumber,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.assign_lead_2 as assignLead12,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,g.plant_id as plantId,g.sub_plant_id as subPlantId,gi.product,gi.farmer,gi.count,
    gi.farmer_code as farmerCode,gi.grn_item_id as grnItemId,gi.indent_item_id as indentItemId,gi.sale_order_id as saleOrderId,gi.sale_order_item_id as saleOrderItemId,gi.reweighment_quantity as quantity,gi.price ,farm.name as farmName,farm.address as farmAddress,ms.name as farmerName,msb.name as brokerName,mp.name as productName,me.employee_name as lead1Name,mem.employee_name as lead2Name, gi.vi_inspection as isVInspectionCompleted, gi.rm_inspection as isRmInspectionCompleted, gi.antibiotic_test as isAntibioticsTestCompleted,gi.loose_shell as looseShell,fungus_percentage as fungusPercentage,gi.remarks as plantLotNumber,gi.ref_no as refNo,i.harvest_type as harvestType,g.reweighment_bill_to as reweightBillTo,ii.expected_qty AS expectedQty FROM ` + rmGrnTable + ` g 
    LEFT JOIN `+ rmGrnItemsTable + ` gi ON gi.grn_id=g.grn_id 
    LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
    LEFT JOIN `+ rmIndentItemsTable + ` ii ON ii.indent_id=gi.indent_id AND ii.expected_count=gi.count
    LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
    LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
    LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=gi.product
    LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
    LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
    LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
    LEFT JOIN `+ salesSoTable + ` s ON s.sale_order_id=gi.sale_order_id
    LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=gi.sale_order_id 
    
    where  g.grn_id=`+ req.grnId;
    console.log(query,"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
    const grnData = await manager.query(query);
    return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
  }

  async updatePlantOrSubPlant(grnRequest: RmGrnPlantRequest): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {

      await manager.startTransaction();
      const updateInv = await manager.getCustomRepository(GrnRepository).update(
        { grnId: Raw((alias) => `grn_id = '${grnRequest.grnId}'`) },
        { plantId: grnRequest.plantId, subPlantId: grnRequest.subPlantId }
      );
      if (updateInv.affected) {
        manager.completeTransaction()
        return new CommonResponse(true, 1, 'Updated successfully', undefined)
      } else {
        manager.releaseTransaction()
        return new CommonResponse(false, 0, 'not updated', undefined)

      }
    } catch (err) {
      manager.releaseTransaction()
      return new CommonResponse(false, 0, 'not updated', undefined)
    }
    return
  }


  async getGRNAbstract(grnAbstractRequest?: GrnAbstractRequest): Promise<any> {
    const { harvestType } = grnAbstractRequest;
    const manager = getManager();
    
  
      let query = `SELECT IF(u.plant_code IS NULL, "Out Side", u.plant_code) AS unit_name,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 0 AND 25 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 0 AND 25 THEN gi.quantity ELSE 0 END) AS count25,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 26 AND 32 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 26 AND 32 THEN gi.quantity ELSE 0 END) AS count30,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 33 AND 42 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 33 AND 42 THEN gi.quantity ELSE 0 END) AS count40,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 43 AND 52 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 43 AND 52 THEN gi.quantity ELSE 0 END) AS count50,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 53 AND 62 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 53 AND 62 THEN gi.quantity ELSE 0 END) AS count60,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 63 AND 72 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 63 AND 72 THEN gi.quantity ELSE 0 END) AS count70,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 73 AND 82 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 73 AND 82 THEN gi.quantity ELSE 0 END) AS count80,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 83 AND 92 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 83 AND 92 THEN gi.quantity ELSE 0 END) AS count90,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 93 AND 102 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 93 AND 102 THEN gi.quantity ELSE 0 END) AS count100,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 103 AND 112 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 103 AND 112 THEN gi.quantity ELSE 0 END) AS count110,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 113 AND 122 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 113 AND 122 THEN gi.quantity ELSE 0 END) AS count120,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 123 AND 132 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 123 AND 132 THEN gi.quantity ELSE 0 END) AS count130,
SUM(CASE WHEN i.harvest_type = 'Re Weighment' AND gi.reweighment_count BETWEEN 133 AND 500 THEN gi.reweighment_quantity WHEN i.harvest_type = 'Live Harvest' AND gi.COUNT BETWEEN 133 AND 500 THEN gi.quantity ELSE 0 END) AS count140
FROM grn_items gi
LEFT JOIN grn g ON g.grn_id = gi.grn_id
LEFT JOIN indent i ON i.indent_id = gi.indent_id
LEFT JOIN erpx_dev_masters.unitcodes u ON u.unit_code_id = g.plant_id
WHERE 1 = 1`;
        if(grnAbstractRequest.fromDate !== undefined){
          query += ` AND DATE(g.grn_date) BETWEEN '${grnAbstractRequest.fromDate}' and  '${grnAbstractRequest.toDate}'`
        }
        if(grnAbstractRequest.reweighmentFromDate !== undefined){
          query += ` AND DATE(g.reweighment_date) BETWEEN '${grnAbstractRequest.reweighmentFromDate}' and '${grnAbstractRequest.reweighmentToDate}'`
        }
        query += ` GROUP BY u.unit_code_id`
      let grnAbstract = await manager.query(query);
      return new AllGrnResponseModel(true, 5555, 'Data retrieved Successfully', grnAbstract);
    
  }
  // async getGRNAbstract(grnAbstractRequest?: GrnAbstractRequest): Promise<any> {
  //   const { harvestType } = grnAbstractRequest;
  //   const manager = getManager();
    
  //   if (harvestType === HarvestTypes.Re_Weighment) {
  //     let reweighmentquery = `SELECT If(u.plant_code is null,"Out Side",u.plant_code) AS unit_name,
  //       SUM(CASE WHEN reweighment_count BETWEEN 0 AND 25 THEN reweighment_quantity  ELSE 0 END) AS count25,
  //       SUM(CASE WHEN reweighment_count BETWEEN 26 AND 32 THEN reweighment_quantity  ELSE 0 END) AS count30,
  //       SUM(CASE WHEN reweighment_count BETWEEN 33 AND 42 THEN reweighment_quantity  ELSE 0 END) AS count40,
  //       SUM(CASE WHEN reweighment_count BETWEEN 43 AND 52 THEN reweighment_quantity  ELSE 0 END) AS count50,
  //       SUM(CASE WHEN reweighment_count BETWEEN 53 AND 62 THEN reweighment_quantity  ELSE 0 END) AS count60,
  //       SUM(CASE WHEN reweighment_count BETWEEN 63 AND 72 THEN reweighment_quantity  ELSE 0 END) AS count70,
  //       SUM(CASE WHEN reweighment_count BETWEEN 73 AND 82 THEN reweighment_quantity  ELSE 0 END) AS count80,
  //       SUM(CASE WHEN reweighment_count BETWEEN 83 AND 92 THEN reweighment_quantity  ELSE 0 END) AS count90,
  //       SUM(CASE WHEN reweighment_count BETWEEN 93 AND 102 THEN reweighment_quantity  ELSE 0 END) AS count100,
  //       SUM(CASE WHEN reweighment_count BETWEEN 103 AND 112 THEN reweighment_quantity  ELSE 0 END) AS count110,
  //       SUM(CASE WHEN reweighment_count BETWEEN 113 AND 122 THEN reweighment_quantity  ELSE 0 END) AS count120,
  //       SUM(CASE WHEN reweighment_count BETWEEN 123 AND 132 THEN reweighment_quantity  ELSE 0 END) AS count130,
  //       SUM(CASE WHEN reweighment_count BETWEEN 133 AND 500 THEN reweighment_quantity  ELSE 0 END) AS count140
  //       FROM grn_items LEFT JOIN grn g ON g.grn_id=grn_items.grn_id 
  //       LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=g.plant_id      
  //       GROUP BY u.unit_code_id`;
  //     console.log(reweighmentquery);
  //     let reweighmentAbstract = await manager.query(reweighmentquery);
  //     return new AllGrnResponseModel(true, 5555, 'Re-weighment data retrieved', reweighmentAbstract);
  //   } else {
  //     let query = `SELECT If(u.plant_code is null,"Out Side",u.plant_code) AS unit_name,
  //       SUM(CASE WHEN COUNT BETWEEN 0 AND 25 THEN quantity ELSE 0 END) AS count25,
  //       SUM(CASE WHEN COUNT BETWEEN 26 AND 32 THEN quantity ELSE 0 END) AS count30,
  //       SUM(CASE WHEN COUNT BETWEEN 33 AND 42 THEN quantity ELSE 0 END) AS count40,
  //       SUM(CASE WHEN COUNT BETWEEN 43 AND 52 THEN quantity ELSE 0 END) AS count50,
  //       SUM(CASE WHEN COUNT BETWEEN 53 AND 62 THEN quantity ELSE 0 END) AS count60,
  //       SUM(CASE WHEN COUNT BETWEEN 63 AND 72 THEN quantity ELSE 0 END) AS count70,
  //       SUM(CASE WHEN COUNT BETWEEN 73 AND 82 THEN quantity ELSE 0 END) AS count80,
  //       SUM(CASE WHEN COUNT BETWEEN 83 AND 92 THEN quantity ELSE 0 END) AS count90,
  //       SUM(CASE WHEN COUNT BETWEEN 93 AND 102 THEN quantity ELSE 0 END) AS count100,
  //       SUM(CASE WHEN COUNT BETWEEN 103 AND 112 THEN quantity ELSE 0 END) AS count110,
  //       SUM(CASE WHEN COUNT BETWEEN 113 AND 122 THEN quantity ELSE 0 END) AS count120,
  //       SUM(CASE WHEN COUNT BETWEEN 123 AND 132 THEN quantity ELSE 0 END) AS count130,
  //       SUM(CASE WHEN COUNT BETWEEN 133 AND 500 THEN quantity ELSE 0 END) AS count140
  //       FROM grn_items LEFT JOIN grn g ON g.grn_id=grn_items.grn_id 
  //       LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=g.plant_id  
  //       WHERE 1=1 `;
  //       if(grnAbstractRequest.fromDate !== undefined){
  //         query += ` AND DATE(g.grn_date) BETWEEN '${grnAbstractRequest.fromDate}' and  '${grnAbstractRequest.toDate}'`
  //       }
  //       query += ` GROUP BY u.unit_code_id`
  //     let grnAbstract = await manager.query(query);
  //     return new AllGrnResponseModel(true, 5555, 'Live harvest data retrieved', grnAbstract);
  //   }
  // }
  


  async getGRNAbstractForReweighment(grnAbstractRequest: GrnAbstractRequest): Promise<any> {
    console.log(new Date(grnAbstractRequest.fromDate));
    const manager = getManager();
    let query = `SELECT If(u.plant_code is null,"Out Side",u.plant_code) AS plant_code,
    SUM(CASE WHEN reweighment_count BETWEEN 0 AND 25 THEN reweighment_quantity  ELSE 0 END) AS count25,
    SUM(CASE WHEN reweighment_count BETWEEN 26 AND 32 THEN reweighment_quantity  ELSE 0 END) AS count30,
    SUM(CASE WHEN reweighment_count BETWEEN 33 AND 42 THEN reweighment_quantity  ELSE 0 END) AS count40,
    SUM(CASE WHEN reweighment_count BETWEEN 43 AND 52 THEN reweighment_quantity  ELSE 0 END) AS count50,
    SUM(CASE WHEN reweighment_count BETWEEN 53 AND 62 THEN reweighment_quantity  ELSE 0 END) AS count60,
    SUM(CASE WHEN reweighment_count BETWEEN 63 AND 72 THEN reweighment_quantity  ELSE 0 END) AS count70,
    SUM(CASE WHEN reweighment_count BETWEEN 73 AND 82 THEN reweighment_quantity  ELSE 0 END) AS count80,
    SUM(CASE WHEN reweighment_count BETWEEN 83 AND 92 THEN reweighment_quantity  ELSE 0 END) AS count90,
    SUM(CASE WHEN reweighment_count BETWEEN 93 AND 102 THEN reweighment_quantity  ELSE 0 END) AS count100,
    SUM(CASE WHEN reweighment_count BETWEEN 103 AND 112 THEN reweighment_quantity  ELSE 0 END) AS count110,
    SUM(CASE WHEN reweighment_count BETWEEN 113 AND 122 THEN reweighment_quantity  ELSE 0 END) AS count120,
    SUM(CASE WHEN reweighment_count BETWEEN 123 AND 132 THEN reweighment_quantity  ELSE 0 END) AS count130,
    SUM(CASE WHEN reweighment_count BETWEEN 133 AND 500 THEN reweighment_quantity  ELSE 0 END) AS count140
    FROM grn_items LEFT JOIN grn g ON g.grn_id=grn_items.grn_id 
    LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=g.plant_id      
    GROUP BY u.unit_code_id`;
    console.log(query);
    let grnAbstract = await manager.query(query);
    return new AllGrnResponseModel(true, 5555, 'closed indents retrived', grnAbstract)
  }

  async updateGrnAuditQty(req: RmActualCountDto) {
    const updateResponse = await this.grnItemRepository.update({ grnItemId: req.grnItemId }, { actualCount: req.actualCount, actualQuantity: req.actualQuantity });

    if (updateResponse.affected) {
      return new CommonResponse(true, 1111, 'Updated Successfully.');
    } else {
      return new CommonResponse(false, 9999, 'Failed To Update.')
    }
  }

  async getGrnNumberDropdownInfoForRMInvoice():Promise<CommonResponse>{
    const manager = getManager()
    try{
      // const data = await this.grnRepository.find({select:['grnId','grnNumber'],where:{invoiceStatus:InvoiceStatusEnum.OPEN}})
      const query = `select g.grn_id as grnId, g.grn_number as grnNumber
      from ${appSettings.rm_procure_db} .grn g
      where inv_status = '${InvoiceStatusEnum.OPEN}'
      group by g.grn_number`
      const data = await manager.query(query)
      if(data.length > 0){
        return new CommonResponse(true,1,'Data retrieved',data)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
      
    }catch(err){
      throw err
    }
  }

  async getIndentNumberDropdownInfoForRMInvoice():Promise<CommonResponse>{
    const manager = getManager()
    try{
      // const data = await this.grnRepository.find({select:['grnId','grnNumber'],where:{invoiceStatus:InvoiceStatusEnum.OPEN}})
      const query = `select g.grn_id as grnId,g.indent_no as indentId,i.indent_code as indentNumber
      from ${appSettings.rm_procure_db} .grn g
      left join ${appSettings.rm_procure_db} .indent i on i.indent_id = g.indent_no
      where inv_status = '${InvoiceStatusEnum.OPEN}'
      group by i.indent_code`
      const data = await manager.query(query)
      if(data.length > 0){
        return new CommonResponse(true,1,'Data retrieved',data)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
      
    }catch(err){
      throw err
    }
  }

  async getGrnItemInfoForInvoice(req:RmInvoiceReq):Promise<CommonResponse>{
    const manager = getManager()
    const newArray = req.batchNumber.map(item => '"'+item+'"');
    const yearArray = req.year.map(item => ''+item+'');
    try{
      // let infoQuery = `select gi.grn_item_id as grnItemId,gi.lot_number as lotNumber,gi.count as actualCount,g.grn_number as grnNumber,g.supplier_type as supplierType,s.name as supplierName,s.code as supplierCode,s.gst_number as gstNumber,concat(s.street,',',s.apartment,',',s.district,',',s.state,',',s.postal_code) as supplierAddress,i.indent_code as indentNumber,hr.vehicle_no as vehicleNumber,gi.quantity,gi.price as expectedPrice,gi.indent_id as indentId,IF(i.harvest_type = 'LIVE HARVEST',gi.quantity,gi.reweighment_quantity) AS totalQty,gid.quantity AS defectQty,d.defect_name AS defectName,
      // gid.grn_item__defects_id AS defectId,gi.plant_lot_number as batchNumber
      // from ${appSettings.rm_procure_db} .grn_items gi
      // left join ${appSettings.rm_procure_db} .grn g on g.grn_id = gi.grn_id
      // left join ${appSettings.rm_procure_db} .indent i on i.indent_id = gi.indent_id
      // left join ${appSettings.rm_procure_db} .indent_items ii on ii.indent_id = gi.indent_id
      // left join ${appSettings.masters_db} .suppliers s on s.supplier_id = gi.farmer 
      // left join ${appSettings.rm_procure_db} .harvest_report hr on hr.indent_id = gi.indent_id 
      // left join ${appSettings.rm_procure_db} .grn_item_defects gid on gid.grn_item_id = gi.grn_item_id
      // LEFT JOIN ${appSettings.masters_db} .defect d ON d.defect_id = gid.defect_id
      // where gi.grn_item_id > 0`
      // if(req.batchNumber != undefined){
      //   infoQuery += ` and gi.plant_lot_number IN (${newArray})`
      // }

      let infoQuery = `SELECT  g.grn_id as grnId,gi.grn_item_id AS grnItemId, gi.lot_number AS lotNumber, IF(i.harvest_type = '${HarvestTypes.Live_Harvest}',gi.count,gi.reweighment_count) AS actualCount, g.grn_number AS grnNumber, g.supplier_type AS supplierType, s.name AS supplierName, s.code AS supplierCode, s.gst_number AS gstNumber, CONCAT(s.street, ',', s.apartment, ',', s.district, ',', s.state, ',', s.postal_code) AS supplierAddress, i.indent_code AS indentNumber, g.vehicle_number AS vehicleNumber, SUM(gi.quantity) as quantity, gi.price AS expectedPrice,  gi.indent_id AS indentId, IF(i.harvest_type = '${HarvestTypes.Live_Harvest}', SUM(gi.quantity), gi.reweighment_quantity) AS totalQty, NULL AS defectQty, NULL AS defectName, NULL AS defectId,  GROUP_CONCAT(DISTINCT(gi.plant_lot_number)) AS batchNumber,'GRN Item' AS recordType,g.plant_id as plantId
      FROM ${appSettings.rm_procure_db}.grn_items gi
      LEFT JOIN  ${appSettings.rm_procure_db}.grn g ON g.grn_id = gi.grn_id
      LEFT JOIN  ${appSettings.rm_procure_db}.indent i ON i.indent_id = gi.indent_id
      LEFT JOIN  ${appSettings.masters_db}.suppliers s ON s.supplier_id =  IF(i.supplier_type = '${SupplierTypeEnum.DEALER}' , gi.broker , gi.farmer )
      WHERE  gi.grn_item_id > 0  AND gi.plant_lot_number IN (${newArray}) AND gi.year IN (${yearArray}) AND IF(harvest_type = '${HarvestTypes.Live_Harvest}' , addon_count = 0,addon_count IN (0,1) ) and gi.inv_status = '${InvoiceStatusEnum.OPEN}'
      GROUP BY plant_lot_number
      UNION ALL
      SELECT  g.grn_id as grnId,gi.grn_item_id AS grnItemId,gi.lot_number AS lotNumber,IF(i.harvest_type = '${HarvestTypes.Live_Harvest}',gi.count,gi.reweighment_count) AS actualCount,g.grn_number AS grnNumber,g.supplier_type AS supplierType,s.name AS supplierName,s.code AS supplierCode,s.gst_number AS gstNumber,CONCAT(s.street, ',', s.apartment, ',', s.district, ',', s.state, ',', s.postal_code) AS supplierAddress,i.indent_code AS indentNumber,g.vehicle_number AS vehicleNumber,gi.quantity,gi.price AS expectedPrice,gi.indent_id AS indentId,IF(i.harvest_type = '${HarvestTypes.Live_Harvest}',SUM(gi.quantity), gi.reweighment_quantity) AS totalQty,gid.quantity AS defectQty,d.defect_name AS defectName,gid.grn_item__defects_id AS defectId, GROUP_CONCAT(DISTINCT(gi.plant_lot_number)) AS batchNumber,'Defect' AS recordType,g.plant_id as plantId
      FROM  ${appSettings.rm_procure_db}.grn_items gi
      LEFT JOIN  ${appSettings.rm_procure_db}.grn g ON g.grn_id = gi.grn_id
      LEFT JOIN  ${appSettings.rm_procure_db}.indent i ON i.indent_id = gi.indent_id
      LEFT JOIN  ${appSettings.masters_db}.suppliers s ON s.supplier_id = IF(i.supplier_type = '${SupplierTypeEnum.DEALER}' , gi.broker , gi.farmer )
      LEFT JOIN  ${appSettings.rm_procure_db}.grn_item_defects gid ON gid.grn_item_id = gi.grn_item_id
      LEFT JOIN  ${appSettings.masters_db}.defect d ON d.defect_id = gid.defect_id
      WHERE  gid.defect_id > 0  AND gi.plant_lot_number IN (${newArray}) AND gi.year IN (${yearArray}) AND IF(harvest_type = '${HarvestTypes.Live_Harvest}' , addon_count = 0,addon_count IN (0,1) ) and gi.inv_status = '${InvoiceStatusEnum.OPEN}'
      GROUP BY gid.defect_id,plant_lot_number
      ORDER BY batchNumber, recordType `
      const data = await manager.query(infoQuery)
      
      if(data.length > 0){
        return new CommonResponse(true,1,'Data retrieved',data)
      }else{
        return new CommonResponse(false,0,'No data found')

      }

    }catch(err){
      throw err
    }
  }

  async updateInvoiceInfo(req:RmInvoiceUpdateReq):Promise<CommonResponse>{
    // const transactionManager = new GenericTransactionManager()
    // const manager = getManager()
    const connection = getConnection();
    const transactionManager: QueryRunner = connection.createQueryRunner();
    try{
      await transactionManager.startTransaction()
      req.grnItemIdMap = new Map<number, { amount: number }>(req.grnItemIdMap);

      let today = dayjs(req.grnItemsInfo[0].invoiceDate).toDate();
      // let today = new Date(req.grnItemsInfo[0].invoiceDate);

      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0
      let toDate = 0
      if ((Number(CurrentMonth) + 1) < 4) {
        fromDate = (CurrentYear - 1);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);
      }
      const nextYear =  Number(toDate.toString().substr(-2)) + 1

      // const getMaxIdQuery= `SELECT COUNT(DISTINCT(invoice_number)) as id FROM ${appSettings.rm_procure_db} .rm_invoice`
      const getMaxIdQuery= `SELECT MAX(ref_no) as id FROM ${appSettings.rm_procure_db} .rm_invoice`
      const maxIdInfo = await transactionManager.manager.query(getMaxIdQuery)
      console.log(maxIdInfo,'8888888888')
      let maxId
      if(maxIdInfo.length > 0){
        maxId = Number(Number(maxIdInfo[0].id)+1)
      }else{
        maxId = 1
      }
      const invoiceNumber = 'BMR/RM/'+ Number(maxId).toString().padStart(3, '0') +'/' + (fromDate.toString().substr(-2)) + '-' + (toDate.toString().substr(-2))

      const getSupplierIdAgainstIndent = await transactionManager.manager.find(IndentItems,{where:{indentId:req.grnItemsInfo[0].indentId}})

      let tdsFlag
      
      let amountInfo
        let prevAmount = 0

      let billTo = req.billToType == 'Farmer' ? req.billTo : 0

      const getBillToQry = `SELECT reweighment_bill_to FROM ${appSettings.rm_procure_db} .grn_items WHERE grn_item_id = ${req.grnItemsInfo[0].grnItemId}`
      const reweighmentBillToInfo = await transactionManager.manager.query(getBillToQry)

      let findtdsApplicableInfoQry = `SELECT COUNT(*) as count from ${appSettings.rm_procure_db} .grn_items gi LEFT JOIN ${appSettings.rm_procure_db} .indent_items ii ON ii.indent_id = gi.indent_id  
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id LEFT JOIN ${appSettings.rm_procure_db} .rm_invoice inv ON inv.grn_item_id = gi.grn_item_id
      WHERE IF(bill_to_type ='Farmer' , inv.bill_to = ${billTo} ,IF(i.supplier_type = '${SupplierTypeEnum.DEALER}',ii.broker = ${getSupplierIdAgainstIndent[0].broker},ii.farmer = ${getSupplierIdAgainstIndent[0].farmer})) AND tds_applicable = 1 AND inv.financial_year = '${(fromDate.toString().substr(-2)) + '-' + (toDate.toString().substr(-2))}' AND reweighment_bill_to = '${reweighmentBillToInfo[0].reweighment_bill_to}'`
      // if(req.billToType == 'Farmer'){
      //   findtdsApplicableInfoQry +=  `  AND inv.bill_to = ${req.billTo}`
      // }else{
      //   findtdsApplicableInfoQry == ` AND IF(i.supplier_type = '${SupplierTypeEnum.DEALER}',ii.broker = ${getSupplierIdAgainstIndent[0].broker},ii.farmer = ${getSupplierIdAgainstIndent[0].farmer})`
      // }
      const tdsApplicableInfo = await transactionManager.manager.query(findtdsApplicableInfoQry)   
      if(tdsApplicableInfo[0]?.count > 0){
        tdsFlag = true
      }else{
        tdsFlag = false
        
        const amountAgainstSupplierInfoQry = `SELECT SUM(inv.total_amount) as amount from ${appSettings.rm_procure_db} .rm_invoice inv LEFT JOIN ${appSettings.rm_procure_db} .indent_items ii ON ii.indent_id = inv.indent_id  
        LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = inv.indent_id
        LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_item_id = inv.grn_item_id
        WHERE IF(bill_to_type ='Farmer' , inv.bill_to = ${billTo} ,IF(i.supplier_type = '${SupplierTypeEnum.DEALER}',ii.broker = ${getSupplierIdAgainstIndent[0].broker},ii.farmer = ${getSupplierIdAgainstIndent[0].farmer})) AND inv.financial_year = '${(fromDate.toString().substr(-2)) + '-' + (toDate.toString().substr(-2))}' AND reweighment_bill_to = '${reweighmentBillToInfo[0].reweighment_bill_to}'`
        // if(req.billToType == 'Farmer'){
        //   findtdsApplicableInfoQry +=  `  AND inv.bill_to = ${req.billTo}`
        // }else{
        //   findtdsApplicableInfoQry == ` AND IF(i.supplier_type = '${SupplierTypeEnum.DEALER}',ii.broker = ${getSupplierIdAgainstIndent[0].broker},ii.farmer = ${getSupplierIdAgainstIndent[0].farmer})`
        // }
        amountInfo = await transactionManager.manager.query(amountAgainstSupplierInfoQry)
        prevAmount = amountInfo[0].amount
      }

      const saveFlag = new Set<boolean>()
      for(const rec of req.grnItemsInfo){
        let inputString = rec.batchNumber
        // Split the string by commas, remove duplicates using Set, and convert back to an array
        let lotNumbers = [...new Set(inputString.split(','))];
        const grnItemAmount = req.grnItemIdMap.get(rec.grnItemId).amount
        const entityObj = new RmInvoice()
        entityObj.batchNumber = rec.batchNumber
        entityObj.grnId = rec.grnId
        entityObj.grnItemId = rec.grnItemId
        entityObj.invoiceNumber = invoiceNumber
        entityObj.invoiceDate = rec.invoiceDate
        entityObj.indentId = rec.indentId
        entityObj.defectId = rec.defectId
        entityObj.plantId = req.plantId                                                       
        entityObj.count = rec.count
        entityObj.unitPrice = rec.unitPrice
        entityObj.quantity = rec.quantity
        entityObj.totalAmount = rec.totalAmount
        entityObj.type = rec.type
        entityObj.invoiceRemarks = rec.invoiceRemarks
        entityObj.billTo = req.billTo
        entityObj.invoiceStatus = req.invoiceStatus
        entityObj.billToType = req.billToType
        entityObj.financierName = req.financierName
        entityObj.refNo = Number(maxId)
        entityObj.createdUser = req.createdUser
        entityObj.financialYear = (fromDate.toString().substr(-2)) + '-' + (toDate.toString().substr(-2))
        const saveInvoiceInfo = await transactionManager.manager.save(RmInvoice,entityObj)
        if(!saveInvoiceInfo){
          saveFlag.add(false)
          await transactionManager.rollbackTransaction()
          await transactionManager.release()
          return new CommonResponse(false,0,'Somethig went wrong in saving invoice info')
        }

        if(rec.totalAmount > 0){
          let taxableAmount
          if(tdsFlag){
            taxableAmount = Number(rec.totalAmount)
          }else{
            // console.log(amountInfo[0].amount,'amuountt')
            // console.log(Number(grnItemAmount),'grnitemamount')
            // console.log(Number(prevAmount) + Number(grnItemAmount),'totalllllllll')
            if(Number(prevAmount) + Number(rec.totalAmount) > 5000000){
              taxableAmount = (Number(prevAmount) + Number(rec.totalAmount)) - 5000000
              tdsFlag = true
            }else{
              tdsFlag = false
              taxableAmount = 0
            }
            prevAmount = Number(prevAmount) + Number(rec.totalAmount)
          }
          const tdsApplicableInfoUpdate = await transactionManager.manager.update(GrnItems,{grnItemId:rec.grnItemId},{tdsApplicable:tdsFlag,taxableAmount:() => `taxable_amount + ${taxableAmount}`})
          if(tdsApplicableInfoUpdate.affected){
            saveFlag.add(true)
          }else{
            saveFlag.add(false)
            await transactionManager.rollbackTransaction()
            await transactionManager.release()
            return new CommonResponse(false,0,'Something went wrong in Grn Item Price Updation')

          }
          
        }
        const grnItemPriceUpdate = await transactionManager.manager.update(GrnItems,{plantLotNumber: In(lotNumbers)},{invoiceStatus:InvoiceStatusEnum.CLOSE})
        if(!grnItemPriceUpdate.affected){
          saveFlag.add(false)
          await transactionManager.rollbackTransaction()
          await transactionManager.release()
          return new CommonResponse(false,0,'Something went wrong in Grn Item Price Updation')
        }
        
      }
      const findGrn = await transactionManager.manager.find(GrnItems,{where:{invoiceStatus:InvoiceStatusEnum.OPEN,isActive:true,grnId:req.grnId}})
      let updateInvoiceStatus
      if(findGrn.length > 0){
        updateInvoiceStatus = await transactionManager.manager.update(Grn,{grnId:req.grnId},{invoiceStatus:InvoiceStatusEnum.INPROGRESS})
      }else{
        updateInvoiceStatus = await transactionManager.manager.update(Grn,{grnId:req.grnId},{invoiceStatus:InvoiceStatusEnum.CLOSE})
      }
      if(!updateInvoiceStatus.affected){
        saveFlag.add(false)
        await transactionManager.rollbackTransaction()
        await transactionManager.release()
        return new CommonResponse(false,0,'Something went wrong in invoice status updation in GRN')
      }

      if(!(saveFlag.has(false))){
        await transactionManager.commitTransaction()
        await transactionManager.release()
        return new CommonResponse(true,1,'Updated successfully')
      }else{
        await transactionManager.rollbackTransaction()
        await transactionManager.release()
        return new CommonResponse(false,0,'Something went wrong in updation')
      }
    }catch(err){
      await transactionManager.rollbackTransaction()
      await transactionManager.release()
      return new CommonResponse(false,0,'Something went wrong in updation',err)
    }
  }

  async createReweighmentInfo(req:ReweighmentReq):Promise<CommonResponse>{
    const transactionManager =new GenericTransactionManager()
    const queryManger = getManager()
    try{
      // const lotCodeArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','Y','Z']
      
      await transactionManager.startTransaction()
      let saveFlag = new Set<boolean>()
      
      const rmratereq = new RmRatesInfoReq(req.indentId,req.harvestType,CompanyCategoryEnum.OWN,req.count)
      const grnItemById = await transactionManager.getRepository(GrnItems).findOne(req.grnItemId)
      const getRmRatesInfo = await this.rmCountPriceListService.getRmRatesAgainstUploadedDate(rmratereq)
      const budgetRangeReq = new RmBudgetInfoReq(req.harvestType==HarvestTypes.Re_Weighment?req.count:grnItemById.count,req.reweighmentDate)
      console.log(budgetRangeReq,'reqqqqqqqqqqqqqq');
      
      const budgetRange = await this.rmBudgetService.getBudgetRangeAgainstCount(budgetRangeReq)
      const productIdByGrnItem = `SELECT ii.product as productId FROM indent_items ii
        LEFT JOIN grn_items gi ON gi.indent_id = ii.indent_id
        WHERE gi.grn_id = ${req.grnId}
        GROUP BY gi.indent_id `
      const productId = await queryManger.query(productIdByGrnItem)
      console.log(productId[0].productId,'oooooooooooo');
      
      let rmRate 
      if(getRmRatesInfo.data.length > 0){
        rmRate = getRmRatesInfo.data[0].price
      }else{
        saveFlag.add(false)
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Rm Rate not found for the given count')
      }
      if(req.harvestType == HarvestTypes.Re_Weighment && !req.addonCount){
        const updateRmRateInGRN = await transactionManager.getRepository(GrnItems).update({grnItemId:req.grnItemId},{rmRate:rmRate,price:() => `${rmRate} + ice_rate`})
        if(updateRmRateInGRN.affected){
          saveFlag.add(true)
        }else{
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in updating Rm Rate in GRN')
        }
      }
      const date = new Date(req.reweighmentDate)
      const reweighmentYear = date.getFullYear()
      const month = date.getMonth()
      const year =  Number(month) + 1 < 4 ? Number(reweighmentYear) - 1 : reweighmentYear
      const batchNumCheckQry = `SELECT * from ${appSettings.rm_procure_db} .grn_items where plant_lot_number = '${req.batchNumber}' and year = ${year}`
      const batchNumCheck = await queryManger.query(batchNumCheckQry)
      if(batchNumCheck.length > 0){
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Batch Number already existed')
      }
      let saveGrnItem
      const findsameCountExist = await transactionManager.getRepository(GrnItems).find({where:{mainBatchNumber:req.mainBatchNumber,count:req.count,year:year}})

      const getGrnItemsCountQry = `SELECT COUNT(*) as count,indent_id,count FROM ${appSettings.rm_procure_db} .grn_items WHERE grn_id = ${req.grnId}`
      const grnItemCount = await queryManger.query(getGrnItemsCountQry)
      const reweighmentCountQry = `SELECT COUNT(*) as count FROM ${appSettings.rm_procure_db} .grn_items WHERE grn_id = ${req.grnId} AND reweighment_status = 1`
      const reweighmentCount = await queryManger.query(reweighmentCountQry)
      if(req.addonCount){
        // const month = moment().month()
        // const year = moment().year()
        const getMaxId = `select max(ref_no) as ref from ${appSettings.rm_procure_db}.grn_items gi where YEAR(created_at) = ${year} and MONTH(gi.created_at) =  ${month + 1} `
        const result = await queryManger.query(getMaxId)
        let monthlyRefNo
        if (result && result.length) {
          const maxref = Number(result[0].ref) + 1
          monthlyRefNo = maxref
          console.log(monthlyRefNo)
        } else {
          monthlyRefNo = 1
          console.log('else',monthlyRefNo)

        }
        const unitcodeReq = new PlantIdRequest(req.plantId)
      const getCompanyInfo = await this.unitCodesService.getPlantDetailsById(unitcodeReq)
      let totalGrnItems = await this.grnItemRepository.count({ where: { lotNumber: isNotEmpty(null) } })
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0
      let toDate = 0

      if ((CurrentMonth + 1) < 4) {
        fromDate = (CurrentYear);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);

      }

      totalGrnItems = totalGrnItems + 1;
      let grnItemRefNo = monthlyRefNo + "";
      let subPlantShortCode = ''

      while (grnItemRefNo.length < 4) grnItemRefNo = "0" + grnItemRefNo;
        const lotNo = "LOT" + "-" + (getCompanyInfo.data.company == CompanyTypeEnum.BMR_EXPORTS_AP ? 'E' : getCompanyInfo.data.company == CompanyTypeEnum.BMR_EXPORTS_ODISHA ? 'OR' : 'R') + "/" + (toDate.toString().substr(-2)) + '/' + (today.getMonth() + 1) + "/" + grnItemRefNo + subPlantShortCode;
        // const getRmRate = await this.indentService.getRmRateAgainstCount(new RmCountReq(req.count,req.harvestType))
        // let price = 0
        // if(!getRmRate.status){
        //     let decimalIndex = req.count.toString().indexOf(".");
        //     let afterDecimalValue = req.count.toString().substring(decimalIndex+1);
        //     let beforeDecimalValue = req.count.toString().substring(0,decimalIndex);
        //     // const upperCountObj = rmRates.find(e => {
        //     //   return(
        //     //     e.count == Number(beforeDecimalValue) && e.type == req.harvestType && e.category == CompanyCategoryEnum.OWN
        //     //   )
        //     // })
        //     const upperCountObj = await this.indentService.getRmRateAgainstCount(new RmCountReq(Number(beforeDecimalValue),req.harvestType))
        //     // const lowerCountObj= rmRates.find(e => {
        //     //   return(
        //     //     e.count == Number(beforeDecimalValue)+1 && e.type == element.harvestType && e.category == CompanyCategoryEnum.OWN
        //     //   )
        //     // })
        //     const lowerCountObj = await this.indentService.getRmRateAgainstCount(new RmCountReq(Number(beforeDecimalValue) + 1,req.harvestType))
        //     console.log(lowerCountObj,"lowerCountObjlowerCountObjlowerCountObjlowerCountObj")

        //     if(req.count   <= 40){
        //       if(Number(afterDecimalValue) <= 3){
        //         if(!upperCountObj.status){
        //           saveFlag.add(false)
        //           await transactionManager.releaseTransaction()
        //           return new CommonResponse(false,0,`No RM Rate found for the count ${Number(beforeDecimalValue)}`)
        //         }else{
        //           price = upperCountObj.data[0].price
        //         }
        //       }else if(Number(afterDecimalValue) == 4 || Number(afterDecimalValue) == 5 || Number(afterDecimalValue) ==6){
        //         if(lowerCountObj.status && upperCountObj.status){
        //           const diff = Number(upperCountObj.data[0].price) - Number(lowerCountObj.data[0].price)
        //           const halfdiff = Number(diff)/2
        //           price = Number(upperCountObj.data[0].price) + Math.abs(Number(halfdiff))
        //         }else{
        //           saveFlag.add(false)
        //           await transactionManager.releaseTransaction()
        //           return new CommonResponse(false,0,`No RM Rate found for the count ${Number(beforeDecimalValue)}`)
        //         }
        //       }else{
        //         if(lowerCountObj.status){
        //           saveFlag.add(false)
        //           await transactionManager.releaseTransaction()
        //           return new CommonResponse(false,0,`No RM Rate found for the count ${Number(beforeDecimalValue) + 1}`)
        //         }else{
        //           price = lowerCountObj.data[0].price
        //         }
        //       }
        //     }else{
        //         if(Number(afterDecimalValue) <= 3){
        //           if(!upperCountObj.status){
        //             saveFlag.add(false)
        //             await transactionManager.releaseTransaction()
        //             return new CommonResponse(false,0,`No RM Rate found for the count ${Number(beforeDecimalValue)}`)
        //           }else{
        //             price = upperCountObj.data[0].price
        //           }
        //         }else if(Number(afterDecimalValue) == 4 || Number(afterDecimalValue) == 5){
        //           if(lowerCountObj.status && upperCountObj.status){
        //             const diff = Number(upperCountObj.data[0].price) - Number(lowerCountObj.data[0].price)
        //             const halfdiff = Number(diff)/2
        //             price = Number(upperCountObj.data[0].price) + Math.abs(Number(halfdiff))
        //           }else{
        //             saveFlag.add(false)
        //             await transactionManager.releaseTransaction()
        //            return new CommonResponse(false,0,`No RM Rate found for the count ${Number(beforeDecimalValue)}`)

        //           }
        //         }else{
        //           if(!lowerCountObj.status){
        //             saveFlag.add(false)
        //             await transactionManager.releaseTransaction()
        //             return new CommonResponse(false,0,`No RM Rate found for the count ${Number(beforeDecimalValue) + 1}`)

        //           }else{
        //             price = lowerCountObj.data[0].price
        //           }
        //         }
        //     }
        // }
        // const rmPrice = getRmRate.status ? getRmRate.data[0].price : price

        const grnItemObj = new GrnItems()
        grnItemObj.grnId = req.grnId
        grnItemObj.indentId = req.indentId
        grnItemObj.count = 0
        grnItemObj.farmer = req.farmer
        grnItemObj.farmerCode = req.farmCode
        grnItemObj.price = req.vehilceRequired ? rmRate : Number(rmRate) + 5
        grnItemObj.plantLotNumber = req.batchNumber
        grnItemObj.remarks = req.batchNumber
        grnItemObj.lotNumber = lotNo
        grnItemObj.monthlyRefNo = monthlyRefNo
        grnItemObj.rmRate = rmRate
        grnItemObj.iceRate = req.vehilceRequired ? 0 : 5
        grnItemObj.addonCount = req.addonCount
        grnItemObj.createdUser = req.userName
        grnItemObj.saleOrderId = req.saleOrderId
        grnItemObj.saleOrderItemId = req.saleOrderItemId
        grnItemObj.assignToRm = true
        grnItemObj.mainBatchNumber = req.mainBatchNumber
        grnItemObj.year = year
        grnItemObj.broker = req.broker
        grnItemObj.reweighmentDate = req.reweighmentDate
        grnItemObj.budgetRange = productId[0]?.productId ==1?'Black Tiger': budgetRange.data
        if(grnItemObj.count){
          const count = req.count
          //find count in enum
          let slotVal
          for (const [key, value] of Object.entries(CountRangesEnum)) {
          if (value.includes('-')) {
            const [min, max] = value.split('-').map(Number);
            if (count >= min && count <= max) {
              slotVal= CountRangesEnum[key as keyof typeof CountRangesEnum];
            }
          } else if (value.includes('above')) {
            const min = Number(value.split(' ')[0]);
            if (count > min) {
              slotVal = CountRangesEnum[key as keyof typeof CountRangesEnum];
            }
          } else if (Number(value) === count) {
            slotVal = CountRangesEnum[key as keyof typeof CountRangesEnum];
          }
        }
        console.log(slotVal,'slotttttttttttttttt');
        
        grnItemObj.slot = slotVal
        }
        if(req.count){

        }
        if(budgetRange.status){
        saveGrnItem = await transactionManager.getRepository(GrnItems).save(grnItemObj)
        if(!saveGrnItem){
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in saving Grn Item')
        }
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Budget Range Not found for this month')
     
      }
      }
      let totalBoxes = 0
      let totalQty = 0
      if( req.countQtyInfo.length>0){
      for(const rec of req.countQtyInfo){
        const enObj = new RMReWeighingEntity()
        enObj.carrierType = CarrierType.NETS
        enObj.createdUser = req.createdUser
        enObj.grnId = req.grnId
        enObj.grnItemId = req.addonCount ? saveGrnItem.grnItemId : req.grnItemId
        enObj.indentId = req.indentId
        enObj.noOfCratesOrNets = rec.count
        enObj.quantity = rec.quantity
        enObj.plantId = req.plantId
        totalQty += Number(rec.quantity)
        totalBoxes += Number(rec.count)
        const save = await transactionManager.getRepository(RMReWeighingEntity).save(enObj)
        if(!save){
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in saving reweighment info')
        }
      }
    }
      let defectsQty = 0
      if(req.defectsInfo.length > 0){
        for (const grnItemDefect of req.defectsInfo) {
          defectsQty += Number(grnItemDefect.defectQuantity)
          const grnDefectObj = new GrnItemDefects()
          grnDefectObj.defectId = grnItemDefect.defectId
          grnDefectObj.percentage = grnItemDefect.defectPercentage
          grnDefectObj.quantity = grnItemDefect.defectQuantity
          grnDefectObj.indentId = req.indentId
          grnDefectObj.indentItemId = grnItemDefect.indentItemId
          const grnItemObj = new GrnItems()
          grnItemObj.grnItemId = req.addonCount ? saveGrnItem.grnItemId : req.grnItemId
          grnDefectObj.grnItemsInfo = grnItemObj
          grnDefectObj.grnItemId = req.addonCount ? saveGrnItem.grnItemId : req.grnItemId
          const defectSave = await transactionManager.getRepository(GrnItemDefects).save(grnDefectObj)
          if(!defectSave){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in saving defects')
          }
        }
      }
      if(req.vehicleNumber !== undefined){
        const vehicleNumbersArray = req.vehicleNumber.split(",").map(vehicle => vehicle.trim());
      for(const val of vehicleNumbersArray){
        
        const updateAvalibility = await this.vehicleAssignmentService.getVehicleAssignDetailsByVehicleNum({vehicleNum:val})
        if(updateAvalibility.status){
          const updateVehicle = await this.vehicleervice.updateVehicleAvalibility({vehicleNum:val,isAvailable:true})
          const updateDriver = await this.employeeService.updateAvalibility({id:updateAvalibility.data[0]?.driverId,isAvailable:true})
          if(updateDriver.status && updateVehicle.status){
            saveFlag.add(true)
          }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in updating driver or vehicle availablity')
                    }
                  }
      }
      }
      
      const boxWeight = totalBoxes * Number(GlobalVariableValues.boxWeight)
      const rewighmentQty = totalQty - boxWeight
      if(!(saveFlag.has(false))){
        // let lotNumber  
        // const grnItemAgainstGrn = await transactionManager.getRepository(GrnItems).find({where:{grnId:req.grnId,plantLotNumber:Not(IsNull())}})
        // if(grnItemAgainstGrn.length == 0){
        //   lotNumber = req.batchNumber
        // }else if(grnItemAgainstGrn.length == 1){
        //   lotNumber = req.batchNumber + '/' + 'A'
        // }else{
        //   let codeIndexes =[]
        //   for(const rec of grnItemAgainstGrn){
        //     codeIndexes.push(lotCodeArr.indexOf(rec.plantLotNumber.split('/')[1]))
        //   }
        //   let maxIndex = Math.max(...codeIndexes)
        //   lotNumber = req.batchNumber + '/' + lotCodeArr[maxIndex+1]
        // }
        let updateFlag = new Set<boolean>()
        let updateGrnItem
        if(req.addonCount){
          let quantity
          if(findsameCountExist.length > 0 || req.addonCount){
            quantity = 0
          }else{
            quantity =  rewighmentQty + defectsQty
          }
          if(budgetRange.status){

            updateGrnItem = await transactionManager.getRepository(GrnItems).update({grnItemId:saveGrnItem.grnItemId},{reweighmentBoxes:req.boxes,sampleQuantity:req.sampleQty,samplePieces:req.samplePieces,reweighmentCount:req.count,reweighmentQuantity:rewighmentQty, reweighmentStatus:true,quantity: quantity,reweighmentDate:req.reweighmentDate,budgetRange:productId[0]?.productId==1?'Black Tiger':budgetRange.data,reweighmentBillTo:req.reweighmentBillTo})
          }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Budget Range Not found for this month')
          }
        }else{
          if(budgetRange.status){
          updateGrnItem = await transactionManager.getRepository(GrnItems).update({grnItemId:req.grnItemId},{reweighmentBoxes:req.boxes,sampleQuantity:req.sampleQty,samplePieces:req.samplePieces,reweighmentCount:req.count,reweighmentQuantity:rewighmentQty, reweighmentStatus:true,plantLotNumber:req.batchNumber,remarks:req.batchNumber,mainBatchNumber:req.mainBatchNumber,year:year,reweighmentDate:req.reweighmentDate,budgetRange:productId[0]?.productId==1?'Black Tiger':budgetRange.data,reweighmentBillTo:req.reweighmentBillTo})
        }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Budget Range Not found for this month')
          }
        }
        if(updateGrnItem.affected){
          const findGrn = await transactionManager.getRepository(Grn).find({where:{grnId:req.grnId,reweighmentBillTo:null}})
          if(findGrn.length > 0){
            const updateReweighmentBillTo = await transactionManager.getRepository(Grn).update({grnId:req.grnId},{reweighmentBillTo:req.reweighmentBillTo,vehicleNumber:req.vehicleNumber,sealNumber:req.sealNumber,reweighmentDate:req.reweighmentDate,supervisor:req.supervisor})
            if(!updateReweighmentBillTo.affected){
              updateFlag.add(false)
              console.log('Something went wrong in reweighment Info updation in GRN');

              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in reweighment Info updation in GRN')
            }
          }

          updateFlag.add(true)
        }else{
          updateFlag.add(false)
          
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in GRN items info update')
        }
        if(!updateFlag.has(false)){
          let qty 
          if(req.harvestType == HarvestTypes.Live_Harvest && !req.addonCount){
            const getGrnQty = await transactionManager.getRepository(GrnItems).find({where:{grnItemId:req.grnItemId},select:['quantity']})
            qty = getGrnQty[0].quantity
          }else{
            qty = rewighmentQty
          }
          //production inventory save
          const prodInvReq = new GrnInfoReq(OperationTypeEnum.GRN,req.count,rewighmentQty + defectsQty,req.batchNumber,req.plantId,req.createdUser,req.grnItemId,req.grnId,req.addonCount,year,req.mainBatchNumber,req.antiboiticTestResult,moment(req.reweighmentDate).format('YYYY-MM-DD'))

          const productionInventorySave = await this.prodInvService.createGrnRecordAfterReweighment(prodInvReq)
          if(productionInventorySave.status){
            if(Number(grnItemCount[0].count) == Number(reweighmentCount[0].count) + 1){
              const updateIndentStatus = await transactionManager.getRepository(Indent).update({indentId:grnItemCount[0].indent_id},{indentStatus:Indentstatusenum.CLOSED})
              if(!updateIndentStatus){
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in updating indent status')
              }
            }
            const newLogDto = new LogsDto(1,'create','Reweighment',0,true,'Reweighment Info Save successfully',req.createdUser)
            let logEntry = await this.logService.createLog(newLogDto)
            await transactionManager.completeTransaction()
            return new CommonResponse(true,1,'Saved successfully')
          }else{
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,productionInventorySave.internalMessage)
          }
        }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(true,1,'Something went wrong')
        }
      }
    }catch(err){
      console.log(err,'---')
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Something went wrong')
    }
  }

  async updateReweighmentStatus(req:GrnIdReq):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    const queryManger = getManager()
    try{
      // const lotCodeArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','Y','Z']
      await transactionManager.startTransaction()
      const date = new Date(req.reweighmentDate)
      const reweighmentYear = date.getFullYear()
      const month = date.getMonth()
      const year = Number(month) + 1 < 4 ? Number(reweighmentYear) - 1 : reweighmentYear
      if(req.mainBatchNumber != undefined){
        const batchNumCheckQry = `SELECT * from ${appSettings.rm_procure_db} .grn_items where plant_lot_number = '${req.mainBatchNumber}' and year = ${year}`
        const batchNumCheck = await queryManger.query(batchNumCheckQry)
        if(batchNumCheck.length > 0){
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Batch Number already existed')
        }
      }
      const updateBatchNumber = await transactionManager.getRepository(Grn).update({grnId:req.grnId},{reweighmentBillTo:req.reweighmentBillTo,vehicleNumber:req.vehicleNumber,sealNumber:req.sealNumber,reweighmentDate:req.reweighmentDate,supervisor:req.supervisor})
      if(!updateBatchNumber.affected){
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong in batch number updation')
      }else{
        const saveFlag = new Set<boolean>()
        const findGrnItemId = await transactionManager.getRepository(GrnItems).find({where:{grnId:req.grnId}})
        if(req.vehicleNumber !== undefined){
          const vehicleNumbersArray = req.vehicleNumber.split(",").map(vehicle => vehicle.trim());
        for(const val of vehicleNumbersArray){
          
          const updateAvalibility = await this.vehicleAssignmentService.getVehicleAssignDetailsByVehicleNum({vehicleNum:val})
          console.log(updateAvalibility,'oooooooooo');
          
          if(updateAvalibility.status){
            const updateVehicle = await this.vehicleervice.updateVehicleAvalibility({vehicleNum:val,isAvailable:true})
            // console.log(updateVehicle,'updateVehicle');

            const updateDriver = await this.employeeService.updateAvalibility({id:updateAvalibility.data[0]?.driverId,isAvailable:true})
            // console.log(updateDriver,'driverrrrrr');
            
            if(updateDriver.status && updateVehicle.status){
              saveFlag.add(true)

            }else{
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in updating driver or vehicle availablity')
                      }
                    }
        }
        }
        for(const rec of findGrnItemId){
          // console.log( rec.count,'reccccccccccc');
          // console.log( req.countWiseBatchNum.map(e => {return(e.count)}),'lottttttttttt');
          // console.log(req.countWiseBatchNum.filter(e => {return(e.count === rec.count)}),'budgettttttttt');
          const lotNumber = req.countWiseBatchNum.filter(e => {return(e.grnItemId === rec.grnItemId)})[0].batchNumber
          let mainLotNumber
          if(req.mainBatchNumber == undefined){
            mainLotNumber = lotNumber
          }else{
            mainLotNumber = req.mainBatchNumber
          }
          const batchNumCheckQry = `SELECT * from ${appSettings.rm_procure_db} .grn_items where plant_lot_number = '${lotNumber}' and year = ${year}`
          const batchNumCheck = await queryManger.query(batchNumCheckQry)
          if(batchNumCheck.length > 0){
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Batch Number already existed')
          }

          const budgetRangeReq = new RmBudgetInfoReq(rec.count,req.reweighmentDate)
          const budgetRange = await this.rmBudgetService.getBudgetRangeAgainstCount(budgetRangeReq)
          // console.log(budgetRange,'oooooodwqhbbbbbj');
          
          // const productIdByGrnItem = `SELECT product FROM grn_items gi WHERE gi.grn_item_id = ${req.grnItemId}`
          // const productId = await queryManger.query(productIdByGrnItem)
          
          // const grnItemAgainstGrn = await transactionManager.getRepository(GrnItems).find({where:{grnId:req.grnId,plantLotNumber:Not(IsNull())}})
          // if(grnItemAgainstGrn.length == 0){
          //   lotNumber = req.batchNumber
          // }else if(grnItemAgainstGrn.length == 1){
          //   lotNumber = req.batchNumber + '-' + 'A'
          // }else{
          //   let codeIndexes =[]
          //   for(const rec of grnItemAgainstGrn){
          //     codeIndexes.push(lotCodeArr.indexOf(rec.plantLotNumber.split('/')[1]))
          //   }
          //   let maxIndex = Math.max(...codeIndexes)
          //   lotNumber = req.batchNumber + '-' + lotCodeArr[maxIndex+1]
          // }
          if(budgetRange.status){

         
          const update = await transactionManager.getRepository(GrnItems).update({grnItemId:rec.grnItemId},{reweighmentStatus:true,plantLotNumber:lotNumber,remarks:lotNumber,year:year,mainBatchNumber:mainLotNumber,reweighmentDate:req.reweighmentDate,budgetRange:rec.product==1?'Black Tiger':budgetRange.data,reweighmentBillTo:req.reweighmentBillTo})
          if(!update.affected){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in updating reweighment status')
          }
         }else{
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Rm Budget not found for the month of this reweighment date')
         
        }
          //production inventory save
          const prodInvReq = new GrnInfoReq(OperationTypeEnum.GRN,Number(rec.count),rec.quantity,lotNumber,req.plantId,req.createdUser,rec.grnItemId,null,null,year,mainLotNumber,rec.testResult,moment(req.reweighmentDate).format('YYYY-MM-DD'))
          const productionInventorySave = await this.prodInvService.createGrnRecordAfterReweighment(prodInvReq)
          if(!(productionInventorySave.status)){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in production inventory updation')
          }
        }
        if(!(saveFlag.has(false))){
          const updateIndentStatus = await transactionManager.getRepository(Indent).update({indentId:findGrnItemId[0].indentId},{indentStatus:Indentstatusenum.CLOSED})
          if(!updateIndentStatus.affected){
            await transactionManager.releaseTransaction()
           return new CommonResponse(false,0,'Something went wrong in updating indent status')
          }
          const newLogDto = new LogsDto(1,'Update','Grn Items',0,true,'Reweighment Status Updated in GRN Items',req.createdUser)
          let logEntry = await this.logService.createLog(newLogDto)
          await transactionManager.completeTransaction()
          return new CommonResponse(true,1,'Updated successfully')
        }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong')
        }
      }
    }catch(err){
      console.log(err);
      
      await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong')
    }
  }

  async getGrnNumbersDropdownForReweighment():Promise<CommonResponse>{
    const manager = getManager()
    try{
      // const data = await this.grnItemRepository.find({where:{reweighmentStatus:false}})
      const dataQuery = `select gi.grn_id as grnId,g.grn_number as grnNumber,g.indent_no as indentId,i.harvest_type as harvestType,gi.indent_item_id as indentItemId,IF(i.supplier_type = 'Dealer', bs.name,fs.name) AS supplierName,ii.farmer,ii.farmer_code as farmerCode,ii.broker,i.is_vehicle_required as vehicleRequired,GROUP_CONCAT(DISTINCT(gi.count)) AS count
      from ${appSettings.rm_procure_db} .grn_items gi
      left join ${appSettings.rm_procure_db} .grn g on g.grn_id = gi.grn_id
      left join ${appSettings.rm_procure_db} .indent i on i.indent_id = gi.indent_id
      LEFT JOIN ${appSettings.rm_procure_db} . indent_items ii ON ii.indent_id = i.indent_id
      LEFT JOIN ${appSettings.masters_db} .suppliers bs ON  bs.supplier_id= ii.broker
      LEFT JOIN ${appSettings.masters_db} .suppliers fs ON  fs.supplier_id= ii.farmer
      where gi.reweighment_status = 0 and assign_to_rm = 1 and gi.is_active = 1 and gi.test_result = 'PASS'
      group by g.grn_id`
      const data = await manager.query(dataQuery)
      if(data.length > 0){
        return new CommonResponse(true,1,'Data retrieved',data)
      }else{
        return new CommonResponse(false,0,'No data found')
      } 

    }catch(err){
      throw err
    }
  }

  // async getGrnInfoForPriceAccpetance(req:InvoiceStatusReq):Promise<CommonResponse>{
  //   const manager = getManager()
  //   try{
  //     let dataQuery = `select g.grn_id,g.grn_number,i.indent_code,g.supplier_type,s.name,s.code,gi.lot_number,gi.count,gi.price,gi.approved_price,
  //     IF(i.harvest_type = 'LIVE HARVEST',gi.quantity,gi.reweighment_quantity) AS quantity, ri.invoice_number as invoiceNumber,ri. bill_to,
  //     from ${appSettings.rm_procure_db} .grn g
  //     left join ${appSettings.rm_procure_db}.rm_invoice ri on ri.grn_id = g.grn_id
  //     left join ${appSettings.rm_procure_db} .grn_items gi on gi.grn_id = g.grn_id
  //     left join ${appSettings.rm_procure_db} .indent i on i.indent_id = g.indent_no
  //     left join ${appSettings.masters_db} .suppliers s on s.supplier_id = gi.farmer
  //     where g.grn_id > 0 and g.inv_status ='${req.status}'`
  //     if(req.grnId){
  //       dataQuery += ` and g.grn_id = ${req.grnId}`
  //     }
  //     if(req.indentId){
  //       dataQuery += ` and i.indent_id = ${req.indentId}`
  //     }
  //    const data = await manager.query(dataQuery)
  //    if(data.length > 0){
  //     const dataMap = new Map<number,PriceAccpetanceModel>()
  //     for(const rec of data){
  //       if(!dataMap.has(rec.grn_id)){
  //         dataMap.set(rec.grn_id, new PriceAccpetanceModel(rec.grn_id,rec.grn_number,rec.indent_code,rec.supplier_type,rec.name,rec.code,rec.inv_no,[]))
  //       }
  //       dataMap.get(rec.grn_id).grnItemInfo.push(new GrnItemInfoForPriceApproval(rec.lot_number,rec.count,rec.quantity,rec.price,rec.approved_price))
  //     }
  //     const dataModel : PriceAccpetanceModel[] =[]
  //     dataMap.forEach(e => dataModel.push(e))
  //     return new CommonResponse(true,1,'Data retreived',dataModel)
  //    }else{
  //     return new CommonResponse(false,0,'No data found')
  //    }
  //   }catch(err){
  //     throw err
  //   }
  // }

  async getGrnInfoForPriceAccpetance(req:InvoiceStatusReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
        let dataQuery = `SELECT ri.rm_invoice_id,ri.invoice_number AS invoiceNumber,ri.bill_to,ri.grn_id, ri.total_amount AS totalAmount,
ri.bill_to_type AS billToType,
g.grn_id,g.grn_number,g.supplier_type,
gi.lot_number,ri.unit_price AS approvedPrice,
CASE 
        WHEN ri.type = 'DEFECT' THEN 0
        ELSE gi.price
    END AS price,
ri.count AS count,
ri.quantity AS quantity,
ii.broker AS dealerId,i.indent_code AS indentNumber,
 ri.batch_number AS batchNumber,ri.type,
d.defect_name AS defect,d.defect_id,sf.code AS supplierCode,
 CASE
        WHEN si.name IS NOT NULL THEN si.name
        ELSE s.name
    END AS supplierName,
 CASE
        WHEN ri.bill_to_type = 'farmer' THEN sf.name
        ELSE ri.financier_name
    END AS financierName,
si.name AS dealerName,sf.name AS farmerName,sf.supplier_id,ri.invoice_remarks as remarks
FROM erpx_dev_rm_procurement.grn g
LEFT JOIN erpx_dev_rm_procurement.rm_invoice ri ON ri.grn_id=g.grn_id
LEFT JOIN erpx_dev_rm_procurement.grn_items gi ON gi.grn_id = g.grn_id
LEFT JOIN erpx_dev_rm_procurement.indent i ON i.indent_id = g.indent_no
LEFT JOIN erpx_dev_rm_procurement.indent_items ii ON ii.indent_id = gi.indent_id
LEFT JOIN erpx_dev_masters.suppliers s ON s.supplier_id = gi.farmer
LEFT JOIN erpx_dev_masters.suppliers sf ON sf.supplier_id = ri.bill_to
LEFT JOIN erpx_dev_masters.suppliers si ON si.supplier_id = ii.broker
left join erpx_dev_rm_procurement.grn_item_defects gid on gid.grn_item__defects_id  = ri.defect_id
LEFT JOIN erpx_dev_masters.defect d ON gid.defect_id= d.defect_id 


  

        WHERE g.grn_id > 0 AND ri.inv_status ='${req.status}'`

        if(req.grnId){
            dataQuery += ` AND ri.grn_id = ${req.grnId}`
        }
        if(req.indentId){
            dataQuery += ` AND ri.indent_id = ${req.indentId}`
        }

        dataQuery += ` GROUP BY rm_invoice_id`


        const data = await manager.query(dataQuery)
        if(data.length > 0){
            const dataMap = new Map<number,PriceAccpetanceModel>()
            for(const rec of data){

                if(!dataMap.has(rec.grn_number)){
                    dataMap.set(rec.grn_number, new PriceAccpetanceModel(
                        rec.grn_id,
                        rec.grn_number,
                        rec.indentNumber,
                        rec.supplier_type,
                        rec.supplierName,
                        rec.supplierCode,
                        rec.invoiceNumber,
                        rec.farmerName,
                        [],
                        rec.billToType,
                        rec.financierName,

                    ))
                }
                dataMap.get(rec.grn_number).grnItemInfo.push(new GrnItemInfoForPriceApproval(
                    rec.lot_number,
                    rec.count,
                    rec.quantity,
                    rec.price,
                    rec.totalAmount,
                    rec.batchNumber,
                    rec.remarks,
                    rec.type,
                    rec.defect,
                    rec.approvedPrice
                ))
            }
            const dataModel : PriceAccpetanceModel[] =[]

            dataMap.forEach(e => dataModel.push(e))
            return new CommonResponse(true,1,'Data retreived',dataModel)
        } else {
            return new CommonResponse(false,0,'No data found')
        }
    } catch(err){
        throw err
    }
}


  async updateInvoiceStatus(req:GrnIdReq):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    try{
      await transactionManager.startTransaction()
      const updateStatusInGrn = await transactionManager.getRepository(Grn).update({grnId:req.grnId},{invoiceStatus:InvoiceStatusEnum.CLOSE})
      if(updateStatusInGrn.affected){
        const updateInvStatusInRmInvoice = await transactionManager.getRepository(RmInvoice).update({grnId:req.grnId},{invoiceStatus:InvoiceStatusEnum.APPROVED})
        if(updateInvStatusInRmInvoice.affected){
          const newLogDto = new LogsDto(1,'Update','Grn Items',0,true,'Invoice Status Updated in GRN Items',req.createdUser)
          let logEntry = await this.logService.createLog(newLogDto)
          await transactionManager.completeTransaction()
          return new CommonResponse(true,1,'Updated successfully')
        }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in updating invoice status in Rm Invoice')
        }
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong in updating GRN invoice status')
      }

    }catch(err){
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Somethign went wrong')
    }
  }

  async getGrnNumberDropdownForPriceApproval(req:InvoiceStatusReq) :Promise<CommonResponse>{
    const manager = getManager()
    try{
      // const getInfo = await this.grnRepository.find({select:['grnId','grnNumber'],where:{invoiceStatus:req.status}})
      const getQuery = `select  ri.grn_id as grnId,g.grn_number as grnNumber
      from ${appSettings.rm_procure_db}.rm_invoice ri
      left join ${appSettings.rm_procure_db}.grn g on g.grn_id = ri.grn_id
        where  ri.inv_status = '${req.status}' 
        group by ri.grn_id`
      const getInfo = await manager.query(getQuery)
      if(getInfo.length >0){
        return new CommonResponse(true,1,'Data retrieved',getInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getIndentNumberDropdownForPriceApproval(req:InvoiceStatusReq) :Promise<CommonResponse>{
    const manager = getManager()
    try{
      // const getInfo = await this.grnRepository.find({select:['grnId','grnNumber'],where:{invoiceStatus:req.status}})
      const getQuery = `select  ri.indent_id as indentId, i.indent_code  as indentNumber
      from ${appSettings.rm_procure_db}.rm_invoice ri
      left join ${appSettings.rm_procure_db} .indent i on i. indent_id = ri. indent_id
      where inv_status = '${req.status}'
      group by ri.indent_id`
      
      
      const getInfo = await manager.query(getQuery)
      if(getInfo.length >0){
        return new CommonResponse(true,1,'Data retrieved',getInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getRMInvoicePrint(req:RMInvoicePrintReq): Promise<CommonResponse> {
    try {
      let query = ` SELECT  DISTINCT(ri.rm_invoice_id),ri.bill_to_type AS billToType,ri.invoice_number AS invoiceNumber,ri.unit_price AS unitPrice,ri.invoice_date AS invoiceDate,
        i.harvest_type AS harvestType,ii.broker,grn.vehicle_number,
        pr.name AS productName,
        su.name AS supplierName,d.name AS dealerName,
        ri.bill_to_type AS billToType,git.tds_applicable AS tdsApplicable,
        git.plant_lot_number AS batchNumber,git.farmer,git.quantity AS grnQuantity,git.inv_remarks,git.count,git.product,git.price AS approvedPrice,git.reweighment_quantity AS reweighmentQuantity,git.taxable_amount as taxableAmount,
        grn.reweighment_bill_to AS address,grn.grn_number,grn.vehicle_number,git.reweighment_count AS reweighmentCount,def.defect_name AS defectName,gid.quantity AS defectQuantity,ri.type AS invoiceType,ri.invoice_remarks as rmInvoiceRemarks,
        TRIM(
           CONCAT(
               IFNULL(su.apartment, ''),
               CASE WHEN su.apartment IS NOT NULL AND su.street IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(su.street, ''),
               CASE WHEN su.street IS NOT NULL AND su.city IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(su.city, ''),
               CASE WHEN su.city IS NOT NULL AND su.district IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(su.district, ''),
               CASE WHEN su.district IS NOT NULL AND su.state IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(su.state, ''),
               CASE WHEN su.state IS NOT NULL AND su.postal_code IS NOT NULL THEN '-' ELSE '' END,
               IFNULL(su.postal_code, '')
           )
       ) AS supplierAddress,
        CASE
        WHEN ri.bill_to_type = 'Farmer' THEN sup.name
        ELSE ri.financier_name
    END AS financierName,
     TRIM(
            CONCAT(
               IFNULL(d.apartment, ''),
               CASE WHEN d.apartment IS NOT NULL AND d.street IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(d.street, ''),
               CASE WHEN d.street IS NOT NULL AND d.city IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(d.city, ''),
               CASE WHEN d.city IS NOT NULL AND d.district IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(d.district, ''),
               CASE WHEN d.district IS NOT NULL AND d.state IS NOT NULL THEN ', ' ELSE '' END,
               IFNULL(d.state, ''),
               CASE WHEN d.state IS NOT NULL AND d.postal_code IS NOT NULL THEN '-' ELSE '' END,
               IFNULL(d.postal_code, '')
           )
       ) AS dealerAddress
        FROM erpx_dev_rm_procurement.rm_invoice ri
        LEFT JOIN erpx_dev_rm_procurement.indent i ON i.indent_id=ri.indent_id
        LEFT JOIN  erpx_dev_rm_procurement.indent_items ii ON ii.indent_id=ri.indent_id
        LEFT JOIN erpx_dev_rm_procurement.grn_items git ON git.grn_item_id=ri.grn_item_id
        LEFT JOIN erpx_dev_masters.products pr ON pr.product_id=git.product
        LEFT JOIN erpx_dev_masters.suppliers sup ON sup.supplier_id = ri.bill_to
        LEFT JOIN erpx_dev_masters.suppliers su ON su.supplier_id=ii.farmer
        LEFT JOIN erpx_dev_masters.suppliers d ON d.supplier_id=ii.broker
        LEFT JOIN erpx_dev_rm_procurement.grn grn ON grn.indent_no=ri.indent_id
        LEFT JOIN erpx_dev_rm_procurement.grn_item_defects gid ON gid.grn_item__defects_id=ri.defect_id
        LEFT JOIN erpx_dev_masters.defect def ON def.defect_id=gid.defect_id
       WHERE 
       ri.invoice_number = '${req.invoiceNumber}'
      `
      const data = await this.grnRepository.query(query);

    if (data.length > 0) {
      const distinctBatchNumbers = [...new Set(data.map(item => item.batchNumber))].join(', ');
      const result = data.map(item => ({
        ...item,
        batchNumbers: distinctBatchNumbers
      }));

      return new CommonResponse(true, 0, "RM Invoice Details retrieved successfully", result);
    } else {
      return new CommonResponse(false, 1, "No data found", []);
    }
  } catch (err) {
    throw err;
  }
}


  async getReWeightMentInfo(req: ReWeighmentInfo): Promise<ReWeighMentResponseModel>{
    try{
      const manager = getManager()
      // const customer = getCustomer()
     // const reWeighData = await this.reweighmentRepo.find({
        // where: {
        //   grnId: req.grnId,
        //   grnItemId: req.grnItemId,
        // }
    //  });

      //  const detailview =`SELECT 
      //  gi.reweighment_boxes as reweighmentboxes,
      //   gi.sample_quantity as sampleQuantity,
      //  gi.sample_pieces as samplePieces,
      //   gi.reweighment_count as reweighmentCount
      //   from ${appSettings.rm_procure_db} .gm_items gi
      //   left join ${appSettings.rm_procure_db} .grn_items gi  ON gi. grn_item_id = gid. grn_item_id
      //   WHERE  gi.grn_item_id =${req.grnItemId}`
      //   console.log( detailview,'-------------------')
      //   const reqdata = await manager.query(detailview)
        const detailview =`SELECT 
        gi.reweighment_boxes AS reweighmentboxes,
        gi.sample_quantity AS sampleQuantity,
        gi.sample_pieces AS samplePieces,
        gi.reweighment_count AS reweighmentCount,
        rew.no_of_crates_or_nets As noOfCratesOrNets,
        rew.quantity 
    FROM 
    ${appSettings.rm_procure_db}.rm_re_weighing rew
    LEFT JOIN 
    ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rew.grn_item_id
    WHERE  
        gi.grn_item_id = ${req.grnItemId}`
        console.log(detailview,'-------')
          const reqdata = await manager.query(detailview)
    


      const defectQuery =`SELECT gid.grn_item_id as grnItemId, gid.defect_id as defectId , 
      gid.quantity as quantity,gid.percentage,d.defect_name as defectName
      from ${appSettings.rm_procure_db} .grn_item_defects gid
      left join ${appSettings.masters_db} .defect d ON d.defect_id = gid.defect_id
      WHERE gid.grn_item_id = ${req.grnItemId}`
      const getdata = await manager.query(defectQuery)
      console.log(defectQuery,"-=============================================")

      const defectData = []
      if(getdata.length > 0){
      for(const rec of getdata){
        defectData.push(new  ReWeighMentDefectsModel (rec.defectId,rec.quantity, rec.percentage,rec.defectName))
      }
      }
      const info = []
      if(reqdata.length > 0){
        for(const rec of reqdata){
          info.push(new ReWeighMentModelDto(rec.noOfCratesOrNets,rec.quantity))
        }
      }
      const resultObj = new ReweighmentInfoModel(reqdata[0]?.reweighmentboxes, reqdata[0]?.sampleQuantity,reqdata[0]?.samplePieces,reqdata[0]?.reweighmentCount,info,defectData) 
      return new ReWeighMentResponseModel(true, 0, "Re-weighment data retrieved successfully", resultObj)

    }catch(err){
      return new ReWeighMentResponseModel(false, 1, "Error while fetching re-weighment data", err)

    }

  }

  async getGrnItemInfoForReweighment(req:RmInvoiceReq):Promise<ReWeighMentViewResponseModel>{
    const manager = getManager()
    try{
      let infoQuery = `SELECT gi.grn_item_id AS grnItemId,g.grn_id AS grnId,gi.indent_id AS indentId,i.indent_code AS indentNumber,g.plant_id AS plantId,g.reweighment_bill_to AS reweighmentBillTo,gi.lot_number as lotNumber,gi.quantity,gi.count,gi.price,g.grn_date as grnDate,g.vehicle_number as vehicleNumber,gi.sale_order_id as saleOrderId,gi.sale_order_item_id as saleOrderItemId,i.vehicle_assigned as isVehicleRequired,gi.test_result as antibioticTestResult
      FROM ${appSettings.rm_procure_db} .grn_items gi
      LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id
      WHERE gi.grn_item_id > 0 AND gi.reweighment_status = 0 AND gi.test_result ='PASS' AND gi.antibiotics_test_status='COMPLETED' AND gi.grn_id = ${req.grnId} AND gi.is_active = 1 and gi.assign_to_rm = 1
      GROUP BY gi.grn_item_id `
      // if(req.grnId != undefined){
      //   infoQuery += ` and gi.grn_id = ${req.grnId}`
      // }
      const data = await manager.query(infoQuery)
      // let refinfo
      // if(data.length > 0){
      //   let grnYear = new Date(data[0].grnDate).getFullYear()
      //   let grnMonth = new Date(data[0].grnDate).getMonth() + 1
      //   let getGrnQuery
      //   if(grnMonth >= 4){
      //     getGrnQuery= `SELECT MAX(ref_no) as refNumber,u.company FROM ${appSettings.rm_procure_db} .grn g left join ${appSettings.masters_db} .unitcodes u on u.company = g.reweighment_bill_to where year(grn_date) = ${grnYear} and month(grn_date) >= 4 group by u.company`
         
      //   }else{
      //     getGrnQuery = `SELECT MAX(ref_no) as refNumber,u.company FROM ${appSettings.rm_procure_db} .grn g left join ${appSettings.masters_db} .unitcodes u on u.company = g.reweighment_bill_to where year(grn_date) = ${grnYear} and month(grn_date) < 4 group by u.company`
      //   }
      //   refinfo = await manager.query(getGrnQuery)
      //   console.log(refinfo,'============')
      //   // if(refinfo.length > 0){
      //   //   refNo = refinfo[0].refNumber + 1
      //   // }else{
      //   //   refNo = 1
      //   // }
      // }
      if(data.length > 0){
        return new ReWeighMentViewResponseModel(true,1,'Data retrieved',data)
      }else{
        const qry = ` SELECT g.grn_id AS grnId,gi.indent_id AS indentId,i.indent_code AS indentNumber,g.plant_id AS plantId,g.reweighment_bill_to AS reweighmentBillTo,
        g.grn_date AS grnDate,g.vehicle_number AS vehicleNumber,gi.sale_order_id AS saleOrderId,
        gi.sale_order_item_id AS saleOrderItemId,i.vehicle_assigned AS isVehicleRequired
        FROM ${appSettings.rm_procure_db} .grn g
        LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_id = g.grn_id
        LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id 
        WHERE gi.grn_item_id > 0  AND gi.grn_id = 5 AND gi.is_active = 1 AND gi.assign_to_rm = 1
        GROUP BY g.grn_id`
        const info = await manager.query(qry)
        if(info.length > 0){
          return new ReWeighMentViewResponseModel(true,1,'Data retrieved',info)
        }else{
        return new ReWeighMentViewResponseModel(false,0,'No data found')

      }
    }

    }catch(err){
      throw err
    }
  }

  
  async getPlantLotNumbers():Promise<CommonResponse>{
    const manager = getManager()
    try{
   let query = `select DISTINCT(plant_lot_number) as plantLotNumber,year from grn_items WHERE plant_lot_number IS NOT NULL `
    // group by plant_lot_number
      const data = await manager.query(query)
      if(data.length > 0){
        return new CommonResponse(true,1,'Data retrieved',data)
      }else{
        return new CommonResponse(false,0,'No data found')

      }

    }catch(err){
      throw err
    }
  }

  async getRefNoInfoAgainstCompany(req:RmInvoiceReq):Promise<CommonResponse>{
    const queryManger = getManager()
    try{
      let refNo
      const getGrnDate = await this.grnRepository.find({where:{grnId:req.grnId}})
      let grnYear = new Date(getGrnDate[0].grnDate).getFullYear()
      let grnMonth = new Date(getGrnDate[0].grnDate).getMonth() + 1
      let getGrnQuery
      if(grnMonth >= 4){
        getGrnQuery= `SELECT MAX(ref_no) as refNumber FROM ${appSettings.rm_procure_db} .grn g left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = g.plant_id where u.company = '${req.company}' and year(grn_date) = ${grnYear} and month(grn_date) >= 4 and reweighment_bill_to IS NOT NULL`
       
      }else{
        getGrnQuery = `SELECT MAX(ref_no) as refNumber FROM ${appSettings.rm_procure_db} .grn g left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = g.plant_id where u.company = '${req.company}' and year(grn_date) = ${grnYear} and month(grn_date) < 4 and reweighment_bill_to IS NOT NULL`
      }
      const refinfo = await queryManger.query(getGrnQuery)
      if(refinfo.length > 0){
        refNo = refinfo[0].refNumber + 1
      }else{
        refNo = 1
      }
      refNo = refNo + ''
      while (refNo.length < 4) refNo = "0" + refNo;
      return new CommonResponse(true,1,'Data retrieved',refNo)
    }catch(err){
      throw err
    }
  }
  async getReweighmentDetails(req:rmReweighmentreq):Promise<CommonResponse>{
    const manager= getManager()
    try{
      let query1 =`select gi.count, gi.grn_id as grnId, gi.indent_id as indentId, g.grn_id as grnId, g.grn_number as grnNumber,  gi.plant_lot_number   as batchNumber,
      i.indent_id as indentId , i.indent_code as indentCode, s.supplier_id as supplierId, s. name  as farmer, gi.farmer as farmerId,gi.reweighment_status, i. harvest_type as harvestType, gi.grn_item_id as grnItemId,gi.reweighment_count as reCount,g.reweighment_date as reweighmentDate
     from ${appSettings.rm_procure_db}.grn_items gi
     left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gi.grn_id
     left join ${appSettings.rm_procure_db}.indent i on i.indent_id =gi.indent_id
     left join ${appSettings.masters_db}.suppliers s on s.supplier_id = gi.farmer
     where gi.grn_item_id > 0 `
     if(req.tabName == 'OPEN'){
      query1 += ` and gi.reweighment_status = 0`
    }
    if(req.tabName == 'CLOSED'){
      query1 += ` and gi.reweighment_status = 1`
    } 
    if(req.farmerId){
      query1 += `and gi.farmer = ${req.farmerId}`
    }
    if
    (req.grnId){
      query1 += ` and gi.grn_id =${req.grnId}`
    }
    const obtain= await manager.query(query1)
    if(obtain.length > 0){
      return new CommonResponse(true,1,'Data retrieved',obtain)
    }else{
      return new CommonResponse(false,0,'No data found')
    }

    }catch(err){
      throw err
  }
}
 async getGrnDropDownDetails():Promise<CommonResponse>{
  try{
    const manager = getManager()
      let query2 = `select  g.grn_number as grnNumber,gi.grn_id as grnId
      from ${appSettings.rm_procure_db}.grn_items gi
      left join ${appSettings.rm_procure_db}.grn g on g.grn_id  = gi.grn_id
      group by g.grn_number`
      const dropinfo = await manager.query(query2)
      if(dropinfo.length>0){
        return new CommonResponse(true, 1,'Data retrieved successfully', dropinfo)
      }else{
        return new CommonResponse(false, 0,'No data found',[])
      }
      
    }catch(err){
      throw(err)
    }
  }
 
  async getFarmerDropDown():Promise<CommonResponse>{
    try{
      const manager = getManager()
      let query3 =`select s. name  as farmer,gi.farmer as farmerId,s.supplier_id as supplierId
      from  ${appSettings.rm_procure_db}.grn_items gi
      left join ${appSettings.masters_db}.suppliers s on s.supplier_id  = gi.farmer
      group by gi.farmer`
      const farmerinfo = await manager.query(query3)
      if(farmerinfo.length>0){
        return new CommonResponse(true, 1,'Data retrieved successfully', farmerinfo)
      }else{
        return new CommonResponse(false, 0,'No data found',[])
      }
    }catch(err){
      throw(err)
  }
 }

 async updateReweighmentRemovedCount(req:GrnItemIdRequest):Promise<CommonResponse>{
  try{
    const update = await this.grnItemRepository.update({grnItemId:req.grnItemId},{isActive:false})
    if(update.affected){
      return new CommonResponse(true,0,'Updated successfully')
    }else{
      return new CommonResponse(false,0,'Something went wrong')
    }

  }catch(err){
    throw err
  }
}

async getBatchNumberDropdownForInvoice():Promise<CommonResponse>{
  try{
    const manager = getManager()
    // const info = await this.grnItemRepository.find({select:['plantLotNumber']})
    const infoQuery = `select plant_lot_number as batchNumber,year,grn_item_id as grnItemId from ${appSettings.rm_procure_db} .grn_items where plant_lot_number is not null and inv_status = '${InvoiceStatusEnum.OPEN}'`
    const info = await manager.query(infoQuery)
    if(info.length >0){
      return new CommonResponse(true,1,'Data retrieved',info)
    }else{
      return new CommonResponse(false,0,'No data found')
    }

  }catch(err){
    throw err
  }
}

  async updateYieldPer(req:YieldPerReq):Promise<CommonResponse>{
    try{
      const update = await this.grnItemRepository.update({mainBatchNumber:req.batchNumber,year:req.year},{yieldPer:req.yieldPer})
      if(!update){
        return new CommonResponse(false,0,'Somethign went wrong in updating yield percentage')
      }else{
        return new CommonResponse(true,1,'Updated successfully')
      }

    }catch(err){
      throw err
    }
  }

  // async getGrnItemsForRmBudgetReport(month?: number, year?: number): Promise<CommonResponse> {
  //   try {
  //     const manager = getManager();
      
  //     // Creating a mapping for month numbers to their corresponding month names
  //     const monthMapping: { [key: number]: string } = {
  //       1: 'January',
  //       2: 'February',
  //       3: 'March',
  //       4: 'April',
  //       5: 'May',
  //       6: 'June',
  //       7: 'July',
  //       8: 'August',
  //       9: 'September',
  //       10: 'October',
  //       11: 'November',
  //       12: 'December'
  //     };
      
  //     // Get the month name from the month number
  //     let monthName: string | undefined;
  //     if (month) {
  //       monthName = monthMapping[month];
  //     }
  
  //     let infoQuery = `SELECT i.assign_lead_1, grni.count, rmb.count AS budgetCount, 
  //       MONTH(grni.created_at) AS grnBudgetMonth, YEAR(grni.created_at) AS grnBudgetYear, 
  //       SUM(grni.quantity) AS grnQuantity, SUM(rmb.quantity) AS budgetQuantity, rmb.month, rmb.year, 
  //       emp.employee_name AS employeeName, rmb.procurement_manager_id, grni.grn_item_id, 
  //       grni.grn_id, grni.indent_id
  //       FROM erpx_dev_rm_procurement.grn_items grni
  //       LEFT JOIN erpx_dev_rm_procurement.indent i ON i.indent_id = grni.indent_id
  //       LEFT JOIN erpx_dev_masters.rm_budget rmb ON MONTH(grni.created_at) = rmb.month AND YEAR(grni.created_at) = rmb.year AND grni.count = rmb.count
  //       LEFT JOIN erpx_dev_masters.employee_details emp ON emp.employee_id = i.assign_lead_1
  //       WHERE 1
  //       ${month ? ' AND MONTH(grni.created_at) = ' + month : ''}
  //       ${year ? ' AND YEAR(grni.created_at) = ' + year : ''}
  //       GROUP BY i.assign_lead_1, grni.count, YEAR(grni.created_at), MONTH(grni.created_at)
        
  //       UNION
        
  //       SELECT i.assign_lead_1, grni.count, rmb.count AS budgetCount, 
  //       MONTH(rmb.month) AS grnBudgetMonth, YEAR(rmb.year) AS grnBudgetYear, 
  //       0 AS grnQuantity, SUM(rmb.quantity) AS budgetQuantity, rmb.month, rmb.year, 
  //       emp.employee_name AS employeeName, rmb.procurement_manager_id, NULL AS grn_item_id, 
  //       NULL AS grn_id, NULL AS indent_id
  //       FROM erpx_dev_masters.rm_budget rmb
  //       LEFT JOIN erpx_dev_rm_procurement.grn_items grni ON MONTH(grni.created_at) = rmb.month AND YEAR(grni.created_at) = rmb.year AND grni.count = rmb.count
  //       LEFT JOIN erpx_dev_rm_procurement.indent i ON i.indent_id = grni.indent_id
  //       LEFT JOIN erpx_dev_masters.employee_details emp ON emp.employee_id = rmb.procurement_manager_id
  //       WHERE grni.count IS NULL
  //       ${monthName ? ' AND rmb.month = "' + monthName + '"' : ''}
  //       ${year ? ' AND rmb.year = ' + year : ''}
  //       GROUP BY rmb.procurement_manager_id, rmb.count, rmb.year, rmb.month
  //     `;
  
  //     const info = await manager.query(infoQuery);
  //     if (info.length > 0) {
  //       return new CommonResponse(true, 1, 'Data retrieved', info);
  //     } else {
  //       return new CommonResponse(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     throw err;
  //   }
  // }
  

  async getGrnItemsForRmBudgetReport(month?: number, year?: number): Promise<CommonResponse> {
    try {
      const manager = getManager();
      const monthMapping: { [key: number]: string } = {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December'
      };
      let monthName: string | undefined;
      if (month) {
        monthName = monthMapping[month];
      }
  
      let infoQuery = `
        SELECT 
          i.assign_lead_1,
          grni.count,
          MONTH(grni.created_at) AS grnBudgetMonth,
          YEAR(grni.created_at) AS grnBudgetYear,
          SUM(grni.quantity) AS grnQuantity,
          rmb.quantity AS budgetQuantity,
          rmb.count AS budgetCount,
          rmb.month,
          rmb.year,
          emp.employee_name AS employeeName,
          rmb.procurement_manager_id,
          grni.grn_item_id,
          grni.grn_id,
          grni.indent_id
        FROM erpx_dev_rm_procurement.grn_items grni
        LEFT JOIN erpx_dev_rm_procurement.indent i ON i.indent_id = grni.indent_id
        LEFT JOIN erpx_dev_masters.rm_budget rmb 
          ON grni.count = rmb.count 
          AND YEAR(grni.created_at) = rmb.year 
          AND MONTH(grni.created_at) = MONTH(STR_TO_DATE(CONCAT('1 ', rmb.month, ' ', rmb.year), '%d %M %Y'))
          AND i.assign_lead_1 = rmb.procurement_manager_id
        LEFT JOIN erpx_dev_masters.employee_details emp ON emp.employee_id = i.assign_lead_1
        WHERE 1
        ${month ? ' AND MONTH(grni.created_at) = ' + month : ''}
        ${year ? ' AND YEAR(grni.created_at) = ' + year : ''}
        GROUP BY i.assign_lead_1, grni.count, YEAR(grni.created_at), MONTH(grni.created_at), rmb.month, rmb.year, rmb.procurement_manager_id, emp.employee_name
        
        UNION
        
        SELECT 
          NULL AS assign_lead_1,
          rmb.count AS budgetCount,
          NULL AS grnBudgetMonth,
          NULL AS grnBudgetYear,
          0 AS grnQuantity,
          rmb.quantity AS budgetQuantity,
          rmb.count,
          MONTH(STR_TO_DATE(CONCAT('1 ', rmb.month, ' ', rmb.year), '%d %M %Y')) AS month,
          rmb.year,
          emp.employee_name AS employeeName,
          rmb.procurement_manager_id,
          NULL AS grn_item_id,
          NULL AS grn_id,
          NULL AS indent_id
        FROM 
          erpx_dev_masters.rm_budget rmb
        LEFT JOIN 
          erpx_dev_rm_procurement.grn_items grni 
          ON grni.count = rmb.count 
          AND YEAR(grni.created_at) = rmb.year 
          AND MONTH(grni.created_at) = MONTH(STR_TO_DATE(CONCAT('1 ', rmb.month, ' ', rmb.year), '%d %M %Y'))
        LEFT JOIN 
          erpx_dev_rm_procurement.indent i ON i.indent_id = grni.indent_id
        LEFT JOIN 
          erpx_dev_masters.employee_details emp ON emp.employee_id = rmb.procurement_manager_id
        WHERE 
          grni.count IS NULL
          AND rmb.year = 2024
        ${monthName ? ' AND rmb.month = "' + monthName + '"' : ''}
        ${year ? ' AND rmb.year = ' + year : ''}
        GROUP BY 
          rmb.procurement_manager_id, rmb.count, rmb.year, MONTH(STR_TO_DATE(CONCAT('1 ', rmb.month, ' ', rmb.year), '%d %M %Y')), emp.employee_name
        ORDER BY 
          budgetCount, grnBudgetMonth, grnBudgetYear
      `;
  
      const info = await manager.query(infoQuery);
      if (info.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved', info);
      } else {
        return new CommonResponse(false, 0, 'No data found');
      }
    } catch (err) {
      throw err;
    }
  }
  
  


  async getRmInvoiceReport(req?: RmInvoiceReportReq): Promise<CommonResponse> {
    try {
      console.log(req, "reqqqqqqqqqqqq");
  
      const manager = getManager();
  
      // 1. Main query
      let query = `
        SELECT grni.grn_item_id,
          rmi.count,
          rmi.batch_number AS batchNumber,
          SUM(rmi.quantity) AS totalQuantity,
          rmi.invoice_number AS invoiceNumber,
          DATE(rmi.invoice_date) AS invoiceDate,
          rmi.rm_invoice_id,
          rmi.grn_id,
          rmi.indent_id,
          rmi.plant_id,
          p.name as productName,
          MAX(CASE WHEN rmi.type = 'GOOD' THEN rmi.unit_price END) AS unitPrice,
          SUM(rmi.total_amount) AS totalAmount,
          grni.farmer,
          rmi.bill_to_type AS billToType,
          CASE 
              WHEN rmi.bill_to_type='Financier' THEN rmi.financier_name 
              ELSE su.name 
          END AS billTo,
          grni.ice_rate as iceRate,
          i.assign_lead_1,
          i.harvest_type as harvestType,
          CASE 
              WHEN d.name IS NULL THEN s.name 
              ELSE d.name 
          END AS farmerName,
          CASE 
              WHEN d.supplier_category IS NULL THEN s.supplier_category 
              ELSE d.supplier_category 
          END AS category,
          ed.employee_name AS supervisorName,
          grni.farmer_code,
          fm.address AS place,
          g.vehicle_number AS vehicleNumber
        FROM 
          ${appSettings.rm_procure_db}.rm_invoice rmi
        LEFT JOIN 
          ${appSettings.rm_procure_db}.grn_items grni ON grni.grn_item_id = rmi.grn_item_id
        LEFT JOIN 
          ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
        LEFT JOIN 
          ${appSettings.rm_procure_db}.grn g ON g.grn_id = rmi.grn_id
        LEFT JOIN 
          ${appSettings.masters_db}.suppliers s ON s.supplier_id = grni.farmer
        LEFT JOIN 
          ${appSettings.masters_db}.employee_details ed ON ed.employee_id = g.supervisor_id
        LEFT JOIN 
          ${appSettings.masters_db}.farms fm ON fm.farm_id = grni.farmer_code
        LEFT JOIN 
          erpx_dev_masters.suppliers d ON d.supplier_id = grni.broker
        LEFT JOIN 
          ${appSettings.masters_db}.suppliers su ON su.supplier_id = rmi.bill_to
          left join  ${appSettings.masters_db}.products p on p.product_id = grni.product
        WHERE 1 = 1 
      `;
  
      const parameters: any[] = [];
  
      // Filters
      if (req?.farmer) {
        query += ' AND grni.farmer = ?';
        parameters.push(req.farmer);
      }
      if (req?.batchNum) {
        query += ' AND rmi.batch_number = ?';
        parameters.push(req.batchNum);
      }
      if (req?.category) {
        query += ' AND s.supplier_category = ?';
        parameters.push(req.category);
      }
      if (req?.harvestType) {
        query += ' AND i.harvest_type = ?';
        parameters.push(req.harvestType);
      }
      if (req?.grnfromDate && req?.grnToDate) {
        const grnToDate = new Date(req.grnToDate);
        grnToDate.setHours(23, 59, 59, 999);
        query += ' AND rmi.invoice_date BETWEEN ? AND ?';
        parameters.push(req.grnfromDate);
        parameters.push(grnToDate.toISOString().slice(0, 19).replace('T', ' '));
      }
  
      query += `
        GROUP BY 
          rmi.count, rmi.batch_number
        ORDER BY 
          rmi.count, rmi.batch_number
      `;
  
const tdsQuery = `
SELECT 
  gi.grn_item_id,rmi.count, 
  rmi.invoice_number, 
  gi.taxable_amount 
FROM ${appSettings.rm_procure_db}.rm_invoice rmi
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi 
  ON gi.grn_item_id = rmi.grn_item_id
`;

const invoiceData = await manager.query(query, parameters);
const tdsRawData = await manager.query(tdsQuery);

const tdsMap = new Map<string, number>();
for (const row of tdsRawData) {
const key = `${row.invoice_number}|${row.count}|${row.grn_item_id}`;
const taxable = parseFloat(row.taxable_amount) || 0;
const tds = taxable * 0.001;

if (tdsMap.has(key)) {
  tdsMap.set(key, tdsMap.get(key)! + tds);
} else {
  tdsMap.set(key, tds);
}
}

const finalData = invoiceData.map((row: any) => {
const key = `${row.invoiceNumber}|${row.count}|${row.grn_item_id}`;
const tdsAmount = tdsMap.get(key) || 0;
const finalAMount = parseFloat(row.totalAmount) - tdsAmount;

return {
  ...row,
  tdsAmount,
  finalAMount,
};
});

  
      return finalData.length > 0
        ? new CommonResponse(true, 1, 'Data retrieved', finalData)
        : new CommonResponse(false, 0, 'No data found');
  
    } catch (err) {
      throw err;
    }
  }
  





async getBatchNumbers(): Promise<CommonResponse> {
  try {
    const manager = getManager();
    let query = ` SELECT rmi.batch_number
FROM `+ appSettings.rm_procure_db + `.rm_invoice rmi
group by rmi.batch_number
`
    const details = await manager.query(query);

    return new CommonResponse(true, 1, 'No data found', details)

  } catch (err) {
    throw err
  }

}


async getFarmers(): Promise<CommonResponse> {
  try {
    const manager = getManager();
    let query = ` SELECT  grni.farmer,s.name as farmerName
FROM `+ appSettings.rm_procure_db + `.grn_items grni
LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = grni.farmer
WHERE grni.farmer!="Null"
group by grni.farmer
`
    const details = await manager.query(query);

    return new CommonResponse(true, 1, 'No data found', details)

  } catch (err) {
    throw err
  }

}

async getCategorys(): Promise<CommonResponse> {
  try {
    const manager = getManager();
    let query = ` SELECT  grni.farmer,s.name AS farmerName,s.supplier_category AS category
FROM `+ appSettings.rm_procure_db + `.grn_items grni
LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = grni.farmer
 WHERE s.supplier_category!="NULL"
 GROUP BY s.supplier_category
`
    const details = await manager.query(query);

    return new CommonResponse(true, 1, 'No data found', details)

  } catch (err) {
    throw err
  }

}

async getHarvestType(): Promise<CommonResponse> {
  try {
    const manager = getManager();
    let query = ` SELECT i.indent_id,i.harvest_type AS harvestType
 FROM `+ appSettings.rm_procure_db + `.indent i
 GROUP BY i.harvest_type
`
    const details = await manager.query(query);

    return new CommonResponse(true, 1, 'No data found', details)

  } catch (err) {
    throw err
  }

}

async getAverageRateReport(req?: AverageRateRmReport): Promise<CommonResponse> {
  try {
    const manager = getManager();
    
    let infoQuery = `
      SELECT count, price, updated_at 
      FROM ${appSettings.rm_procure_db}.rm_rates 
      WHERE category = '${CompanyCategoryEnum.OWN}' 
      AND type = '${HarvestTypes.Live_Harvest}' 
      ORDER BY count`;

    const info = await manager.query(infoQuery);
    interface PriceInfoModel {
      countRange: string;
      price: number;
      minCount : number;
      maxCount : number;
    }

    let countRanges: PriceInfoModel[] = [];

    let prevCount: number;
    let prevPrice = 0;
    let countVal: string;
    let sameCounts: number[] = [];
    let colorVal: boolean;

    const countRangeMap = new Map<string, PriceInfoModel>();


    if(info){
      for(const priceRec of info){
        let minCount
        let maxCount
          if(prevPrice == priceRec.price){
              sameCounts.push(prevCount) 
              countVal = Math.min(...sameCounts)+'-'+priceRec.count  
              countRanges.splice(-1)
              colorVal = true
              minCount =  Math.min(...sameCounts)
              maxCount = priceRec.count
          }else{
              sameCounts = []
              countVal = priceRec.count   
              colorVal = false      
              minCount =  priceRec.count
              maxCount = priceRec.count                      
          }
          countRanges.push({countRange:countVal,price:priceRec.price,minCount : minCount,maxCount : maxCount})
          prevCount = priceRec.count
          prevPrice = priceRec.price
        
      }

  }

  for(const rec of countRanges){
    if (!countRangeMap.has(rec.countRange)) {
      countRangeMap.set(rec.countRange,{countRange:rec.countRange,price:rec.price,minCount : rec.minCount,maxCount : rec.maxCount});
    }
  }
   console.log(countRangeMap,"!!!!!!!!!!!!!!!11")

    let totalDataQuery = `
      SELECT rmi.count, SUM(rmi.quantity) as quantity, SUM(rmi.total_amount) AS totalAmount
      FROM ${appSettings.rm_procure_db}.rm_invoice rmi 
      WHERE rmi.rm_invoice_id > 0 `;

    if (req?.fromDate && req?.toDate) {
      totalDataQuery += ` AND DATE(rmi.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }

    totalDataQuery += ` GROUP BY rmi.count ORDER BY rmi.count`;

    const totalData = await manager.query(totalDataQuery);
    // const totalDataMap = new Map<number, any>();

    // for (const rec of totalData) {
    //   if (!totalDataMap.has(Number(rec.count))) {
    //     totalDataMap.set(Number(rec.count), rec);
    //   }
    // }


    let finalPriceInfo: any[] = [];
let othersTotalQuantity = 0;
let othersTotalAmount = 0;

for (const countData of totalData) {
  let found = false;

  for (const [_, range] of countRangeMap) {
    if (countData.count >= range.minCount && countData.count <= range.maxCount) {
      let existing = finalPriceInfo.find(item => item.count === range.countRange);
      
      if (existing) {
        existing.totalQuantity += Number(countData.quantity) ?? 0;
        existing.totalAmount += Number(countData.totalAmount) ?? 0;
      } else {
        finalPriceInfo.push({
          count: range.countRange,
          price: range.price,
          totalQuantity: Number(countData.quantity) ?? 0,
          totalAmount: Number(countData.totalAmount) ?? 0,
        });
      }

      found = true;
      break;
    }
  }

  if (!found) {
    othersTotalQuantity += Number(countData.quantity) ?? 0;
    othersTotalAmount += Number(countData.totalAmount) ?? 0;
  }
}

// If there are remaining counts, add them as "Others"
if (othersTotalQuantity > 0) {
  finalPriceInfo.push({
    count: "Others",
    price: 0, // No specific price
    totalQuantity: othersTotalQuantity,
    totalAmount: othersTotalAmount,
  });
}
console.log(finalPriceInfo,"finalPriceInfo")
if (finalPriceInfo.length > 0) {
  return new CommonResponse(true, 1, "Data retrieved", finalPriceInfo);
} else {
  return new CommonResponse(false, 0, "No data found");
}


    // for (const count of totalData) {
    //   let totalQuantity = 0;
    //   let totalAmount = 0;

    //   if(count.minCount )
      
      // if (count.minCount !== count.maxCount) {
      //   for (let i = count.minCount; i <= count.maxCount; i++) {
      //     const minCountInfo = totalData.get(i);
      //     totalQuantity += Number(minCountInfo?.quantity) ?? 0;
      //     totalAmount += Number(minCountInfo?.totalAmount) ?? 0;
      //   }
      // } else {
      //   const minCountInfo = totalData.get(count.minCount);
      //   totalQuantity = Number(minCountInfo?.quantity) ?? 0;
      //   totalAmount = Number(minCountInfo?.totalAmount) ?? 0;
      // }

      // if (totalQuantity > 0) {
      //   finalPriceInfo.push({
      //     count: count.countRange,
      //     price: count.price,
      //     totalQuantity,
      //     totalAmount,
      //   });
      // }
    // }

    if (finalPriceInfo.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved', finalPriceInfo);
    } else {
      return new CommonResponse(false, 0, 'No data found');
    }
  } catch (err) {
    throw err;
  }
}


// async getAverageRateReport(req?: AverageRateRmReport): Promise<CommonResponse> {
//   try {
//     const manager = getManager();
    
    // const countRangeQuery = `
    //   SELECT CONCAT(MIN(rr.count), '-', MAX(rr.count)) AS countRange, rr.price, MIN(rr.count) as minCount,MAX(rr.count) as maxCount
    //   FROM ${appSettings.rm_procure_db}.rm_rates rr
    //   WHERE rr.company="BMR" AND rr.type="LIVE HARVEST" AND count between 7 and 96
    //   GROUP BY rr.price`;
    
    // let infoQuery = `SELECT count,price,updated_at FROM `+appSettings.rm_procure_db+` .rm_rates WHERE category = '${CompanyCategoryEnum.OWN}' AND type = '${HarvestTypes.Live_Harvest}' AND count <= 100 ORDER BY count`

//     const countRanges = await manager.query(countRangeQuery);

  //   interface priceInfoModel{
  //     count:string,
  //     price:number,
  //     colorVar : boolean,
  //     uploadedDate : any
  // }
  // let priceInfo:priceInfoModel[] = []; 
  // let prevCount
  // let prevPrice = 0
  // let countVal
  // let sameCounts:number[] = []
  // let colorVal
  // if(info){
  //     for(const priceRec of info){
  //         if(prevPrice == priceRec.price){
  //             sameCounts.push(prevCount) 
  //             countVal = Math.min(...sameCounts)+'-'+priceRec.count  
  //             priceInfo.splice(-1)
  //             colorVal = true
  //         }else{
  //             sameCounts = []
  //             countVal = priceRec.count   
  //             colorVal = false                            
  //         }
  //         priceInfo.push({count:countVal,price:priceRec.price,colorVar:colorVal,uploadedDate: moment(priceRec.updated_at).format('YYYY-MM-DD')})
  //         prevCount = priceRec.count
  //         prevPrice = priceRec.price
  //     }
  //   const countRangeInfo = await this.enquiryService.getCountPricesInfo()
    
  //   let totalDataQuery = `
  //     SELECT rmi.count, SUM(rmi.quantity) as quantity, SUM(rmi.total_amount) AS totalAmount
  //     FROM ${appSettings.rm_procure_db}.rm_invoice rmi WHERE count between 7 and 96`;
    
  //   if (req.fromDate && req.toDate) {
  //     totalDataQuery += ` WHERE DATE(rmi.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
  //   }
  //   totalDataQuery += ` GROUP BY rmi.count`
  //   const totalData = await manager.query(totalDataQuery);

  //   const totalDataMap = new Map<number,any>()

  //   for(const rec of totalData){
  //     if(!totalDataMap.has(Number(rec.count))){
  //       totalDataMap.set(Number(rec.count),rec)
  //     }
  //   }

//     const priceInfo = [];
// console.log(totalDataMap,'totalDataMappppp')
//     for(const count of countRanges){
//       let totalQuantity = 0;
//       let totalAmount = 0;
//       console.log(count,'ccccccccccccccccccccccccccccccccc')
//       if(count.minCount != count.maxCount){
//         for(let i = count.minCount; i<= count.maxCount ; i++){
//           if(totalDataMap.get(Number(i)) != undefined ){
//             console.log(  totalDataMap.get(Number(i)),' totalDataMap.get(Number(count.minCount))')
//           }
//           const minCountinfo = totalDataMap.get(Number(i))
//           const minCountQty = minCountinfo != undefined ? minCountinfo.quantity : 0
//           const minCountAmount = minCountinfo != undefined ? minCountinfo.totalAmount : 0
//           totalQuantity +=  Number(minCountQty)
//           totalAmount += Number(minCountAmount)

//         }
//       }else{
//         const minCountinfo = totalDataMap.get(Number(count.minCount)) 
//       const minCountQty = minCountinfo != undefined ? minCountinfo.quantity : 0
//       const minCountAmount = minCountinfo != undefined ? minCountinfo.totalAmount : 0
//         totalQuantity = Number(minCountQty);
//         totalAmount = Number(minCountAmount);
//       }
//       if(totalQuantity > 0 ){
//         priceInfo.push({
//           count: count.countRange,
//           price: count.price,
//           totalQuantity,
//           totalAmount
//         });
//       }
//     }
    
    // for (const rangeItem of countRanges) {
    //   const [minCount, maxCount] = rangeItem.countRange.split('-').map(Number);
    //   let totalQuantity = 0;
    //   let totalAmount = 0;
      
    //   for (const dataItem of totalData) {
    //     const count = Number(dataItem.count);

    //     if (count >= minCount && count <= maxCount) {
    //       totalQuantity += Number(dataItem.quantity);
    //       totalAmount += Number(dataItem.totalAmount);
    //     }
    //   }
    //   priceInfo.push({
    //     count: rangeItem.countRange,
    //     price: rangeItem.price,
    //     totalQuantity,
    //     totalAmount
    //   });
    // }
    // console.log(priceInfo,"!!!!!!!!!!!!!!!!!!!!!")
//     if (priceInfo.length > 0) {
//       return new CommonResponse(true, 1, 'Data retrieved', priceInfo);
//     } else {
//       return new CommonResponse(false, 0, 'No data found');
//     }
//   } catch (err) {
//     throw err;
//   }
// }



// async getAverageRateReport(req?:AverageRateRmReport): Promise<CommonResponse> {
//   try {
//     const manager = getManager();
//     let query = `
//       SELECT  rmi.invoice_date,CONCAT(MIN(rmi.count), '-', MAX(rmi.count)) AS countRange,rr.price,SUM(rmi.quantity) AS totalQuantity,
//       SUM(rmi.total_amount) AS totalAmount
//       FROM ${appSettings.rm_procure_db}.rm_invoice rmi
//       LEFT JOIN ${appSettings.rm_procure_db}.rm_rates rr ON rr.count = rmi.count
//       WHERE rr.company="BMR" AND rr.type="LIVE HARVEST"`;
//     if (req.fromDate != undefined && req.toDate != undefined) {
//       query += ` AND DATE(rmi.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
//   }

//   query += `  GROUP BY rr.price
//       ORDER BY 
//         rmi.invoice_date, rmi.rm_invoice_id`;
//     console.log(query,"!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
//     const details = await manager.query(query);

//     if (details.length > 0) {
//       const priceInfo = [];
//       let currentPrice = null;
//       let prevCount = '';
//       let totalQuantity = 0;
//       let totalAmount=0;

//       for (let i = 0; i < details.length; i++) {
//         const item = details[i];
//         const price = item.price;
//         const countRange = item.countRange;
//         const quantity = item.totalQuantity;
//         const amount=item.totalAmount;
//         console.log(quantity,"AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA")

//         if (price !== currentPrice) {
//           // Push the previous data if it's not the first iteration
//           if (currentPrice !== null) {
//             priceInfo.push({
//               count: prevCount,
//               price: currentPrice,
//               totalQuantity: totalQuantity,
//               totalAmount:totalAmount,
//             });
//           }
//           currentPrice = price;
//           prevCount = countRange; // Initialize with current countRange
//           totalQuantity = quantity;
//           totalAmount=amount;
//         } else {
//           // If prices are the same, update prevCount to show the single value
//           prevCount = countRange;
//           totalQuantity += quantity;
//           totalAmount+=amount;
//         }
//         console.log(totalQuantity,"#########################################")

//         if (i === details.length - 1) {
//           // Push the last record
//           priceInfo.push({
//             count: prevCount,
//             price: currentPrice,
//             totalQuantity: totalQuantity,
//             totalAmount:totalAmount 
//           });
//         }
//       }
//       console.log(priceInfo,"******************************************8")

//       return new CommonResponse(true, 1, 'Data retrieved', priceInfo);
//     } else {
//       return new CommonResponse(false, 0, 'No data found');
//     }
//   } catch (err) {
//     throw err;
//   }
// }

  async getRmInvoiceInfo(req:InvoiceStatusReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let infoQry = `SELECT rm_invoice_id,ri.invoice_number as invoiceNumber,ri.invoice_date as invoiceDate,IF(ri.bill_to_type = 'Farmer' , s.name,ri.financier_name) AS financierName,g.grn_number as grnNumber,i.indent_code as indentNumber,i.supplier_type as supplierType,ri.bill_to_type as billToType,
      su.name AS supplierName,su.code AS supplierCode,ri.grn_id as grnId
      FROM ${appSettings.rm_procure_db} .rm_invoice ri
      LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = ri.grn_id
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = ri.indent_id
      LEFT JOIN ${appSettings.rm_procure_db} .indent_items ii ON ii.indent_id = ri.indent_id
      LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = ri.bill_to
      LEFT JOIN ${appSettings.masters_db} .suppliers su ON su.supplier_id = IF(i.supplier_type = 'Dealer' , ii.broker , ii.farmer)
      WHERE g.grn_id > 0 AND ri.inv_status ='${req.status}'`
      if(req.grnId){
        infoQry += ` AND ri.grn_id = ${req.grnId}`
    }
    if(req.indentId){
        infoQry += ` AND ri.indent_id = ${req.indentId}`
    }
    infoQry += ` GROUP BY invoice_number`
    const data = await manager.query(infoQry)
    if(data.length > 0){
      return new CommonResponse(true,1,'Data retreived',data)
    }else {
      return new CommonResponse(false,0,'No data found')
    }
    }catch(err){
      throw err
    }
  }

  async getRmInvoiceItemsInfo(req:GrnInvoiceNumberRequest):Promise<CommonResponse>{
    const manager = getManager()
    try{
      const invItemsInfoQry =  `SELECT ri.batch_number as batchNumber,gi.lot_number as lotNumber,ri.type,d.defect_name as defectName,ri.count,ri.quantity,gi.rm_rate as price,ri.unit_price as approvedPrice,ri.total_amount as totalAmount FROM ${appSettings.rm_procure_db} .rm_invoice ri
      LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_item_id = ri.grn_item_id
      LEFT JOIN ${appSettings.rm_procure_db} .grn_item_defects gid ON gid.grn_item__defects_id = ri.defect_id
      LEFT JOIN ${appSettings.masters_db} .defect d ON d.defect_id = gid.defect_id
      WHERE invoice_number = '${req.invoiceNumber}'`
      const invItemsInfo = await manager.query(invItemsInfoQry)
      if(invItemsInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',invItemsInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

async getProcurementEmployeeNames():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT emp.employee_id AS employeeId,CONCAT(emp.employee_name," ",emp.emp_last_name) AS fullName,emp.department_id,
de.dept_name
FROM erpx_dev_masters.employee_details emp
LEFT JOIN erpx_dev_masters.departments de ON de.dept_id=emp.department_id
WHERE de.dept_name="Procurement"
GROUP BY emp.employee_id`
console.log(query ,"queryyyyy")
const data=await manager.query(query)
if(data.length>0){
  return new CommonResponse(true,1,'Data Retrieved',data)
}else{
  return new CommonResponse(false,0,'No data Found')
}
}

async getAllGrnNUmbers():Promise<CommonResponse>{
  const manager=getManager()
  let query=`SELECT 
    i.indent_code AS grnIndentNumber,
    g.grn_number AS grnNumber,
    gi.grn_id AS id,
    gi.grn_item_id as grnItemId,
    g.indent_no AS indentId,
    i.indent_code AS indentNumber
FROM 
    ${appSettings.rm_procure_db}.grn_items gi
LEFT JOIN 
    ${appSettings.rm_procure_db}.grn g ON g.grn_id = gi.grn_id
LEFT JOIN 
    ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
WHERE 
    gi.test_result IS NULL
      group by i.indent_code `
console.log(query ,"queryyyyy")
const data=await manager.query(query)
if(data.length>0){
  return new CommonResponse(true,1,'Data Retrieved',data)
}else{
  return new CommonResponse(false,0,'No data Found')
}
}
 async getAllLotCodesForGrading():Promise<CommonResponse>{
  const manager = getManager()
  let query =` select  DISTINCT lot_number as lotNumber
from ${appSettings.production_db}.grade_inventory
where test_result IS NULL`

const data = await manager.query(query)
if(data.length>0){
  return new CommonResponse(true,1,'Data Retrieved',data)
}else{
  return new CommonResponse(false,0,'No data Found')
}
 }
// async getRmGrnFullDataForGrading(req: AntibioticsReq) {
  
  
//   const manager = getManager();
//   const page = req.page || 1;
//   const pageSize = req.pageSize || 20;
//   const offset = (page - 1) * pageSize;
  
//   req = req || {};
  
//     let dataQuery = `select gi.lot_number as lotNumber,gi.boxes as boxes,gi.grn_hon_count as count,gi.grn_hon_quantity as HONQuantity,ii.expected_qty as indentQuantity,gim.quantity AS grnQuantity,gi.antibiotics_test_status as antibioticsTestStatus, i.indent_id as indentId,
// 	g.grn_number as grnNumber,i.indent_code as indentNumber,i.supplier_type as supplierType,g.reweighment_bill_to as reweightBillTo,g.grn_date as grnDate,
// 	s.name as farmerName,su.name as dealerName,p.name as productName,g.grn_id as grnId,gim.grn_item_id as grnItemId,s.name as farmerName,g.reweighment_date as reweighmentDate ,gi.test_result AS isAntibioticsTestCompleted,gim.year
// 	from ${appSettings.production_db}.grade_inventory gi
//   	left join  ${appSettings.rm_procure_db}.grn_items gim  on gim.plant_lot_number = gi.lot_number AND gim.year=gi.year
// 	left join ${appSettings.rm_procure_db}.indent i on i.indent_id = gim.indent_id
// 	left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gim.grn_id
//   left join  ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id=gim.indent_item_id 
// 	left join  ${appSettings.masters_db}.products p on p.product_id = gim.product
// 	left join ${appSettings.masters_db}.suppliers su ON su.supplier_id = gim.broker
// 	left join ${appSettings.masters_db}.suppliers s on s.supplier_id = gim.farmer
// WHERE gi.test_result IS NULL AND gi.antibiotics_test_status = 'PENDING' 

//   `;


//   let countQuery = `
//     SELECT COUNT(*) as total
//     FROM (
//       SELECT gi.lot_number
//       FROM ${appSettings.production_db}.grade_inventory gi
//       LEFT JOIN ${appSettings.rm_procure_db}.grn_items gim ON gim.plant_lot_number = gi.lot_number AND gim.year = gi.year
//       LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = gim.indent_id
//       LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = gim.grn_id
//       LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id = gim.indent_item_id 
//       LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id = gim.product
//       LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gim.broker
//       LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gim.farmer
//       WHERE gi.test_result IS NULL AND gi.antibiotics_test_status = 'PENDING'
//   `;

//   if (req.fromDate && req.toDate) {
//     const dateFilter = ` AND g.grn_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
//     dataQuery += dateFilter;
//     countQuery += dateFilter;
//   } else {
//     const defaultDateFilter = ` AND g.grn_date >= '2025-03-15'`;
//     dataQuery += defaultDateFilter;
//     countQuery += defaultDateFilter;
//   }

//   countQuery += ` GROUP BY gi.lot_number) as subquery`;

//   dataQuery += ` GROUP BY gi.lot_number, gi.grn_hon_count`;
//   dataQuery += ` LIMIT ${pageSize} OFFSET ${offset}`;

//   try {
//     const [grnData, totalResult] = await Promise.all([
//       manager.query(dataQuery, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []),
//       manager.query(countQuery, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : [])
//     ]);

//     const total = totalResult[0]?.total || 0;

//     return new CommonResponse(
//       true, 
//       1001, 
//       'GRN data retrieved successfully', 
//       {
//         data: grnData,
//         pagination: {
//           page,
//           pageSize,
//           total
//         }
//       }
//     );
//   } catch (error) {
//     console.error("Database query error:", error);
//     return new CommonResponse(
//       false, 
//       1002, 
//       'Error retrieving GRN data', 
//       {
//         data: [],
//         pagination: {
//           page: 1,
//           pageSize: 20,
//           total: 0
//         }
//       }
//     );
//   }
// }

async getRmGrnFullDataForGrading (req:AntibioticsReq) {
  const manager = getManager();
  req = req || {};
  let query = `select gi.lot_number as lotNumber,gi.boxes as boxes,gi.grn_hon_count as count,gi.grn_hon_quantity as HONQuantity,ii.expected_qty as indentQuantity,gim.quantity AS grnQuantity,gi.antibiotics_test_status as antibioticsTestStatus, i.indent_id as indentId,
	g.grn_number as grnNumber,i.indent_code as indentNumber,i.supplier_type as supplierType,g.reweighment_bill_to as reweightBillTo,g.grn_date as grnDate,
	s.name as farmerName,su.name as dealerName,p.name as productName,g.grn_id as grnId,gim.grn_item_id as grnItemId,s.name as farmerName,g.reweighment_date as reweighmentDate ,gi.test_result AS isAntibioticsTestCompleted,gim.year
	from ${appSettings.production_db}.grade_inventory gi
  	left join  ${appSettings.rm_procure_db}.grn_items gim  on gim.plant_lot_number = gi.lot_number AND gim.year=gi.year
	left join ${appSettings.rm_procure_db}.indent i on i.indent_id = gim.indent_id
	left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gim.grn_id
  left join  ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id=gim.indent_item_id 
	left join  ${appSettings.masters_db}.products p on p.product_id = gim.product
	left join ${appSettings.masters_db}.suppliers su ON su.supplier_id = gim.broker
	left join ${appSettings.masters_db}.suppliers s on s.supplier_id = gim.farmer
WHERE gi.test_result IS NULL AND gi.antibiotics_test_status = 'PENDING' 

   `
   if (req.fromDate && req.toDate != undefined) {
    query += ` AND g.grn_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
}
 else {
  query += ` AND g.grn_date >= '2025-03-15'`;
}
query += ` GROUP BY gi.lot_number, gi.grn_hon_count`;
try {
  const grnData = await manager.query(query, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []);
  return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
} catch (error) {
  console.error("Database query error:", error);
  return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
}
}


// async getRmGrnFullDataForGrading (req:AntibioticsReq) {
//   console.log(req,'4444')
//   console.log("Received Request:", req);
// console.log("From Date:", req?.fromDate);
// console.log("To Date:", req?.toDate);
//   const manager = getManager();
//   req = req || {};
//   let query = `select gi.lot_number as lotNumber,gi.boxes as boxes,gi.grn_hon_count as count,gi.grn_hon_quantity as HONQuantity,ii.expected_qty as indentQuantity,gim.quantity AS grnQuantity,gi.antibiotics_test_status as antibioticsTestStatus, i.indent_id as indentId,
// 	lcd.grn_number as grnNumber,i.indent_code as indentNumber,i.supplier_type as supplierType,g.reweighment_bill_to as reweightBillTo,g.grn_date as grnDate,
// 	s.name as farmerName,su.name as dealerName,p.name as productName,g.grn_id as grnId,gim.grn_item_id as grnItemId,s.name as farmerName,g.reweighment_date as reweighmentDate ,gi.test_result AS isAntibioticsTestCompleted,gim.year
// 	from ${appSettings.production_db}.grade_inventory gi
// 	left join ${appSettings.production_db}.lot_code_data lcd on lcd .lot_number = gi.lot_number AND lcd.year=gi.year
// 	left join ${appSettings.rm_procure_db}.indent i on i.indent_id = lcd.indent_no
// 	left join ${appSettings.rm_procure_db}.grn g on g.grn_number = lcd.grn_number
// 	left join  ${appSettings.rm_procure_db}.grn_items gim  on gim.plant_lot_number = gi.lot_number AND gim.year=gi.year
//   left join  ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id=gim.indent_item_id 
// 	left join  ${appSettings.masters_db}.products p on p.product_id = gim.product
// 	left join ${appSettings.masters_db}.suppliers su ON su.supplier_id = gim.broker
// 	left join ${appSettings.masters_db}.suppliers s on s.supplier_id = gim.farmer
// WHERE gi.test_result IS NULL AND gi.antibiotics_test_status = 'PENDING' 

//    `
//    if (req.fromDate && req.toDate != undefined) {
//     query += ` AND g.grn_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
// }
//  else {
//   query += ` AND g.grn_date >= '2025-03-15'`;
// }
// query += ` GROUP BY gi.lot_number, gi.grn_hon_count`;
// try {
//   const grnData = await manager.query(query, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []);
//   return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
// } catch (error) {
//   console.error("Database query error:", error);
//   return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
// }
// }

 async getRmGrnDataByLotCode(req: LotNoReq) {
  const manager = getManager();

  const query = `select gi.lot_number as lotNumber,gi.boxes as boxes,gi.grn_hon_count as count,gi.grn_hon_quantity as quantity,
	lcd.grn_number as grnNumber,i.indent_code as indentNumber,i.supplier_type as supplierType,g.reweighment_bill_to as reweightBillTo,g.grn_date as grnDate,
	f.name as farmName,p.name as productName,g.grn_id as grnId,gis.grn_item_id as grnItemId,s.name as farmerName,g.reweighment_date as reweighmentDate
	from ${appSettings.production_db}.grade_inventory gi
	left join ${appSettings.production_db}.lot_code_data lcd on lcd .lot_number = gi.lot_number
	left join ${appSettings.rm_procure_db}.indent i on i.indent_id = lcd.indent_no
	left join ${appSettings.rm_procure_db}.grn g on g.grn_number = lcd.grn_number
        left join  ${appSettings.rm_procure_db}.grn_items gis on gis.grn_id = g.grn_id
	left join  ${appSettings.rm_procure_db}.grn_items gim  on gim.plant_lot_number = gi.lot_number
	left join  ${appSettings.masters_db}.products p on p.product_id = gim.product
	left join ${appSettings.masters_db}.farms f on f.farm_id = gim.farmer_code
	left join ${appSettings.masters_db}.suppliers s on s.supplier_id = gim.farmer
where  gi.lot_number = '${req.lotNumber}'
group by gis.grn_item_id`
  const result = await manager.query(query);
  return new CommonResponse(true, 1001, 'GRN data retrieved successfully', result);
}

  async getAddonCountsInfo(req:RmInvoiceReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      const newArray = req.batchNumber.map(item => '"'+item+'"');

      const getQry = `SELECT GROUP_CONCAT(plant_lot_number) as plantLotNumber FROM ${appSettings.rm_procure_db} .grn_items WHERE addon_count = 1 AND plant_lot_number IN (${newArray}) GROUP BY addon_count`
      const info = await manager.query(getQry)

      if(info.length > 0){
        return new CommonResponse(true,1,'Data retrieved',info)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async updateRMRatesAgainstIndentDate():Promise<CommonResponse>{
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();
    try{
      let saveFlag = new Set<boolean>()
      await transManager.startTransaction()
      const getGrnInfoQry = `SELECT gi.grn_item_id,gi.indent_id,i.indent_date,i.harvest_type,gi.count,gi.reweighment_count
      FROM ${appSettings.rm_procure_db} .grn_items gi 
      LEFT JOIN ${appSettings.rm_procure_db} .indent i on i.indent_id = gi.indent_id`
      const grnInfo = await transManager.query(getGrnInfoQry)

      if(grnInfo.length > 0){
        for(const rec of grnInfo){
          const count = rec.harvest_type == HarvestTypes.Live_Harvest ? rec.count : rec.reweighment_count
          const req = new RmRatesInfoReq(rec.indent_id,rec.harvest_type,CompanyCategoryEnum.OWN,count,rec.indent_date)
          const getRmRateInfo = await this.rmCountPriceListService.getRmRatesAgainstUploadedDate(req)
          if(getRmRateInfo.status){
            const updatePrice = await transManager.manager.getRepository(GrnItems).update({grnItemId:rec.grn_item_id},{rmRate:getRmRateInfo.data[0].price,price:() => `ice_rate + ${getRmRateInfo.data[0].price}`})
            if(updatePrice.affected){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
              await transManager.rollbackTransaction()
              await transManager.release()
              return new CommonResponse(false,0,'Something went wrong in updating price in grn items')
            }
          }
        }
        if(!(saveFlag.has(false))){
          await transManager.commitTransaction()
              await transManager.release()
              return new CommonResponse(true,1,'Successfull')
        }else{
          await transManager.rollbackTransaction()
          await transManager.release()
          return new CommonResponse(false,0,'Something went wrong')
        }
      }else{
        await transManager.rollbackTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      await transManager.rollbackTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'Something went wrong')
    }
  }

  async getTotalRMPayablesDashboard(req?:PayablesDashboardReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry = `SELECT SUM(total_amount),SUM( (total_amount)-  (CASE WHEN inv.type= 'Good'THEN (gi.taxable_amount*0.001) ELSE 0 END)) AS amount,
 SUM(inv.quantity) AS invquantity,invoice_date AS invoiceDate,
   SUM(CASE WHEN inv.type= 'Good'THEN (gi.taxable_amount*0.001) ELSE 0 END) AS taxableAmount,
    SUM(CASE WHEN inv.type = 'DEFECT' THEN inv.quantity ELSE 0 END) 
  AS defect_quantity,
   SUM(CASE WHEN inv.type= 'Good' THEN inv.quantity ELSE 0 END) AS goodQuantity,
   (SUM(CASE WHEN inv.type= 'Good' THEN inv.quantity ELSE 0 END)+
   SUM(CASE WHEN inv.type = 'DEFECT' THEN inv.quantity ELSE 0 END)) AS quantity,uc.company_id,uc.company
        FROM rm_invoice inv
       LEFT JOIN grn_items gi ON gi.grn_item_id= inv.grn_item_id  AND inv.type!='DEFECT'
       LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=plant_id
       LEFT JOIN ${appSettings.masters_db}.unitcodes ucc on ucc.company=reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'`

      if(req.fromDate!=null && req.toDate!=null){
        getQry+=` WHERE DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      }
      if(req.unitId!== undefined && req.unitId != null){
        getQry += ` AND plant_id = ${req.unitId}`
      }
      if(req.supplierId!== undefined && req.supplierId != null){
        getQry += ` AND (farmer = ${req.supplierId} OR broker = ${req.supplierId})`
      }
      if(req.company!== undefined && req.company != null){
        getQry += ` AND ucc.company = '${req.company}'`
      }
      console.log(getQry,'getQry')
      const info = await manager.query(getQry)
      console.log(info,'infooooooooooooooooo')
      if(info.length > 0){
        return new CommonResponse(true,1,'Data retrieved',info)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }
    catch(err){
      throw err
    }
  }
  
  async getInvoiceAmountAgainstVendor(req:PaybleComponentReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getInvAmountQry = `SELECT s.name as farmer,SUM(total_amount - (taxable_amount * 0.001)) AS amount,s.supplier_id FROM ${appSettings.rm_procure_db} .rm_invoice inv
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = inv.indent_id
      LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.indent_id = inv.indent_id
      LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = IF(i.supplier_type = 'Dealer',gi.broker ,gi.farmer)
      LEFT JOIN ${appSettings.masters_db} .unitcodes u ON u.unit_code_id = inv.plant_id
     LEFT JOIN ${appSettings.masters_db}.unitcodes ucc on ucc.company=reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'

      WHERE inv.rm_invoice_id > 0 and inv.inv_status != '${InvoiceStatusEnum.UNDER_APPROVAL}' 
      `
      if(req.fromDate != undefined){
        getInvAmountQry += ` AND DATE(inv.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      }
      if(req.vendorId != undefined){
        getInvAmountQry += ` AND s.supplier_id = ${req.vendorId}`
      }
      if(req.type != undefined){

      }
      if(req.unit != undefined){
        getInvAmountQry += ` AND inv.plant_id = ${req.unit}`
      }
      if(req.division != undefined){
        getInvAmountQry += ` AND ucc.company = '${req.division}'`
      }
      getInvAmountQry += ` GROUP BY IF(i.supplier_type = 'Dealer',gi.broker ,gi.farmer)
      ORDER BY SUM(total_amount) DESC
      LIMIT 10`
      const invAmountInfo = await manager.query(getInvAmountQry)

      if(invAmountInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved successfully',invAmountInfo)
      }else{
        return new CommonResponse(false,0,'No data found',[])
      }
    }catch(err){
      throw err
    }
  }

    async getOverdueInvoiceAmountAgainstVendor(req:PaybleComponentReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      // let getInvAmountQry = `SELECT s.name as farmer,SUM(invTotal.amount) AS amount FROM 
      // (SELECT s.supplier_id,inv.invoice_number,s.name,SUM(total_amount) - payment AS amount FROM ${appSettings.rm_procure_db} .rm_invoice inv
      // LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = inv.indent_id
      // LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.indent_id = inv.indent_id
      // LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = IF(i.supplier_type = 'Dealer',gi.broker ,gi.farmer)
      // WHERE inv.rm_invoice_id > 0 
      // `
      // if(req.fromDate != undefined){
      //   getInvAmountQry += ` AND DATE(inv.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      // }
      // if(req.vendorId != undefined){
      //   getInvAmountQry += ` AND s.supplier_id = ${req.vendorId}`
      // }
      // if(req.type != undefined){

      // }
      // if(req.division != undefined){
      //   getInvAmountQry += ` AND inv.plant_id = ${req.division}`
      // }
      // getInvAmountQry += `  GROUP BY inv.invoice_number ) AS invTotal
      // JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = invTotal.supplier_id
      // GROUP BY 
      //     s.name
      // ORDER BY 
      //     amount DESC
      // LIMIT 10`
      let getInvAmountQry  = ` SELECT IF(i.supplier_type = 'Dealer', ii.broker, ii.farmer) AS supplier_id,SUM(inv.total_amount - (taxable_amount * 0.001)) AS total_amount
      FROM ${appSettings.rm_procure_db} .rm_invoice inv
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = inv.indent_id
      LEFT JOIN ${appSettings.rm_procure_db} .grn_items ii ON ii.indent_id = inv.indent_id
      LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = IF(i.supplier_type = 'Dealer',ii.broker ,ii.farmer)
      LEFT JOIN ${appSettings.masters_db} .unitcodes u ON u.unit_code_id = inv.plant_id
      LEFT JOIN ${appSettings.masters_db}.unitcodes ucc on ucc.company=reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'
      WHERE inv.rm_invoice_id > 0 and inv.inv_status != '${InvoiceStatusEnum.UNDER_APPROVAL}' `
      if(req.fromDate != undefined){
        getInvAmountQry += ` AND DATE(inv.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      }
      if(req.vendorId != undefined){
        getInvAmountQry += ` AND s.supplier_id = ${req.vendorId}`
      }
      if(req.type != undefined){

      }
      if(req.unit != undefined){
        getInvAmountQry += ` AND inv.plant_id = ${req.unit}`
      }
      if(req.division != undefined){
        getInvAmountQry += ` AND ucc.company = '${req.division}'`
      }
      getInvAmountQry += ` GROUP BY supplier_id`

      let invoiceNumSubQry = `SELECT invoice_number FROM ${appSettings.rm_procure_db} .rm_invoice  inv
      LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = inv.indent_id
      LEFT JOIN ${appSettings.rm_procure_db} .grn_items ii ON ii.indent_id = inv.indent_id
      LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = IF(i.supplier_type = 'Dealer',ii.broker ,ii.farmer)
      LEFT JOIN ${appSettings.masters_db}.unitcodes ucc on ucc.company=reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'
      WHERE rm_invoice_id > 0 `
       if(req.fromDate != undefined){
          invoiceNumSubQry += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      }
       if(req.vendorId != undefined){
        invoiceNumSubQry += ` AND s.supplier_id = ${req.vendorId}`
      }
      if(req.unit != undefined){
        invoiceNumSubQry += ` AND inv.plant_id = ${req.unit}`
      }
      if(req.division != undefined){
        invoiceNumSubQry += ` AND ucc.company = '${req.division}'`
      }

      let paymentInfoQry = ` SELECT p.vendor_id AS supplier_id,SUM(p.payment) AS total_payment
      FROM ${appSettings.finance_db} .payables p
      WHERE p.invoice_type = 'RM' AND p.invoice_number IN (${invoiceNumSubQry})
      `
      if(req.fromDate != undefined){
          paymentInfoQry += ` AND DATE(p.received_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      }
      paymentInfoQry += `GROUP BY p.vendor_id`
      let getInvOverdueAmountQry = `SELECT  s.supplier_id,s.name AS farmer, COALESCE(a.total_amount, 0) AS invAmount,COALESCE(p.total_payment, 0) AS payment,COALESCE(a.total_amount, 0) - COALESCE(p.total_payment, 0) AS amount
        FROM ${appSettings.masters_db} .suppliers s
        LEFT JOIN (${getInvAmountQry}) a ON a.supplier_id = s.supplier_id
        LEFT JOIN (${paymentInfoQry}) p ON p.supplier_id = s.supplier_id
        WHERE a.total_amount IS NOT NULL 
        ORDER BY  COALESCE(a.total_amount, 0) - COALESCE(p.total_payment, 0) DESC
        LIMIT 10`
      const invOverdueAmountInfo = await manager.query(getInvOverdueAmountQry)

      if(invOverdueAmountInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved successfully',invOverdueAmountInfo)
      }else{
        return new CommonResponse(false,0,'No data found',[])
      }
    }catch(err){
      throw err
    }
  }


async generateTaxableAmountUpdateScript(req:TdsApplicableReq): Promise<CommonResponse> {
  const manager = getManager();
  let query = `
    SELECT ri.grn_item_id, invoice_date, SUM(total_amount) AS total_amount,
      bill_to_type, bill_to, farmer, broker,
      IF(bill_to_type = "Farmer", bill_to, IF(farmer IS NOT NULL AND farmer != '', farmer, broker)) AS supplier,
      YEAR, g.plant_id, ri.rm_invoice_id
    FROM rm_invoice ri
    LEFT JOIN grn_items gi ON gi.grn_item_id = ri.grn_item_id
    LEFT JOIN grn g ON g.grn_id = ri.grn_id
    WHERE YEAR = ${req.year}
    GROUP BY ri.grn_item_id
    ORDER BY invoice_date
  `;

  const data = await manager.query(query);
  if (!data || data.length === 0) {
    return new CommonResponse(false, 0, "No data found", []);
  }

  const tracker = new Map<string, { total: number; tdsStarted: boolean }>();

  for (const record of data) {
    const {
      grn_item_id,
      supplier,
      plant_id,
      total_amount
    } = record;

    const key = `${supplier}_${plant_id}`;
    let tds_applicable = 0;
    let taxable_amount = 0.00;

    let current = tracker.get(key);
    let prevTotal = current?.total || 0;
    let tdsStarted = current?.tdsStarted || false;
    const newTotal = prevTotal + Number(total_amount);

    if (!tdsStarted) {
      if (newTotal > 5000000) {
        tds_applicable = 1;
        taxable_amount = newTotal - 5000000;
        if (taxable_amount > total_amount) {
          taxable_amount = total_amount;
        }
        tracker.set(key, { total: newTotal, tdsStarted: true });
      } else {
        tds_applicable = 0;
        taxable_amount = 0.00;
        tracker.set(key, { total: newTotal, tdsStarted: false });
      }
    } else {
      tds_applicable = 1;
      taxable_amount = Number(total_amount);
      tracker.set(key, { total: newTotal, tdsStarted: true });
    }

    await manager.query(`
      UPDATE grn_items 
      SET tds_applicable = ?, taxable_amount = ? 
      WHERE grn_item_id = ?
    `, [tds_applicable, taxable_amount, grn_item_id]);
  }

  return new CommonResponse(true, 1, "GRN items updated successfully", []);
}

async getInwardReport(req?:InwardFilterReq): Promise<CommonResponse> {
  const manager = getManager();
  let query = `
    SELECT i.indent_id AS inwardId,i.indent_code AS inwardCode,i.indent_date AS inwardDate,i.indent_status,
i.rm_inward_type AS inwardType,ii.farmer,ii.product,ii.expected_qty AS inwardQty,ii.quality,ii.package_type,ii.gross_weight
AS grossWeight,gi.price,gi.bale_qty AS baleQty,gi.quality,gi.reporting_type as reportingType,g.voucher_number AS voucherNo,
g.grn_date AS voucharDate,
(ii.expected_qty*gi.price)AS inwardAmount,(ii.expected_qty-gi.bale_qty) AS remainingQty,s.name as supplierName,p.name as productName
FROM indent i
LEFT JOIN grn g ON g.indent_no=i.indent_id
LEFT JOIN indent_items ii ON ii.indent_id=i.indent_id
LEFT JOIN grn_items gi ON gi.indent_item_id=ii.indent_item_id
LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=ii.farmer
LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=ii.product

WHERE 1=1
    `
    if(req.fromDate && req.toDate){
      query += ` AND DATE(i.indent_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
    }
    if(req.inwardType){
      query += ` AND i.rm_inward_type = '${req.inwardType}'`
    }
    if(req.supplierId){
      query += ` AND ii.farmer = ${req.supplierId}`
    }
    if(req.productId){  
      query += ` AND ii.product = ${req.productId}`
    }
    if(req.inwardId){
      query += ` AND i.indent_id = ${req.inwardId}`
    }
    if(req.voucherNo){
      query += ` AND g.voucher_number = '${req.voucherNo}'`
    }
      query += ` ORDER BY i.indent_id DESC`
    const data = await manager.query(query);
    if (data.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved successfully', data);
    } else {
      return new CommonResponse(false, 0, 'No data found', []);
    }
  }

async getInwardNo(): Promise<CommonResponse> {
  const manager = getManager();
  const query = `SELECT indent_id as inwardId,indent_code AS inwardNo FROM indent ORDER BY indent_id DESC `;
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async getInwardType(): Promise<CommonResponse> {
  const manager = getManager();
  const query = `SELECT rm_inward_type AS inwardType FROM indent
WHERE rm_inward_type IS NOT NULL
GROUP BY rm_inward_type `;
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async getInwardFarmers(): Promise<CommonResponse> {
  const manager = getManager();
  const query = `SELECT farmer as supplierId,name FROM indent_items
LEFT JOIN ${appSettings.masters_db}.suppliers ON supplier_id=farmer
GROUP BY farmer`;
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async getInwardProducts(): Promise<CommonResponse> {
  const manager = getManager();
  const query = `
SELECT product as productId,name AS productName FROM indent_items 
LEFT JOIN ${appSettings.masters_db}.products ON product_id=product
GROUP BY product`;
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async getInwardVouchers(): Promise<CommonResponse> {
  const manager = getManager();
  const query = `
SELECT voucher_number as voucherNo FROM grn
WHERE voucher_number IS NOT NULL
GROUP BY voucher_number`;
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async getVendorsForInvoice(): Promise<CommonResponse> {
  const manager = getManager();
  const query = `
SELECT g.grn_id,gi.farmer,s.name AS vendorName FROM grn g
LEFT JOIN grn_items gi ON gi.grn_id=g.grn_id
LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=gi.farmer
WHERE g.is_po_created=0
GROUP BY gi.farmer`;
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async getVouchersAgainstFarmerForFinance(req?:VoucherVendorReq): Promise<CommonResponse> {
  const manager = getManager();
  let query = `
SELECT g.grn_id,g.voucher_number AS voucherNo,SUM(gi.quantity) AS quantity,SUM(gi.quantity*gi.price) AS amount,
s.name AS vendorName,gi.farmer FROM grn g
LEFT JOIN grn_items gi ON gi.grn_id=g.grn_id
LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=gi.farmer
WHERE g.is_po_created=0`;
if(req?.vendorId){
  query += ` AND gi.farmer = ${req.vendorId}`;
}
query += ` GROUP BY g.voucher_number,gi.farmer`
  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}



async getInvoiceDetails(req?: InvoiceNumReq): Promise<CommonResponse> {
  const manager = getManager();

  let invoiceQuery = `
    SELECT
      g.invoice_number AS invNum,
      DATE_FORMAT(g.invoice_date, '%d-%m-%Y') AS invDate,
      SUM(gi.quantity) AS quantity,
      SUM(gi.quantity * gi.price) AS amount,
      s.name AS farmerName
    FROM ${appSettings.rm_procure_db}.grn g
    LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi
      ON gi.grn_id = g.grn_id
      LEFT JOIN ${appSettings.masters_db}.suppliers s
      ON s.supplier_id = gi.farmer
    WHERE g.invoice_number IS NOT NULL
  `;

  let itemQuery = `
    SELECT
      g.invoice_number AS invNum,
      g.grn_id AS grnId,
      g.voucher_number AS voucherNo,
      gi.farmer AS farmerId,
      s.name AS farmerName,
      gi.quantity,
      gi.price,
      (gi.quantity * gi.price) AS amount
    FROM ${appSettings.rm_procure_db}.grn g
    LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi
      ON gi.grn_id = g.grn_id
    LEFT JOIN ${appSettings.masters_db}.suppliers s
      ON s.supplier_id = gi.farmer
    WHERE g.invoice_number IS NOT NULL
  `;

  if (req?.invNo) {
    invoiceQuery += ` AND g.invoice_number='${req.invNo}'`;
    itemQuery += ` AND g.invoice_number='${req.invNo}'`;
  }

  if (req?.fromDate && req?.toDate) {
    invoiceQuery += ` AND g.invoice_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
    itemQuery += ` AND g.invoice_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
  }

  invoiceQuery += `
    GROUP BY
      g.invoice_number,
      g.invoice_date
    ORDER BY g.invoice_date DESC
  `;

  itemQuery += `
    ORDER BY g.invoice_number, g.voucher_number
  `;

  const invoices = await manager.query(invoiceQuery);
  const items = await manager.query(itemQuery);

  invoices.forEach((invoice: any) => {
    invoice.items = items.filter(
      (item: any) => item.invNum === invoice.invNum
    );
  });

  if (invoices.length > 0) {
    return new CommonResponse(
      true,
      1,
      'Data retrieved successfully',
      invoices
    );
  }

  return new CommonResponse(false, 0, 'No data found', null);
}


async getAllInvoiceNumbers(): Promise<CommonResponse> {
  const manager = getManager();
  let query = `SELECT DISTINCT g.invoice_number as invNum
  FROM ${appSettings.rm_procure_db}.grn g

  WHERE g.invoice_number IS NOT NULL `

  const data = await manager.query(query);
  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', null);
  }
}

async createInvoiceAgainstVoucher(req: CreateInvoiceForVoucher): Promise<CommonResponse> {
    const manager = getManager();

    try {

        if (!req.grnIds || req.grnIds.length === 0) {
            return new CommonResponse(false, 0, 'Please select at least one voucher');
        }
      let today = moment(req.invoiceDate);
        let CurrentYear = today.year();
        let CurrentMonth = Number(today.format('MM'));
        let finToDate = 0;
        let finFromDate = 0;
        let refNum;

        if (CurrentMonth < 4) {
                finFromDate = (CurrentYear - 1);
                finToDate = (CurrentYear);
            } else {
                finFromDate = (CurrentYear);
                finToDate = (CurrentYear + 1);
            }

        const financialYear= (finFromDate.toString().substr(-2)) +'-'+ (finToDate.toString().substr(-2))

        let vendorCode = '';
        const vendorQuery=`SELECT code,supplier_id FROM ${appSettings.masters_db}.suppliers WHERE supplier_id = ${req.vendorId}`
        const vendorData = await manager.query(vendorQuery);
        if (vendorData.length > 0) {
            vendorCode = vendorData[0].code;
        } else {
            return new CommonResponse(false, 0, 'Vendor code not found');
        }

           const query = `SELECT MAX(inv_ref_no) AS refNumber FROM ${appSettings.rm_procure_db}.grn g WHERE g.invoice_number LIKE '${vendorCode}-%'
          AND g.financial_year = '${financialYear}'`;

          const refinfo = await manager.query(query);
            refNum = refinfo[0]?.refNumber? Number(refinfo[0].refNumber) + 1: 1;

          const invNum =`${vendorCode}-${refNum.toString().padStart(3, '0')}/${financialYear}`;
          console.log('Generated Invoice Number:', invNum);

        await manager.transaction(async transaction => {

            await transaction
                .createQueryBuilder()
                .update(Grn)
                .set({
                    isPoCreated: true,
                    invoiceNo: invNum,
                    invoiceDate: req.invoiceDate,
                    invRefNo: refNum,
                    financialYear: financialYear
                })
                .where("grn_id IN (:...ids)", {
                    ids: req.grnIds
                })
                .execute();

        });

        return new CommonResponse(
            true,
            1,
            'Invoice created successfully'
        );

    } catch (error) {
        console.log(error);
        return new CommonResponse(
            false,
            0,
            'Failed to create invoice',
            error
        );
    }
}

    async getLedgerCreateData(req?:VoucherReq):Promise<CommonResponse>{
      let manager=getManager()
      let payableQuery=`SELECT p.invoice_number,MAX(p.received_date) AS received_date,p.amount,p.final_amount,
        SUM(COALESCE(p.payment, 0)) AS payment,p.invoice_date,'PAID' AS STATUS,p.vendor_id,s.name AS vendor,sum(p.buyer_short_payment) as buyer_short_payment,
        sum(p.bank_charges) as bank_charges
        FROM ${appSettings.finance_db}.payables p
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=p.vendor_id
        WHERE invoice_type='RM' AND rm_type='DOMESTIC'`

        if(req?.vendorId){
           payableQuery += ` AND p.vendor_id=${req.vendorId}`
        }

        payableQuery+= ` GROUP BY p.invoice_number,p.vendor_id
        HAVING SUM(CASE WHEN p.status = 'PAID' THEN 1  ELSE 0 END ) > 0`

        const payableData=await manager.query(payableQuery)

        if (!payableData || payableData.length === 0) {
        return new CommonResponse( true, 1, 'No Data Found', []);
        }

        const invoiceNumbers = payableData.map((item: any) => item.invoice_number).filter((invoice_number: string) => !!invoice_number);

      if (invoiceNumbers.length === 0) {
          return new CommonResponse(true,1,'Data Retrieved',payableData.map((item: any) => ({...item,voucherData: []})));
      }

     const placeholders = invoiceNumbers .map(() => '?') .join(',');
console.log(placeholders,"Placeholderssss")
      let voucherQuery=`SELECT p.invoice_number AS invoiceNo,g.voucher_number as voucherNo FROM ${appSettings.finance_db}.payables p
      LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.invoice_number=p.invoice_number
        WHERE invoice_type='RM' AND rm_type='DOMESTIC' AND g.invoice_number IN (${placeholders})`

        if(req?.vendorId){
           voucherQuery += ` AND p.vendor_id=${req.vendorId}`
        }

        voucherQuery+= ` GROUP BY voucher_number,p.invoice_number`
    const voucherData=await manager.query(voucherQuery,invoiceNumbers)
            console.log(voucherQuery,"voucherQuery")

    const voucherMap = new Map<string, any[]>();

    for (const voucher of voucherData) {

        const invoiceNumber = voucher.invoiceNumber;

        if (!voucherMap.has(invoiceNumber)) {
            voucherMap.set(invoiceNumber, []);
        }

        voucherMap.get(invoiceNumber)!.push({
          voucher: voucher.voucherNo
        });
    }
const result = payableData.map((item: any) => {

        const vouchers =voucherMap.get(item.invoiceNumber) || [];

        return {
            invoiceNumber: item.invoice_number,
            invoiceDate: item.invoice_date,
            vendorId: item.vendorId,
            vendor: item.vendor,
            amount: item.amount,
            finalAmount: item.final_amount,
            payment: Number(item.payment || 0) + Number(item.buyer_short_payment || 0) + Number(item.bank_charges || 0),
            paymentDate: item.received_date,
            voucherData: vouchers
        };
    });
    console.log('✅ Final Ledger Create Data:',JSON.stringify(result, null, 2) );
        return new CommonResponse(true,1,'Data Retrieved',result);
    }

    async getDomesticPaidVendors():Promise<CommonResponse>{
      const manager=getManager()
      let query=`   SELECT p.vendor_id as vendorId,s.name AS vendor FROM ${appSettings.finance_db}.payables p
   LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=p.vendor_id
   WHERE invoice_type='RM' AND rm_type='DOMESTIC'
   GROUP BY p.vendor_id
   HAVING SUM(CASE WHEN p.status = 'PAID' THEN 1  ELSE 0 END ) > 0`
       const data=await manager.query(query)
    if(data?.length>0){
     return new CommonResponse(true,1,'Data Retrieved',data);

    }else{
       return new CommonResponse(false,0,'No Data found',[]);
    }
    }

  
}






